var _g, _path, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _path2, _ellipse6, _path3, _ellipse7, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSoccer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    transform: "scale(.7)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.26,142s0-.18,0-.51,0-.83,0-1.47c0-1.29,0-3.18,0-5.62,0-4.89,0-12,0-20.73,0-17.51,0-41.8.07-68.91l-.16.15h6.36l-.16-.15c.05,44.6.09,82.5.11,96.43l0,0-4.75.63-1.19.17-.41.06.39,0,1.19-.14,4.78-.58h0v-.05c0-13.93,0-51.83.1-96.43v-.16H95.11v.16c0,27.16,0,51.49.07,69,0,8.74,0,15.8,0,20.68,0,2.42,0,4.3,0,5.59,0,.63,0,1.11,0,1.44S95.26,142,95.26,142Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.18,141.69s0-.18,0-.51,0-.82,0-1.46c0-1.29,0-3.18,0-5.61,0-4.87,0-11.92.05-20.66,0-17.46,0-41.68.06-68.72l-.15.15h6.15l-.15-.15c0,45,.08,83.25.1,97l0-.06-4.61,0-1.15,0h1.12l4.64,0h0v-.05c0-13.71.06-52,.11-97v-.16H60v.16c0,27.09,0,51.34.07,68.84,0,8.72,0,15.75,0,20.62,0,2.42,0,4.29,0,5.57,0,.63,0,1.11,0,1.44S60.18,141.69,60.18,141.69Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.92,83.4c0,.08,16.71.15,37.33.15s37.33-.07,37.33-.15-16.71-.16-37.33-.16S43.92,83.31,43.92,83.4Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.92,71.73c0,.09,16.71.16,37.33.16s37.33-.07,37.33-.16-16.71-.15-37.33-.15S43.92,71.65,43.92,71.73Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.92,60.07c0,.09,16.71.16,37.33.16s37.33-.07,37.33-.16-16.71-.15-37.33-.15S43.92,60,43.92,60.07Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.92,48.41c0,.09,16.71.16,37.33.16s37.33-.07,37.33-.16-16.71-.15-37.33-.15S43.92,48.33,43.92,48.41Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.92,84a4.86,4.86,0,1,0,4.86-4.86A4.87,4.87,0,0,0,112.92,84Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.63,84a5.16,5.16,0,1,1,5.15,5.16A5.16,5.16,0,0,1,112.63,84Zm.59,0a4.57,4.57,0,1,0,4.56-4.56A4.57,4.57,0,0,0,113.22,84Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 105.44,
    cy: 84.02,
    r: 4.86,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.28,84a5.16,5.16,0,1,1,5.16,5.16A5.17,5.17,0,0,1,100.28,84Zm.59,0a4.57,4.57,0,1,0,4.57-4.56A4.57,4.57,0,0,0,100.87,84Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.23,84a4.86,4.86,0,1,0,4.86-4.86A4.86,4.86,0,0,0,88.23,84Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.93,84a5.16,5.16,0,1,1,5.16,5.16A5.17,5.17,0,0,1,87.93,84Zm.59,0a4.57,4.57,0,1,0,4.57-4.56A4.57,4.57,0,0,0,88.52,84Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80.74,
    cy: 84.02,
    r: 4.86,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.58,84a5.16,5.16,0,1,1,5.16,5.16A5.17,5.17,0,0,1,75.58,84Zm.59,0a4.57,4.57,0,1,0,4.57-4.56A4.57,4.57,0,0,0,76.17,84Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68.39,
    cy: 84.02,
    r: 4.86,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.23,84a5.16,5.16,0,1,1,5.16,5.16A5.17,5.17,0,0,1,63.23,84Zm.6,0a4.56,4.56,0,1,0,4.56-4.56A4.56,4.56,0,0,0,63.83,84Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.04,
    cy: 84.02,
    r: 4.86,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.88,84A5.16,5.16,0,1,1,56,89.18,5.17,5.17,0,0,1,50.88,84Zm.6,0A4.56,4.56,0,1,0,56,79.46,4.56,4.56,0,0,0,51.48,84Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.69,
    cy: 84.02,
    r: 4.86,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.53,84a5.16,5.16,0,1,1,5.16,5.16A5.17,5.17,0,0,1,38.53,84Zm.6,0a4.56,4.56,0,1,0,4.56-4.56A4.56,4.56,0,0,0,39.13,84Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 105.44,
    cy: 72.05,
    r: 4.86,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.28,72.05a5.16,5.16,0,1,1,5.16,5.16A5.17,5.17,0,0,1,100.28,72.05Zm.59,0a4.57,4.57,0,1,0,4.57-4.56A4.57,4.57,0,0,0,100.87,72.05Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.23,72.05a4.86,4.86,0,1,0,4.86-4.86A4.86,4.86,0,0,0,88.23,72.05Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.93,72.05a5.16,5.16,0,1,1,5.16,5.16A5.17,5.17,0,0,1,87.93,72.05Zm.59,0a4.57,4.57,0,1,0,4.57-4.56A4.57,4.57,0,0,0,88.52,72.05Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80.74,
    cy: 72.05,
    r: 4.86,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.58,72.05a5.16,5.16,0,1,1,5.16,5.16A5.17,5.17,0,0,1,75.58,72.05Zm.59,0a4.57,4.57,0,1,0,4.57-4.56A4.57,4.57,0,0,0,76.17,72.05Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68.39,
    cy: 72.05,
    r: 4.86,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.23,72.05a5.16,5.16,0,1,1,5.16,5.16A5.17,5.17,0,0,1,63.23,72.05Zm.6,0a4.56,4.56,0,1,0,4.56-4.56A4.56,4.56,0,0,0,63.83,72.05Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.04,
    cy: 72.05,
    r: 4.86,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.88,72.05A5.16,5.16,0,1,1,56,77.21,5.17,5.17,0,0,1,50.88,72.05Zm.6,0A4.56,4.56,0,1,0,56,67.49,4.56,4.56,0,0,0,51.48,72.05Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.69,
    cy: 72.05,
    r: 4.86,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.53,72.05a5.16,5.16,0,1,1,5.16,5.16A5.17,5.17,0,0,1,38.53,72.05Zm.6,0a4.56,4.56,0,1,0,4.56-4.56A4.56,4.56,0,0,0,39.13,72.05Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.92,71.91a4.86,4.86,0,1,0,4.86-4.86A4.86,4.86,0,0,0,112.92,71.91Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.63,71.91a5.16,5.16,0,1,1,5.15,5.16A5.16,5.16,0,0,1,112.63,71.91Zm.59,0a4.57,4.57,0,1,0,4.56-4.56A4.57,4.57,0,0,0,113.22,71.91Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 105.44,
    cy: 60.23,
    r: 4.86,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.28,60.23a5.16,5.16,0,1,1,5.16,5.16A5.16,5.16,0,0,1,100.28,60.23Zm.59,0a4.57,4.57,0,1,0,4.57-4.56A4.57,4.57,0,0,0,100.87,60.23Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.23,60.23a4.86,4.86,0,1,0,4.86-4.86A4.86,4.86,0,0,0,88.23,60.23Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.93,60.23a5.16,5.16,0,1,1,5.16,5.16A5.16,5.16,0,0,1,87.93,60.23Zm.59,0a4.57,4.57,0,1,0,4.57-4.56A4.57,4.57,0,0,0,88.52,60.23Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80.74,
    cy: 60.23,
    r: 4.86,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.58,60.23a5.16,5.16,0,1,1,5.16,5.16A5.16,5.16,0,0,1,75.58,60.23Zm.59,0a4.57,4.57,0,1,0,4.57-4.56A4.57,4.57,0,0,0,76.17,60.23Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68.39,
    cy: 60.23,
    r: 4.86,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.23,60.23a5.16,5.16,0,1,1,5.16,5.16A5.16,5.16,0,0,1,63.23,60.23Zm.6,0a4.56,4.56,0,1,0,4.56-4.56A4.56,4.56,0,0,0,63.83,60.23Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.04,
    cy: 60.23,
    r: 4.86,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.88,60.23A5.16,5.16,0,1,1,56,65.39,5.17,5.17,0,0,1,50.88,60.23Zm.6,0A4.56,4.56,0,1,0,56,55.67,4.56,4.56,0,0,0,51.48,60.23Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.69,
    cy: 60.23,
    r: 4.86,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.53,60.23a5.16,5.16,0,1,1,5.16,5.16A5.17,5.17,0,0,1,38.53,60.23Zm.6,0a4.56,4.56,0,1,0,4.56-4.56A4.56,4.56,0,0,0,39.13,60.23Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.92,60.09a4.86,4.86,0,1,0,4.86-4.86A4.86,4.86,0,0,0,112.92,60.09Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.63,60.09a5.16,5.16,0,1,1,5.15,5.16A5.16,5.16,0,0,1,112.63,60.09Zm.59,0a4.57,4.57,0,1,0,4.56-4.56A4.57,4.57,0,0,0,113.22,60.09Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 105.44,
    cy: 48.41,
    r: 4.86,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.28,48.41a5.16,5.16,0,1,1,5.16,5.16A5.16,5.16,0,0,1,100.28,48.41Zm.59,0a4.57,4.57,0,1,0,4.57-4.57A4.57,4.57,0,0,0,100.87,48.41Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.23,48.41a4.86,4.86,0,1,0,4.86-4.86A4.86,4.86,0,0,0,88.23,48.41Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.93,48.41a5.16,5.16,0,1,1,5.16,5.16A5.16,5.16,0,0,1,87.93,48.41Zm.59,0a4.57,4.57,0,1,0,4.57-4.57A4.57,4.57,0,0,0,88.52,48.41Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80.74,
    cy: 48.41,
    r: 4.86,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.58,48.41a5.16,5.16,0,1,1,5.16,5.16A5.16,5.16,0,0,1,75.58,48.41Zm.59,0a4.57,4.57,0,1,0,4.57-4.57A4.57,4.57,0,0,0,76.17,48.41Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68.39,
    cy: 48.41,
    r: 4.86,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.23,48.41a5.16,5.16,0,1,1,5.16,5.16A5.16,5.16,0,0,1,63.23,48.41Zm.6,0a4.56,4.56,0,1,0,4.56-4.57A4.56,4.56,0,0,0,63.83,48.41Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.04,
    cy: 48.41,
    r: 4.86,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.88,48.41A5.16,5.16,0,1,1,56,53.57,5.17,5.17,0,0,1,50.88,48.41Zm.6,0A4.56,4.56,0,1,0,56,43.84,4.56,4.56,0,0,0,51.48,48.41Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.69,
    cy: 48.41,
    r: 4.86,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.53,48.41a5.16,5.16,0,1,1,5.16,5.16A5.17,5.17,0,0,1,38.53,48.41Zm.6,0a4.56,4.56,0,1,0,4.56-4.57A4.56,4.56,0,0,0,39.13,48.41Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.92,48.27a4.86,4.86,0,1,0,4.86-4.86A4.86,4.86,0,0,0,112.92,48.27Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.63,48.27a5.16,5.16,0,1,1,5.15,5.16A5.16,5.16,0,0,1,112.63,48.27Zm.59,0a4.57,4.57,0,1,0,4.56-4.56A4.56,4.56,0,0,0,113.22,48.27Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.28,
    y: 131.14,
    width: 50.59,
    height: 74.11,
    transform: "translate(75.14 336.39) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.62,
    y: 133.3,
    width: 42.29,
    height: 9.88,
    transform: "translate(75.53 276.48) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "19.79 131.14 24.24 143.18 16.62 143.18 16.62 131.14 19.79 131.14",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.62,
    y: 145.35,
    width: 42.29,
    height: 9.88,
    transform: "translate(75.53 300.57) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "19.79 143.18 24.24 155.23 16.62 155.23 16.62 143.18 19.79 143.18",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.62,
    y: 157.63,
    width: 42.29,
    height: 9.88,
    transform: "translate(75.53 325.13) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "19.79 155.46 24.24 167.51 16.62 167.51 16.62 155.46 19.79 155.46",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.62,
    y: 169.65,
    width: 42.29,
    height: 9.88,
    transform: "translate(75.53 349.19) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "19.79 167.49 24.24 179.53 16.62 179.53 16.62 167.49 19.79 167.49",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.62,
    y: 181.68,
    width: 42.29,
    height: 9.88,
    transform: "translate(75.53 373.24) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "19.79 179.52 24.24 191.56 16.62 191.56 16.62 179.52 19.79 179.52",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.62,
    y: 193.71,
    width: 42.29,
    height: 9.88,
    transform: "translate(75.53 397.29) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "19.79 191.54 24.24 203.59 16.62 203.59 16.62 191.54 19.79 191.54",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.86,
    y: 163.34,
    width: 202.06,
    height: 2.41,
    transform: "translate(327.79 329.08) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.86,
    y: 165.82,
    width: 202.06,
    height: 17.07,
    transform: "translate(327.79 348.71) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.69,
    y: 184.71,
    width: 202.06,
    height: 17.07,
    transform: "translate(327.44 386.48) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.86,
    y: 140.06,
    width: 202.06,
    height: 23.19,
    transform: "translate(327.79 303.3) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.86,
    y: 137.93,
    width: 202.06,
    height: 2.41,
    transform: "translate(327.79 278.27) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.69,
    y: 182.18,
    width: 202.06,
    height: 2.41,
    transform: "translate(327.44 366.77) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.28,
    y: 201.16,
    width: 252.47,
    height: 31.28,
    transform: "translate(277.03 433.61) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.5,141s0-.18,0-.51,0-.82,0-1.46c0-1.3,0-3.19,0-5.63,0-4.89,0-12-.05-20.73,0-17.51,0-41.8-.07-68.91l.16.15h-6.36l.16-.15c0,44.6-.09,82.51-.1,96.43l-.05,0,4.75.63,1.19.17.41.06-.39,0-1.18-.14-4.79-.58h0v-.05c0-13.92-.05-51.83-.1-96.43v-.16h6.66v.16c0,27.16,0,51.49-.06,69,0,8.75,0,15.8-.05,20.68,0,2.42,0,4.31,0,5.59,0,.63,0,1.11,0,1.45S633.5,141,633.5,141Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.59,140.73s0-.18,0-.51,0-.82,0-1.46c0-1.29,0-3.18,0-5.61,0-4.87,0-11.92,0-20.66,0-17.46,0-41.68-.07-68.72l.16.15h-6.16l.16-.15c-.05,45-.09,83.25-.11,97l-.05,0,4.61,0h0l-4.64,0h0v-.05c0-13.71-.06-51.95-.1-97v-.16h6.46v.16c0,27.09,0,51.35-.06,68.84,0,8.72,0,15.76,0,20.62,0,2.42,0,4.29,0,5.57,0,.63,0,1.11,0,1.44S668.59,140.73,668.59,140.73Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.85,82.44c0,.08-16.72.15-37.33.15s-37.34-.07-37.34-.15,16.71-.16,37.34-.16S684.85,82.35,684.85,82.44Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.85,70.78c0,.08-16.72.15-37.33.15s-37.34-.07-37.34-.15,16.71-.16,37.34-.16S684.85,70.69,684.85,70.78Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.85,59.12c0,.08-16.72.15-37.33.15s-37.34-.07-37.34-.15S626.89,59,647.52,59,684.85,59,684.85,59.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.85,47.46c0,.08-16.72.15-37.33.15s-37.34-.07-37.34-.15,16.71-.16,37.34-.16S684.85,47.37,684.85,47.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.84,83.06A4.86,4.86,0,1,1,611,78.2,4.87,4.87,0,0,1,615.84,83.06Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611,88.22a5.16,5.16,0,1,1,5.15-5.16A5.17,5.17,0,0,1,611,88.22Zm0-9.72a4.56,4.56,0,1,0,4.56,4.56A4.57,4.57,0,0,0,611,78.5Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 623.33,
    cy: 83.06,
    r: 4.86,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.33,88.22a5.16,5.16,0,1,1,5.15-5.16A5.17,5.17,0,0,1,623.33,88.22Zm0-9.72a4.56,4.56,0,1,0,4.56,4.56A4.57,4.57,0,0,0,623.33,78.5Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.54,83.06a4.87,4.87,0,1,1-4.86-4.86A4.87,4.87,0,0,1,640.54,83.06Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.68,88.22a5.16,5.16,0,1,1,5.15-5.16A5.17,5.17,0,0,1,635.68,88.22Zm0-9.72a4.56,4.56,0,1,0,4.56,4.56A4.57,4.57,0,0,0,635.68,78.5Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.88,83.06A4.86,4.86,0,1,1,648,78.2,4.86,4.86,0,0,1,652.88,83.06Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648,88.22a5.16,5.16,0,1,1,5.16-5.16A5.16,5.16,0,0,1,648,88.22Zm0-9.72a4.56,4.56,0,1,0,4.57,4.56A4.56,4.56,0,0,0,648,78.5Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.23,83.06a4.86,4.86,0,1,1-4.86-4.86A4.86,4.86,0,0,1,665.23,83.06Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.37,88.22a5.16,5.16,0,1,1,5.16-5.16A5.16,5.16,0,0,1,660.37,88.22Zm0-9.72a4.56,4.56,0,1,0,4.57,4.56A4.56,4.56,0,0,0,660.37,78.5Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 672.72,
    cy: 83.06,
    r: 4.86,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.72,88.22a5.16,5.16,0,1,1,5.16-5.16A5.16,5.16,0,0,1,672.72,88.22Zm0-9.72a4.56,4.56,0,1,0,4.57,4.56A4.56,4.56,0,0,0,672.72,78.5Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 685.07,
    cy: 83.06,
    r: 4.86,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.07,88.22a5.16,5.16,0,1,1,5.16-5.16A5.17,5.17,0,0,1,685.07,88.22Zm0-9.72a4.56,4.56,0,1,0,4.56,4.56A4.56,4.56,0,0,0,685.07,78.5Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 623.33,
    cy: 71.09,
    r: 4.86,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.33,76.25a5.16,5.16,0,1,1,5.15-5.16A5.16,5.16,0,0,1,623.33,76.25Zm0-9.72a4.56,4.56,0,1,0,4.56,4.56A4.57,4.57,0,0,0,623.33,66.53Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.54,71.09a4.87,4.87,0,1,1-4.86-4.86A4.86,4.86,0,0,1,640.54,71.09Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.68,76.25a5.16,5.16,0,1,1,5.15-5.16A5.16,5.16,0,0,1,635.68,76.25Zm0-9.72a4.56,4.56,0,1,0,4.56,4.56A4.57,4.57,0,0,0,635.68,66.53Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.88,71.09A4.86,4.86,0,1,1,648,66.23,4.85,4.85,0,0,1,652.88,71.09Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648,76.25a5.16,5.16,0,1,1,5.16-5.16A5.16,5.16,0,0,1,648,76.25Zm0-9.72a4.56,4.56,0,1,0,4.57,4.56A4.57,4.57,0,0,0,648,66.53Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.23,71.09a4.86,4.86,0,1,1-4.86-4.86A4.85,4.85,0,0,1,665.23,71.09Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.37,76.25a5.16,5.16,0,1,1,5.16-5.16A5.16,5.16,0,0,1,660.37,76.25Zm0-9.72a4.56,4.56,0,1,0,4.57,4.56A4.57,4.57,0,0,0,660.37,66.53Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 672.72,
    cy: 71.09,
    r: 4.86,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.72,76.25a5.16,5.16,0,1,1,5.16-5.16A5.16,5.16,0,0,1,672.72,76.25Zm0-9.72a4.56,4.56,0,1,0,4.57,4.56A4.57,4.57,0,0,0,672.72,66.53Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 685.07,
    cy: 71.09,
    r: 4.86,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.07,76.25a5.16,5.16,0,1,1,5.16-5.16A5.17,5.17,0,0,1,685.07,76.25Zm0-9.72a4.56,4.56,0,1,0,4.56,4.56A4.57,4.57,0,0,0,685.07,66.53Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.84,71A4.86,4.86,0,1,1,611,66.1,4.87,4.87,0,0,1,615.84,71Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611,76.11A5.16,5.16,0,1,1,616.13,71,5.16,5.16,0,0,1,611,76.11Zm0-9.72A4.57,4.57,0,1,0,615.54,71,4.58,4.58,0,0,0,611,66.39Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 623.33,
    cy: 59.27,
    r: 4.86,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.33,64.43a5.16,5.16,0,1,1,5.15-5.16A5.17,5.17,0,0,1,623.33,64.43Zm0-9.72a4.56,4.56,0,1,0,4.56,4.56A4.57,4.57,0,0,0,623.33,54.71Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.54,59.27a4.87,4.87,0,1,1-4.86-4.86A4.87,4.87,0,0,1,640.54,59.27Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.68,64.43a5.16,5.16,0,1,1,5.15-5.16A5.17,5.17,0,0,1,635.68,64.43Zm0-9.72a4.56,4.56,0,1,0,4.56,4.56A4.57,4.57,0,0,0,635.68,54.71Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.88,59.27A4.86,4.86,0,1,1,648,54.41,4.86,4.86,0,0,1,652.88,59.27Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648,64.43a5.16,5.16,0,1,1,5.16-5.16A5.16,5.16,0,0,1,648,64.43Zm0-9.72a4.56,4.56,0,1,0,4.57,4.56A4.56,4.56,0,0,0,648,54.71Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.23,59.27a4.86,4.86,0,1,1-4.86-4.86A4.86,4.86,0,0,1,665.23,59.27Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.37,64.43a5.16,5.16,0,1,1,5.16-5.16A5.16,5.16,0,0,1,660.37,64.43Zm0-9.72a4.56,4.56,0,1,0,4.57,4.56A4.56,4.56,0,0,0,660.37,54.71Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 672.72,
    cy: 59.27,
    r: 4.86,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.72,64.43a5.16,5.16,0,1,1,5.16-5.16A5.16,5.16,0,0,1,672.72,64.43Zm0-9.72a4.56,4.56,0,1,0,4.57,4.56A4.56,4.56,0,0,0,672.72,54.71Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 685.07,
    cy: 59.27,
    r: 4.86,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.07,64.43a5.16,5.16,0,1,1,5.16-5.16A5.17,5.17,0,0,1,685.07,64.43Zm0-9.72a4.56,4.56,0,1,0,4.56,4.56A4.56,4.56,0,0,0,685.07,54.71Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.84,59.13A4.86,4.86,0,1,1,611,54.27,4.86,4.86,0,0,1,615.84,59.13Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611,64.29a5.16,5.16,0,1,1,5.15-5.16A5.16,5.16,0,0,1,611,64.29Zm0-9.72a4.57,4.57,0,1,0,4.56,4.56A4.57,4.57,0,0,0,611,54.57Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 623.33,
    cy: 47.45,
    r: 4.86,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.33,52.61a5.16,5.16,0,1,1,5.15-5.16A5.17,5.17,0,0,1,623.33,52.61Zm0-9.72a4.56,4.56,0,1,0,4.56,4.56A4.57,4.57,0,0,0,623.33,42.89Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.54,47.45a4.87,4.87,0,1,1-4.86-4.86A4.87,4.87,0,0,1,640.54,47.45Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.68,52.61a5.16,5.16,0,1,1,5.15-5.16A5.17,5.17,0,0,1,635.68,52.61Zm0-9.72a4.56,4.56,0,1,0,4.56,4.56A4.57,4.57,0,0,0,635.68,42.89Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.88,47.45A4.86,4.86,0,1,1,648,42.59,4.86,4.86,0,0,1,652.88,47.45Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648,52.61a5.16,5.16,0,1,1,5.16-5.16A5.16,5.16,0,0,1,648,52.61Zm0-9.72a4.56,4.56,0,1,0,4.57,4.56A4.56,4.56,0,0,0,648,42.89Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.23,47.45a4.86,4.86,0,1,1-4.86-4.86A4.86,4.86,0,0,1,665.23,47.45Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.37,52.61a5.16,5.16,0,1,1,5.16-5.16A5.16,5.16,0,0,1,660.37,52.61Zm0-9.72a4.56,4.56,0,1,0,4.57,4.56A4.56,4.56,0,0,0,660.37,42.89Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 672.72,
    cy: 47.45,
    r: 4.86,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.72,52.61a5.16,5.16,0,1,1,5.16-5.16A5.16,5.16,0,0,1,672.72,52.61Zm0-9.72a4.56,4.56,0,1,0,4.57,4.56A4.56,4.56,0,0,0,672.72,42.89Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 685.07,
    cy: 47.45,
    r: 4.86,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.07,52.61a5.16,5.16,0,1,1,5.16-5.16A5.17,5.17,0,0,1,685.07,52.61Zm0-9.72a4.56,4.56,0,1,0,4.56,4.56A4.56,4.56,0,0,0,685.07,42.89Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.84,47.31A4.86,4.86,0,1,1,611,42.45,4.86,4.86,0,0,1,615.84,47.31Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611,52.47a5.16,5.16,0,1,1,5.15-5.16A5.16,5.16,0,0,1,611,52.47Zm0-9.72a4.57,4.57,0,1,0,4.56,4.56A4.57,4.57,0,0,0,611,42.75Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 678.25,
    y: 131.14,
    width: 50.59,
    height: 74.11,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 682.2,
    y: 133.3,
    width: 42.29,
    height: 9.88,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "721.33 131.14 716.87 143.18 724.49 143.18 724.49 131.14 721.33 131.14",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 682.2,
    y: 145.35,
    width: 42.29,
    height: 9.88,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "721.33 143.18 716.87 155.23 724.49 155.23 724.49 143.18 721.33 143.18",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 682.2,
    y: 157.63,
    width: 42.29,
    height: 9.88,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "721.33 155.46 716.87 167.51 724.49 167.51 724.49 155.46 721.33 155.46",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 682.2,
    y: 169.65,
    width: 42.29,
    height: 9.88,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "721.33 167.49 716.87 179.53 724.49 179.53 724.49 167.49 721.33 167.49",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 682.2,
    y: 181.68,
    width: 42.29,
    height: 9.88,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "721.33 179.52 716.87 191.56 724.49 191.56 724.49 179.52 721.33 179.52",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 682.2,
    y: 193.71,
    width: 42.29,
    height: 9.88,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "721.33 191.54 716.87 203.59 724.49 203.59 724.49 191.54 721.33 191.54",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 476.19,
    y: 163.34,
    width: 202.06,
    height: 2.41,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 476.19,
    y: 165.82,
    width: 202.06,
    height: 17.07,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 476.36,
    y: 184.71,
    width: 202.06,
    height: 17.07,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 476.19,
    y: 140.06,
    width: 202.06,
    height: 23.19,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 476.19,
    y: 137.93,
    width: 202.06,
    height: 2.41,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 476.36,
    y: 182.18,
    width: 202.06,
    height: 2.41,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 476.36,
    y: 201.16,
    width: 252.47,
    height: 31.28,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Field--inject-29"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.32,
    y: 441.9,
    width: 715.52,
    height: 18.83,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.48 124.27 22.32 441.9 737.85 441.9 583.66 122.16 169.48 124.27",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "599.11 433.76 552.45 290.13 203.14 290.13 160.04 433.75 159.08 433.46 202.4 289.13 553.17 289.13 600.06 433.45 599.11 433.76",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "265.81 433.69 264.82 433.52 276.46 366.88 479.65 366.88 479.72 367.3 490.76 433.52 489.77 433.69 478.81 367.88 277.3 367.88 265.81 433.69",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.64,289.91c-.06-.08-5.5-8.07-17.36-16C426.34,266.69,407.55,258,380.14,258h-.06c-16.49,0-40.09,2.64-58.88,15.12-11.23,7.46-15.46,15-15.5,15.09l-.88-.48c.17-.3,17.48-30.7,75.26-30.73h.06c53,0,75.11,32,75.33,32.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.29,179.41c-37.52,0-68-19.73-68-44a29.68,29.68,0,0,1,2-10.66l.93.36a28.55,28.55,0,0,0-1.94,10.3c0,23.7,30.07,43,67,43s67-19.28,67-43A28.84,28.84,0,0,0,443,124.1l.92-.39a29.7,29.7,0,0,1,2.44,11.72C446.33,159.68,415.8,179.41,378.29,179.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.91,434.1H33.33l.32-.71L173.57,132H577.26l.14.29Zm-688-1H721.32L576.64,133H174.21Z",
    style: {
      fill: "#fff"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "freepik--shield-1--inject-29"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--soccer-ball--inject-29"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 213.95,
    cy: 396.64,
    r: 16.9,
    transform: "translate(-217.8 267.46) rotate(-45)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209,380.87a16.42,16.42,0,0,0-4.75,2.38,33.65,33.65,0,0,1,4-1.93A8,8,0,0,1,209,380.87Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211,385.07l-4.82,5.32a12.05,12.05,0,0,0,2.21,7.18,35.41,35.41,0,0,1,7.28,1.27,26.26,26.26,0,0,0,5.14-5.51c-.26-.66-1.79-4.59-2.32-6.33C216.1,385.63,211.73,385.14,211,385.07Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.08,384.68c.76.08,5.07.56,7.59,2a15.05,15.05,0,0,1,4-2.42,10.15,10.15,0,0,0-2.65-2.94,16.26,16.26,0,0,0-6.06-1.16,16.7,16.7,0,0,0-2.36.17,11.65,11.65,0,0,0-2.9,1.23A10.59,10.59,0,0,1,211.08,384.68Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.08,384.19a22.14,22.14,0,0,1,5.15,5.45c.13,0,.43.14.81.3a16.62,16.62,0,0,0-7.78-8.11A8.75,8.75,0,0,1,223.08,384.19Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.59,389.83a9.82,9.82,0,0,1,1-4.12,16.44,16.44,0,0,0-4.08,9.44A12.68,12.68,0,0,1,200.59,389.83Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210,409.18a13.53,13.53,0,0,1-3.56-3.29,20.35,20.35,0,0,1-1.43-2.05q-.6.06-1.14.06a7,7,0,0,1-4-1.07,5.65,5.65,0,0,0,.36,2.75l.12.25h-.08A16.64,16.64,0,0,0,208,412a7.46,7.46,0,0,0,2,0A10.11,10.11,0,0,1,210,409.18Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.94,403.45a25.12,25.12,0,0,1,3.15-5.7,12.49,12.49,0,0,1-2.27-7.25c-.7,0-3.07-.11-5-.38a13,13,0,0,0-3.18,5.8,15.06,15.06,0,0,0,2.16,6.42A6.9,6.9,0,0,0,204.94,403.45Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.26,390.45a10.58,10.58,0,0,0-1-.38,19.89,19.89,0,0,1-1.16,4.67,20.27,20.27,0,0,1,1.15,6.95l1.2.6a16.3,16.3,0,0,0,1-5.65A16.52,16.52,0,0,0,229.26,390.45Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.89,407.52l-1,0c-3.14,0-4.65-.87-5.08-1.17a17.37,17.37,0,0,1-6.47,2.86,9.08,9.08,0,0,0,0,2.87A4.3,4.3,0,0,0,212,413a17.37,17.37,0,0,0,1.92.11,16.39,16.39,0,0,0,8.39-2.3l-.38,0,.22-.27A5.15,5.15,0,0,0,222.89,407.52Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.14,393.58a26.66,26.66,0,0,1-5.16,5.54A25,25,0,0,1,217,406c.35.25,2.11,1.33,6,1.09.27-.17,2.11-1.4,4.85-5.38a20.22,20.22,0,0,0-1.11-6.84A45.68,45.68,0,0,1,221.14,393.58Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214,379.74a16.9,16.9,0,1,0,16.9,16.9A16.89,16.89,0,0,0,214,379.74ZM229,389.94c-.38-.16-.68-.26-.81-.3a22.14,22.14,0,0,0-5.15-5.45,8.75,8.75,0,0,0-1.82-2.36A16.62,16.62,0,0,1,229,389.94ZM214,380.12a16.26,16.26,0,0,1,6.06,1.16,10.15,10.15,0,0,1,2.65,2.94,15.05,15.05,0,0,0-4,2.42c-2.52-1.4-6.83-1.88-7.59-2a10.59,10.59,0,0,0-2.39-3.16,11.65,11.65,0,0,1,2.9-1.23A16.7,16.7,0,0,1,214,380.12Zm6.9,13.21a26.26,26.26,0,0,1-5.14,5.51,35.41,35.41,0,0,0-7.28-1.27,12.05,12.05,0,0,1-2.21-7.18l4.82-5.32c.69.07,5.06.56,7.49,1.93C219.06,388.74,220.59,392.67,220.85,393.33ZM209,380.87a8,8,0,0,0-.77.45,33.65,33.65,0,0,0-4,1.93A16.42,16.42,0,0,1,209,380.87Zm-7.46,4.84a9.82,9.82,0,0,0-1,4.12,12.68,12.68,0,0,0-3.09,5.32A16.44,16.44,0,0,1,201.58,385.71Zm-.73,4.41c1.9.27,4.27.35,5,.38a12.49,12.49,0,0,0,2.27,7.25,25.12,25.12,0,0,0-3.15,5.7,6.9,6.9,0,0,1-5.11-1.11,15.06,15.06,0,0,1-2.16-6.42A13,13,0,0,1,200.85,390.12ZM208,412a16.64,16.64,0,0,1-7.73-6.19h.08l-.12-.25a5.65,5.65,0,0,1-.36-2.75,7,7,0,0,0,4,1.07q.54,0,1.14-.06a20.35,20.35,0,0,0,1.43,2.05,13.53,13.53,0,0,0,3.56,3.29,10.11,10.11,0,0,0,0,2.88A7.46,7.46,0,0,1,208,412Zm14.37-1.18a16.39,16.39,0,0,1-8.39,2.3A17.37,17.37,0,0,1,212,413a4.3,4.3,0,0,1-1.64-.93,9.08,9.08,0,0,1,0-2.87,17.37,17.37,0,0,0,6.47-2.86c.43.3,1.94,1.17,5.08,1.17l1,0a5.15,5.15,0,0,1-.71,3l-.22.27Zm.68-3.72c-3.88.24-5.64-.84-6-1.09a25,25,0,0,0-1.05-6.92,26.66,26.66,0,0,0,5.16-5.54,45.68,45.68,0,0,0,5.62,1.33,20.22,20.22,0,0,1,1.11,6.84C225.13,405.73,223.29,407,223,407.13Zm5.24-5.44a20.27,20.27,0,0,0-1.15-6.95,19.89,19.89,0,0,0,1.16-4.67,10.58,10.58,0,0,1,1,.38,16.52,16.52,0,0,1,1.2,6.19,16.3,16.3,0,0,1-1,5.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M227.76,414.51c0,2.62-8.44,4.75-18.85,4.75s-18.84-2.13-18.84-4.75,8.44-4.74,18.84-4.74S227.76,411.89,227.76,414.51Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-11--inject-29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M597.73,283.69a46.18,46.18,0,0,1-2.42-7.5,16,16,0,0,1,.18-7.82c.12-.38,1.16-2.95,1.56-2.94s-.31,2.39-.16,2.63a13.53,13.53,0,0,1,2,7.8,35.76,35.76,0,0,1-1.14,7.83",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.53,286.75c0-3.06-.43-9.37-.91-15.07a11.8,11.8,0,0,0-11.81-10.81h-.61c-6.59.41-9.93,6.24-9.34,12.81l.79,23.55a7.77,7.77,0,0,0,7.81,7.5h0a7.75,7.75,0,0,0,7.69-7.82c0-1.61,0-2.82,0-2.82S619.47,293.08,619.53,286.75Z",
    style: {
      fill: "#e6866e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.18,294.09a15.28,15.28,0,0,1-8.26-2.41s1.91,4.73,8.23,4.13Z",
    style: {
      fill: "#a3594e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.19,277.25a.91.91,0,0,1-.87.92.87.87,0,0,1-.94-.81.91.91,0,0,1,.87-.92A.87.87,0,0,1,616.19,277.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.31,274.31c-.11.12-.8-.39-1.77-.38s-1.69.5-1.8.38.07-.27.38-.5a2.47,2.47,0,0,1,2.84,0C617.26,274,617.36,274.26,617.31,274.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.2,277.42a.9.9,0,0,1-.87.91.86.86,0,0,1-.94-.81.91.91,0,0,1,.87-.92A.87.87,0,0,1,607.2,277.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.77,274.74c-.11.12-.8-.39-1.77-.38s-1.69.49-1.79.38.06-.27.37-.5a2.48,2.48,0,0,1,2.85,0C607.72,274.47,607.83,274.69,607.77,274.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.29,282.21a6.34,6.34,0,0,1,1.58-.29c.25,0,.49-.08.53-.25a1.28,1.28,0,0,0-.17-.74c-.24-.6-.48-1.23-.74-1.89a32.55,32.55,0,0,1-1.67-4.94,32.71,32.71,0,0,1,2.06,4.8c.25.66.49,1.29.71,1.9a1.43,1.43,0,0,1,.14,1,.62.62,0,0,1-.41.37,1.76,1.76,0,0,1-.42.06A6.61,6.61,0,0,1,611.29,282.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.13,271.38c-.08.26-.86.14-1.78.28s-1.66.46-1.78.22.07-.36.37-.62a2.64,2.64,0,0,1,1.32-.58,2.39,2.39,0,0,1,1.39.2C607,271.05,607.16,271.25,607.13,271.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.52,271.81c-.16.22-.84,0-1.65,0s-1.48.19-1.64,0,0-.34.32-.55a2.26,2.26,0,0,1,1.33-.4,2.23,2.23,0,0,1,1.32.41C616.5,271.47,616.59,271.7,616.52,271.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.44,278.37c-.11-.05-4.36-1.27-4.21,3.06s4.47,3.28,4.48,3.16S597.44,278.37,597.44,278.37Z",
    style: {
      fill: "#e6866e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.32,283s-.07.06-.2.12a.73.73,0,0,1-.56,0,1.87,1.87,0,0,1-.92-1.64,2.43,2.43,0,0,1,.17-1.09.88.88,0,0,1,.55-.6.39.39,0,0,1,.45.19c.06.12,0,.21.06.22s.09-.08,0-.26a.46.46,0,0,0-.18-.26.59.59,0,0,0-.42-.1,1.09,1.09,0,0,0-.77.7,2.56,2.56,0,0,0-.21,1.22,2,2,0,0,0,1.16,1.83.8.8,0,0,0,.69-.14C596.32,283.1,596.34,283,596.32,283Z",
    style: {
      fill: "#a3594e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.53,264.63c.69-.42-1.52-2.6-3.27-3.3-2.66-1.07-6.67-1.62-9-.83a10.45,10.45,0,0,0-6.53,5.19,17,17,0,0,0-1.52,8.78,5,5,0,0,0,.73,2.61c.64.93,1.83,1.49,1.84,2.81a1.8,1.8,0,0,0,.51,1.3c.83.81,1.76,0,2.17-.84a18.69,18.69,0,0,0,.43-9.82c-.24-.71-.61-1.38-.82-2.1a2.66,2.66,0,0,1,.21-2.18,2.61,2.61,0,0,1,.34-.37,4.5,4.5,0,0,1,4.44-1.05c2.48.75,6.7,1.86,7.75,1a6.7,6.7,0,0,0,1.85-2.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595,270.5a2.63,2.63,0,0,1-1.06-4.32c.38-.39.9-.69,1.09-1.21a3.61,3.61,0,0,0-.17-1.8,3.08,3.08,0,0,1,3.39-3.55,4.94,4.94,0,0,1,8.27-3.34,2.38,2.38,0,0,0,.88.64,2.69,2.69,0,0,0,1.56-.35,3.6,3.6,0,0,1,4.49,2.36,3.12,3.12,0,0,1,3.27,5.3,2.78,2.78,0,0,1,.25,3.2,2,2,0,0,1-3,.4,1,1,0,0,1-1.57.27,2.5,2.5,0,0,1-.7-1.69,4.49,4.49,0,0,0-.41-1.82c-.56-1-1.81-1.21-2.91-1.38a25.66,25.66,0,0,0-4.71-.38,8.36,8.36,0,0,0-4.46,1.37,9,9,0,0,0-3.31,6.35",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.23,274.33c0,.05-.33,0-.71-.11s-.67-.25-.66-.3.34,0,.71.11S597.25,274.28,597.23,274.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.3,273.36c0,.05-.25,0-.51-.08s-.46-.21-.45-.26.25,0,.52.08S597.32,273.31,597.3,273.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.78,272.27s-.25-.13-.48-.38-.38-.47-.34-.51.25.13.48.38S597.82,272.23,597.78,272.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.34,282.86c.14,0,.1,1,.91,1.72s1.86.68,1.86.82-.24.18-.68.17a2.41,2.41,0,0,1-1.56-.62,2.11,2.11,0,0,1-.7-1.44C608.15,283.09,608.27,282.85,608.34,282.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "581 305.19 585.92 317.3 581.27 349.89 579.06 365.79 570.34 365.79 571.51 347.87 574.32 323.52 581 305.19",
    style: {
      fill: "#e6866e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "632.37 309.53 626.79 317.3 630.13 349.09 633.21 365.79 642.02 365.79 639.88 347.06 638.39 323.52 632.37 309.53",
    style: {
      fill: "#e6866e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.51,332s1.59-10.33,2.64-14,3.36-11.58,6.14-14.14,4.61-2.3,9.6-3.91c3.73-1.21,6.76-2.29,6.76-2.29l1.15-1.56c3.13,8.39,13.72,6.41,15.74,0l.93,1.48s15.65,5.17,18.16,9,8.26,25.73,8.26,25.73l-14.41.95.28-7.44s-2,9.06-1.3,16.18c.6,6.28,2,23.74,2,23.74l-42.63-.14s1.21-21.46,1.37-25.54c.11-3-.79-14.88-.79-14.88l-.93,8.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.36,302.4a8.82,8.82,0,0,1-1.15.54l-3.14,1.42c-1.31.61-2.91,1.3-4.59,2.2a12.36,12.36,0,0,0-4.5,4.06,13.64,13.64,0,0,0-1.92,5.78,25.73,25.73,0,0,0,.12,5.05c.13,1.36.24,2.51.33,3.43a4.84,4.84,0,0,1,0,1.26,7.33,7.33,0,0,1-.24-1.24c-.13-.8-.31-2-.49-3.41a23.64,23.64,0,0,1-.24-5.15,13.77,13.77,0,0,1,2-6,12.47,12.47,0,0,1,4.71-4.2c1.74-.9,3.34-1.54,4.68-2.12s2.44-1,3.21-1.26A4.93,4.93,0,0,1,600.36,302.4Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.76,325.83a5.85,5.85,0,0,1,0-1.31c0-.85.13-2.07.28-3.56a29.21,29.21,0,0,0,.13-5.23,11.72,11.72,0,0,0-1.94-5.94,12.87,12.87,0,0,0-5-3.85c-1.79-.83-3.45-1.51-4.84-2.08l-3.3-1.32a7.23,7.23,0,0,1-1.2-.51,5.89,5.89,0,0,1,1.27.31c.81.25,2,.65,3.37,1.18s3.08,1.17,4.91,2a12.93,12.93,0,0,1,5.17,4,11.83,11.83,0,0,1,2,6.2,26.53,26.53,0,0,1-.25,5.31c-.19,1.49-.35,2.7-.44,3.53A7.2,7.2,0,0,1,626.76,325.83Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.45,299.06a9.81,9.81,0,0,1-1.64.59l-4.51,1.43-3.12,1c-1.12.35-2.32.71-3.53,1.21a11.21,11.21,0,0,0-3.43,2.11,11.09,11.09,0,0,0-2.42,3.58,43.26,43.26,0,0,0-1.51,4.15c-.44,1.36-.85,2.69-1.22,4-.74,2.53-1.36,4.83-1.87,6.76L573,328.37a11,11,0,0,1-.48,1.67,1.53,1.53,0,0,1,0-.45q.07-.43.24-1.26c.22-1.1.56-2.68,1-4.62s1-4.26,1.77-6.8c.36-1.27.75-2.61,1.19-4a38.39,38.39,0,0,1,1.53-4.21,10.31,10.31,0,0,1,6.14-5.92c1.24-.5,2.46-.84,3.58-1.17l3.14-.9,4.56-1.27A11.82,11.82,0,0,1,597.45,299.06Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.52,329.52a9.87,9.87,0,0,1-.66-1.56c-.42-1.1-1-2.56-1.63-4.32-1.36-3.63-3.13-8.74-5.21-14.27a6.59,6.59,0,0,0-2.58-3.22,30.24,30.24,0,0,0-3.44-2c-2.26-1.2-4.37-2.15-6.15-2.92l-4.25-1.79a11.7,11.7,0,0,1-1.54-.7,9.82,9.82,0,0,1,1.62.51c1,.37,2.5.91,4.31,1.64s3.94,1.65,6.24,2.84a29.23,29.23,0,0,1,3.51,2.05,7.21,7.21,0,0,1,2.76,3.44c2.1,5.59,3.8,10.67,5.08,14.35l1.47,4.37A11.29,11.29,0,0,1,639.52,329.52Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.83,325.7a4.09,4.09,0,0,1,1.44,3.27,4.63,4.63,0,0,1-.68,2.44,4.76,4.76,0,0,1-2.08,1.77,8.12,8.12,0,0,1-3.46.66,12.55,12.55,0,0,1-3-.36,8.66,8.66,0,0,1-2.54-1l1.45-3a6.86,6.86,0,0,0,1.88.87,7.09,7.09,0,0,0,2.08.31,3,3,0,0,0,1.66-.4,1.25,1.25,0,0,0,.62-1.11,1.17,1.17,0,0,0-.61-1.08,4.46,4.46,0,0,0-2.16-.37h-3.88l.71-8.34h9.1v3.12h-5.75l-.18,2.08h.95A6.78,6.78,0,0,1,610.83,325.7Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "571.51 331.99 571.97 329.14 584.81 330.59 584.48 333.56 571.51 331.99",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "626.48 333.27 626.79 330.94 640.16 329.62 640.88 332.32 626.48 333.27",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.56,297.56a9.59,9.59,0,0,1-12.64,5.63,8.42,8.42,0,0,1-5.12-5.32l1.1-1.77a8,8,0,0,0,8.09,5.56c6.06-.24,7.44-5.67,7.64-5.56l.93,1.48",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 617.59,
    y: 313.6,
    width: 4.69,
    height: 3.11,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.45,317.69a11.77,11.77,0,0,1-4.92,0,11.77,11.77,0,0,1,4.92,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.14,315.62a2,2,0,1,1-2-2A2,2,0,0,1,594.14,315.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.44,365.79c0,.14-18.48.26-41.26.26s-41.26-.12-41.26-.26,18.47-.26,41.26-.26S647.44,365.64,647.44,365.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 606.2,
    cy: 374.92,
    rx: 33.68,
    ry: 3.38
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-10--inject-29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M518.37,105.34c0-3.3.11-6.71,1.46-9.72l-.15-1.25a2.84,2.84,0,0,0-4.22,2,3.54,3.54,0,0,0-2.71,5.41,3.54,3.54,0,0,0-.14,5.46,2.64,2.64,0,0,0-.34,2.49,2.61,2.61,0,0,0,1.93,1.61,4.73,4.73,0,0,0,1.52,5,4.65,4.65,0,0,0-.09,2,2.15,2.15,0,0,0,1.21,1.56,1.45,1.45,0,0,0,1.79-.55,2.47,2.47,0,0,0,.12-1.48A95.23,95.23,0,0,1,518.37,105.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.36,98.17a3.37,3.37,0,0,1,3,1.2,2.73,2.73,0,0,1,.13,3.13,2.87,2.87,0,0,1-.26,3.62,2.57,2.57,0,0,1-.54,3.18l-5.14-9.52A4.38,4.38,0,0,1,536.36,98.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.6,106.78c-.62-6.52,2.66-12.32,9.2-12.76h.61a11.72,11.72,0,0,1,11.77,10.68c.5,5.65,1,11.91,1,15,0,6.29-6.31,7.32-6.31,7.32l.21,12.6-15.79-3.27Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.6,109.75a.9.9,0,0,1-.86.91.86.86,0,0,1-.94-.8.9.9,0,0,1,.86-.91A.86.86,0,0,1,535.6,109.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.94,107.45c-.11.12-.79-.38-1.76-.37s-1.67.5-1.77.39.06-.27.36-.5a2.52,2.52,0,0,1,1.42-.45,2.43,2.43,0,0,1,1.41.44C536.9,107.19,537,107.4,536.94,107.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.73,110.09a.9.9,0,0,1-.86.91.85.85,0,0,1-.93-.8.9.9,0,0,1,.86-.91A.86.86,0,0,1,526.73,110.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.31,107.26c-.1.13-.83-.29-1.79-.17s-1.61.67-1.72.57,0-.27.31-.53a2.36,2.36,0,0,1,1.36-.6,2.34,2.34,0,0,1,1.44.28C527.23,107,527.36,107.2,527.31,107.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.92,115.18a7.24,7.24,0,0,1,1.57-.3c.25,0,.48-.07.52-.24a1.23,1.23,0,0,0-.17-.73l-.75-1.88a33.94,33.94,0,0,1-1.68-4.9,31.51,31.51,0,0,1,2.07,4.76l.72,1.88a1.43,1.43,0,0,1,.14,1,.63.63,0,0,1-.41.36,1.67,1.67,0,0,1-.42.07A5.88,5.88,0,0,1,530.92,115.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.41,103.09c-.09.26-1.06.15-2.19.29s-2.05.47-2.2.23.09-.36.45-.62a3.79,3.79,0,0,1,1.63-.58,3.6,3.6,0,0,1,1.72.19C527.24,102.76,527.45,103,527.41,103.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.52,104.47c-.17.22-.84,0-1.64,0s-1.48.16-1.64-.07,0-.33.33-.54a2.38,2.38,0,0,1,2.64.06C536.5,104.14,536.59,104.36,536.52,104.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.15,111.44c-.11,0-4.33-1.24-4.16,3s4.45,3.24,4.46,3.12S517.15,111.44,517.15,111.44Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.07,116s-.07.06-.2.12a.73.73,0,0,1-.56,0,1.83,1.83,0,0,1-.92-1.62,2.51,2.51,0,0,1,.16-1.08.89.89,0,0,1,.54-.6.38.38,0,0,1,.45.19c.07.11,0,.2.07.21s.08-.08,0-.25a.45.45,0,0,0-.18-.27.58.58,0,0,0-.42-.09,1,1,0,0,0-.75.7,2.52,2.52,0,0,0-.21,1.21,2,2,0,0,0,1.17,1.81.82.82,0,0,0,.68-.14C516.06,116.14,516.08,116,516.07,116Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.06,97.69a2,2,0,0,0-1.53-1.6A1.79,1.79,0,0,0,533.72,94a1.84,1.84,0,0,0-2.52-1.62,1.55,1.55,0,0,0-2.92-.82,2.67,2.67,0,0,0-4.17-.31A3.41,3.41,0,0,0,520,93.15a3.25,3.25,0,0,0-2.84,2.25,2.38,2.38,0,0,0-1.73,3.73,1.76,1.76,0,0,0-.34,2.78,1.78,1.78,0,0,0-1,1.59,1.75,1.75,0,0,0,1,1.53c-.58.08-.81.85-.63,1.4s.6,1,.83,1.54.56,1.07.56,1.07a1.43,1.43,0,0,0,.82,2.38l0,0c.74,1.7,2,3.46,1.92.49,0-.51.73-.7,1-1.13a5.75,5.75,0,0,0,.82-1.57,1.37,1.37,0,0,0-.56-1.54,2.07,2.07,0,0,0,1.24-1.63A6.12,6.12,0,0,0,521,104c-.2-1-.39-2.08-.59-3.12a3.92,3.92,0,0,0,3.38-2.26,2.25,2.25,0,0,0,3.26-.82,2.93,2.93,0,0,0,3.58,1.78c-.15.82,1.32,1.56,2.13,1.77a2.87,2.87,0,0,0,1.8-.37s1.38.81,2.13.5,1.73-1.26,1.24-2A3.63,3.63,0,0,0,538.06,97.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539,115.84a1.39,1.39,0,0,0-2,.59,1.73,1.73,0,0,0-1.63-.66,1.71,1.71,0,0,0-1.35,1.1,1.41,1.41,0,0,0-2.28-.41,1.11,1.11,0,0,0-1.15-.46,1,1,0,0,0-.52-1,1.14,1.14,0,0,0-1.19.09,1.79,1.79,0,0,0-2.55-.44,1,1,0,0,0-1.85,0,1.62,1.62,0,0,0-1.79-.47,1,1,0,0,0-1.26-.92c.16-.5-.62-.74-1-1.1a6.06,6.06,0,0,0-.47-.54c-.19-.15-.52-.18-.65,0a.85.85,0,0,0-.55-1,.94.94,0,0,0-1.11.42,2.44,2.44,0,0,0-.16.71c-.14.78-.62,1.69,0,2.25.11.1.24.18.28.31s-.17.44-.19.68.24.49.35.74a2.28,2.28,0,0,1,0,1.21c0,.4.2.92.63.89a1.37,1.37,0,0,0,.43,1.78,1.35,1.35,0,0,0,.82,1.84.69.69,0,0,0-.08.94,2.13,2.13,0,0,0,.87.62.58.58,0,0,0-.18.83,1.42,1.42,0,0,0,.84.5.69.69,0,0,1,.37.19c.14.22-.07.5,0,.75s.63.51.79.87-.06.76.2,1,.45.13.67.21c.4.14.57.57.82.9a3.67,3.67,0,0,0,2,1.09l1.2.27c.8.16,1.61.26,2.42.37.4.05.9.06,1.12-.26a1.45,1.45,0,0,0,2.23-.21,3.55,3.55,0,0,0,2.18-.35l.72-.28c.72-.28,1.52-.65,1.74-1.35a1.47,1.47,0,0,0,1.17-2,.62.62,0,0,0,.71-.52,2.75,2.75,0,0,0-.11-.94c-.21-1.28.53-2.56.38-3.85-.11-.89-.65-1.79-.36-2.65a1.56,1.56,0,0,0,.15-.54.34.34,0,0,0-.38-.33.83.83,0,0,0-.86-1.11",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.08,115.87c.16,0,.17,1,1.08,1.78s2,.61,2,.76-.25.2-.72.22a2.62,2.62,0,0,1-1.7-.57,2.3,2.3,0,0,1-.83-1.49C527.9,116.13,528,115.87,528.08,115.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "500.23 139.11 505.14 151.22 500.5 183.81 498.29 199.71 489.56 199.71 490.74 181.79 493.55 157.45 500.23 139.11",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "551.6 143.45 546.02 151.22 549.35 183.01 552.44 199.71 561.25 199.71 559.11 180.98 557.62 157.45 551.6 143.45",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.74,166s1.59-10.33,2.63-14,3.37-11.58,6.15-14.14,4.61-2.3,9.59-3.91c3.74-1.21,6.77-2.29,6.77-2.29l1.15-1.55c3.13,8.38,13.93,6.46,16,.05l.72,1.42s15.65,5.17,18.16,9,8.25,25.73,8.25,25.73l-14.4.95.28-7.44s-2,9.06-1.3,16.19c.6,6.27,2,23.73,2,23.73l-42.62-.14s1.21-21.46,1.37-25.54c.11-3-.79-14.88-.79-14.88l-.93,8.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.58,136.32a6,6,0,0,1-1.14.55l-3.14,1.41c-1.31.62-2.92,1.31-4.59,2.2a12.36,12.36,0,0,0-4.5,4.06,13.68,13.68,0,0,0-1.92,5.78,25.73,25.73,0,0,0,.12,5.05c.13,1.37.24,2.51.33,3.43a5,5,0,0,1,0,1.27,7.64,7.64,0,0,1-.24-1.25c-.13-.8-.31-2-.5-3.41a24.29,24.29,0,0,1-.23-5.14,13.77,13.77,0,0,1,2-6,12.47,12.47,0,0,1,4.71-4.2c1.74-.9,3.33-1.54,4.68-2.12s2.44-1,3.21-1.26A4.94,4.94,0,0,1,519.58,136.32Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546,159.75a5.18,5.18,0,0,1,0-1.31c0-.85.13-2.06.28-3.56a29.21,29.21,0,0,0,.13-5.23,11.64,11.64,0,0,0-2-5.94,12.74,12.74,0,0,0-4.95-3.84c-1.79-.84-3.45-1.51-4.84-2.09l-3.3-1.32a9.53,9.53,0,0,1-1.2-.5,4.85,4.85,0,0,1,1.27.31c.81.25,2,.64,3.37,1.17s3.08,1.17,4.9,2a13,13,0,0,1,5.18,4,11.86,11.86,0,0,1,2,6.21,26.43,26.43,0,0,1-.25,5.3c-.19,1.5-.35,2.7-.44,3.53A7,7,0,0,1,546,159.75Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.7,131.49a9.58,9.58,0,0,1-12.65,5.62,8.38,8.38,0,0,1-5.11-5.32L517,130a8,8,0,0,0,8.1,5.55c6.06-.24,7.67-5.63,7.86-5.51l.71,1.43",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.67,133a12.16,12.16,0,0,1-1.63.59L510.53,135l-3.12,1c-1.13.35-2.32.71-3.53,1.21a9.9,9.9,0,0,0-5.85,5.69,41.61,41.61,0,0,0-1.51,4.15c-.45,1.36-.85,2.69-1.22,4-.74,2.53-1.36,4.83-1.87,6.76s-.88,3.41-1.19,4.58a12.6,12.6,0,0,1-.47,1.67,1.52,1.52,0,0,1,0-.45c.05-.29.13-.72.24-1.27.21-1.1.56-2.68,1-4.62s1.05-4.25,1.77-6.8c.36-1.27.75-2.6,1.19-4a38.25,38.25,0,0,1,1.53-4.2,11.37,11.37,0,0,1,2.54-3.74,11.81,11.81,0,0,1,3.6-2.19c1.24-.5,2.46-.84,3.58-1.17l3.14-.9,4.56-1.27A9.52,9.52,0,0,1,516.67,133Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.75,163.44a9.34,9.34,0,0,1-.66-1.56c-.42-1.1-1-2.56-1.63-4.31-1.36-3.64-3.13-8.74-5.21-14.27a7.56,7.56,0,0,0-1.06-1.84,7.71,7.71,0,0,0-1.52-1.39,31.78,31.78,0,0,0-3.44-2c-2.26-1.2-4.37-2.15-6.15-2.92l-4.25-1.79a11.7,11.7,0,0,1-1.54-.7,11,11,0,0,1,1.61.51c1,.37,2.51.91,4.32,1.64s3.94,1.65,6.24,2.84a30.16,30.16,0,0,1,3.51,2.06,7.13,7.13,0,0,1,2.76,3.43c2.1,5.59,3.79,10.67,5.08,14.35.6,1.78,1.09,3.26,1.47,4.37A12.19,12.19,0,0,1,558.75,163.44Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.6,155.71a7.19,7.19,0,0,1,1.78,5.23,8.81,8.81,0,0,1-1,4.21,6.36,6.36,0,0,1-2.68,2.68,8.32,8.32,0,0,1-4,.92,9.14,9.14,0,0,1-2.31-.28,6.32,6.32,0,0,1-1.88-.76l1.47-2.9a4.47,4.47,0,0,0,2.64.74,3.55,3.55,0,0,0,2.47-.85,3.6,3.6,0,0,0,1.12-2.46,4.82,4.82,0,0,1-3.21,1,5.37,5.37,0,0,1-2.47-.56,4.41,4.41,0,0,1-1.78-1.59,4.28,4.28,0,0,1-.66-2.36,4.47,4.47,0,0,1,.74-2.56,4.9,4.9,0,0,1,2-1.71,6.55,6.55,0,0,1,2.83-.6A6.46,6.46,0,0,1,530.6,155.71Zm-3.14,4.18a1.85,1.85,0,0,0,0-2.62,2.09,2.09,0,0,0-1.46-.5,2,2,0,0,0-1.4.49,1.71,1.71,0,0,0-.54,1.33,1.66,1.66,0,0,0,.54,1.3,2,2,0,0,0,1.42.5A2.06,2.06,0,0,0,527.46,159.89Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "490.74 165.92 491.2 163.06 504.04 164.52 503.71 167.48 490.74 165.92",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "545.71 167.19 546.02 164.86 559.39 163.54 560.11 166.24 545.71 167.19",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 536.82,
    y: 147.52,
    width: 4.69,
    height: 3.11,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.68,151.61a11.77,11.77,0,0,1-4.92,0,11.77,11.77,0,0,1,4.92,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.37,149.54a2,2,0,1,1-2-2A2,2,0,0,1,513.37,149.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.3,199.8c0,.15-18.48.26-41.26.26s-41.26-.11-41.26-.26,18.47-.26,41.26-.26S568.3,199.66,568.3,199.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 532.14,
    cy: 207.63,
    rx: 33.68,
    ry: 3.38
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-9--inject-29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M532.81,228.8l5.78-.92-.05-8.64s6.22-1.08,6.19-7.33c0-3-.56-9.22-1.12-14.83a11.64,11.64,0,0,0-11.79-10.49h-.6c-6.49.5-9.69,6.29-9,12.76l.95,29.27Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.54,219.24a14.52,14.52,0,0,1-8.18-2.17s2,4.46,8.23,3.78Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.55,202.3a.89.89,0,0,1-.85.91.84.84,0,0,1-.93-.78.89.89,0,0,1,.84-.92A.87.87,0,0,1,541.55,202.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.41,199.83c-.11.11-.79-.37-1.75-.35s-1.65.51-1.76.39.06-.26.36-.49a2.46,2.46,0,0,1,1.41-.46,2.32,2.32,0,0,1,1.39.42C542.36,199.56,542.47,199.77,542.41,199.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.55,202.47a.9.9,0,0,1-.84.92.87.87,0,0,1-.94-.79.9.9,0,0,1,.84-.92A.86.86,0,0,1,532.55,202.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.18,199.73c-.1.13-.83-.28-1.78-.16s-1.59.69-1.71.59,0-.27.3-.53a2.46,2.46,0,0,1,1.35-.61,2.37,2.37,0,0,1,1.44.27C533.1,199.48,533.22,199.67,533.18,199.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.51,207.56a5.91,5.91,0,0,1,1.55-.31c.25,0,.48-.08.52-.25a1.36,1.36,0,0,0-.18-.73l-.76-1.85a31.9,31.9,0,0,1-1.71-4.85,33.83,33.83,0,0,1,2.1,4.7c.25.65.49,1.27.73,1.87a1.45,1.45,0,0,1,.14,1,.6.6,0,0,1-.4.36,1.68,1.68,0,0,1-.41.07A6.48,6.48,0,0,1,536.51,207.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533,196.34c-.09.26-1.05.15-2.17.31s-2,.48-2.18.25.08-.36.45-.62a3.64,3.64,0,0,1,1.61-.6,3.69,3.69,0,0,1,1.7.17C532.78,196,533,196.21,533,196.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.12,197.17c-.17.22-.83,0-1.63,0s-1.46.17-1.62-.05,0-.33.32-.55a2.31,2.31,0,0,1,1.31-.38,2.26,2.26,0,0,1,1.31.42C542.09,196.84,542.19,197.06,542.12,197.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.8,204c-.11,0-4.31-1.19-4.1,3.08s4.45,3.17,4.45,3S522.8,204,522.8,204Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.77,208.55s-.07,0-.19.12a.73.73,0,0,1-.56,0,1.82,1.82,0,0,1-.93-1.6,2.53,2.53,0,0,1,.15-1.08.86.86,0,0,1,.53-.59.37.37,0,0,1,.45.18c.06.11,0,.2.06.21s.09-.08.05-.25a.44.44,0,0,0-.18-.26.54.54,0,0,0-.42-.09,1,1,0,0,0-.74.7,2.6,2.6,0,0,0-.2,1.2,1.93,1.93,0,0,0,1.18,1.79.79.79,0,0,0,.67-.15C521.77,208.65,521.78,208.55,521.77,208.55Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.7,208.27c.15,0,.17,1,1.08,1.76s2,.58,2,.73-.24.21-.71.23a2.6,2.6,0,0,1-1.69-.56,2.28,2.28,0,0,1-.84-1.47C533.52,208.53,533.63,208.27,533.7,208.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.63,189.17a2.5,2.5,0,0,0-1.43-1.87,3.94,3.94,0,0,0-.09-.7,3.15,3.15,0,0,0-3.14-2.44,3.07,3.07,0,0,0-5.26-1.38,3.67,3.67,0,0,0-4-.46.86.86,0,0,0-.4.33.42.42,0,0,0,0,.33,2.33,2.33,0,0,0-1.86-1,2.36,2.36,0,0,0-.75.13A2.58,2.58,0,0,0,529,183a3.71,3.71,0,0,0-4.47,2.07,3.51,3.51,0,0,0-3,2.48,2.58,2.58,0,0,0-1.84,4.06s-3,.73-2.15,3.39c.42,1.35,2.25,1.08,2.25,1.08l2.44,8.58c0,.05.56,1.05,1.07.82a2.81,2.81,0,0,0,1.09-1.24,6.05,6.05,0,0,0,.86-1.7,1.48,1.48,0,0,0-.62-1.67,2.21,2.21,0,0,0,1.32-1.79,6.47,6.47,0,0,0-.17-2.31c-.22-1.12-.44-2.24-.67-3.37a4.28,4.28,0,0,0,3.65-2.48,2.44,2.44,0,0,0,3.52-.94,3.19,3.19,0,0,0,3.91,1.9c-.16.89,1.44,1.68,2.32,1.9a3.19,3.19,0,0,0,1.95-.42,5.1,5.1,0,0,0,1.74.59h.09c1.21.09,2.36-1,2.93-2.09a2.23,2.23,0,0,0,.92-.12A2.46,2.46,0,0,0,547.63,189.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.17,185.16a.81.81,0,0,1,.11.17,2.18,2.18,0,0,1,.2.56,2.71,2.71,0,0,1,0,1A2.52,2.52,0,0,1,542,188a2.18,2.18,0,0,1-1.31.75,2.58,2.58,0,0,1-1.71-.32,2.13,2.13,0,0,1-.7-.64,1.42,1.42,0,0,1-.23-.44,1,1,0,0,1,0-.53.68.68,0,0,1,.35-.41,1,1,0,0,1,.54-.08,1.36,1.36,0,0,1,.51.18,1.57,1.57,0,0,1,.42.35,2,2,0,0,1,.32,2,2.46,2.46,0,0,1-1.39,1.32,3.05,3.05,0,0,1-1.73.15,4.59,4.59,0,0,1-1.42-.51,8.63,8.63,0,0,1-1.73-1.33l-.43-.41a1.42,1.42,0,0,1-.14-.16l.16.13.44.4a10.06,10.06,0,0,0,1.75,1.28,4.75,4.75,0,0,0,1.39.49,3.12,3.12,0,0,0,1.67-.16,2.41,2.41,0,0,0,1.3-1.25,1.88,1.88,0,0,0-.3-1.86,2,2,0,0,0-.38-.32,1.33,1.33,0,0,0-.46-.16.8.8,0,0,0-.46.07.51.51,0,0,0-.27.32,1.06,1.06,0,0,0,.23.86,2.1,2.1,0,0,0,.66.6,2.49,2.49,0,0,0,1.62.31,2,2,0,0,0,1.25-.69,2.5,2.5,0,0,0,.53-1.09,2.62,2.62,0,0,0,0-.92A2.55,2.55,0,0,0,542.17,185.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "506.01 230.13 510.92 242.24 506.28 274.84 504.06 290.73 495.34 290.73 496.52 272.81 499.32 248.47 506.01 230.13",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "557.38 234.47 551.8 242.24 555.13 274.03 558.22 290.73 567.03 290.73 564.89 272 563.4 248.47 557.38 234.47",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.52,257s1.59-10.33,2.63-14,3.37-11.59,6.14-14.15,4.62-2.3,9.6-3.91c3.74-1.2,6.77-2.29,6.77-2.29l1.15-1.55c3.13,8.38,13.72,6.4,15.73,0l.94,1.48s15.65,5.17,18.16,9,8.25,25.73,8.25,25.73l-14.41.95.29-7.44s-2,9.06-1.3,16.19c.6,6.27,2,23.73,2,23.73l-42.62-.13s1.21-21.47,1.36-25.55c.12-3-.78-14.88-.78-14.88l-.93,8.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.36,227.34a6.41,6.41,0,0,1-1.14.55l-3.14,1.41c-1.31.62-2.92,1.31-4.59,2.2a12.47,12.47,0,0,0-4.51,4.06,14,14,0,0,0-1.92,5.78,26.46,26.46,0,0,0,.13,5c.13,1.37.24,2.52.33,3.43a4.93,4.93,0,0,1,0,1.27,7.64,7.64,0,0,1-.24-1.24c-.13-.81-.31-2-.5-3.42a24.25,24.25,0,0,1-.23-5.14,13.88,13.88,0,0,1,2-6,12.57,12.57,0,0,1,4.72-4.2c1.73-.9,3.33-1.54,4.67-2.11s2.45-1,3.21-1.27A5.74,5.74,0,0,1,525.36,227.34Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.77,250.77a5.18,5.18,0,0,1,0-1.31c0-.84.13-2.06.28-3.56a29.21,29.21,0,0,0,.13-5.23,11.57,11.57,0,0,0-1.95-5.93,12.67,12.67,0,0,0-5-3.85c-1.79-.83-3.45-1.51-4.84-2.09l-3.3-1.32a10.26,10.26,0,0,1-1.21-.5,4.77,4.77,0,0,1,1.28.31c.8.25,2,.64,3.37,1.17s3.08,1.17,4.9,2a13,13,0,0,1,5.18,4,11.86,11.86,0,0,1,2,6.21,26.53,26.53,0,0,1-.25,5.31c-.19,1.49-.36,2.69-.44,3.52A8.31,8.31,0,0,1,551.77,250.77Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.48,222.51a9.58,9.58,0,0,1-12.65,5.62,8.36,8.36,0,0,1-5.11-5.32l1.09-1.76a8,8,0,0,0,8.1,5.56c6.06-.25,7.44-5.68,7.63-5.56l.94,1.48",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.45,224a12.16,12.16,0,0,1-1.63.59L516.31,226l-3.12,1a36.85,36.85,0,0,0-3.53,1.2,9.9,9.9,0,0,0-5.85,5.69A39.25,39.25,0,0,0,502.3,238c-.45,1.36-.85,2.69-1.22,4-.74,2.53-1.36,4.82-1.87,6.75s-.89,3.41-1.19,4.58a14.1,14.1,0,0,1-.47,1.67,1.52,1.52,0,0,1,0-.45c.05-.29.13-.72.24-1.27.21-1.09.56-2.68,1-4.62s1-4.25,1.77-6.8c.36-1.27.75-2.6,1.19-4a39,39,0,0,1,1.53-4.2,11.37,11.37,0,0,1,2.54-3.74,11.58,11.58,0,0,1,3.6-2.18,37.27,37.27,0,0,1,3.58-1.18l3.14-.9,4.56-1.27A10.83,10.83,0,0,1,522.45,224Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.53,254.46a9.78,9.78,0,0,1-.67-1.56l-1.62-4.31c-1.37-3.64-3.14-8.74-5.21-14.27a7.56,7.56,0,0,0-1.06-1.84,7.71,7.71,0,0,0-1.52-1.39,30.13,30.13,0,0,0-3.44-2c-2.26-1.21-4.37-2.16-6.16-2.93l-4.24-1.79a11.7,11.7,0,0,1-1.54-.7,11,11,0,0,1,1.61.51c1,.37,2.51.91,4.32,1.64s3.94,1.65,6.23,2.84a29.45,29.45,0,0,1,3.52,2.06,8.61,8.61,0,0,1,1.63,1.47,8.33,8.33,0,0,1,1.13,2c2.1,5.59,3.79,10.67,5.08,14.35.6,1.78,1.09,3.26,1.46,4.37A11.57,11.57,0,0,1,564.53,254.46Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.85,250.27a3.47,3.47,0,0,1,.53,1.92,3.84,3.84,0,0,1-.77,2.36,4.88,4.88,0,0,1-2.19,1.57,9.82,9.82,0,0,1-6.48,0,4.88,4.88,0,0,1-2.19-1.57,3.84,3.84,0,0,1-.77-2.36,3.47,3.47,0,0,1,.53-1.92,4.29,4.29,0,0,1,1.51-1.41,3.51,3.51,0,0,1-1.13-1.24,3.35,3.35,0,0,1-.4-1.64,3.57,3.57,0,0,1,.71-2.19,4.57,4.57,0,0,1,2-1.46,8.9,8.9,0,0,1,5.94,0,4.57,4.57,0,0,1,2,1.46,3.57,3.57,0,0,1,.71,2.19,3.45,3.45,0,0,1-.39,1.64,3.64,3.64,0,0,1-1.14,1.24A4.2,4.2,0,0,1,535.85,250.27Zm-4.11,3.09a1.74,1.74,0,0,0,0-2.59,2.78,2.78,0,0,0-3.12,0,1.74,1.74,0,0,0,0,2.59,2.77,2.77,0,0,0,3.12,0Zm-2.78-8.3a1.34,1.34,0,0,0-.47,1.11,1.36,1.36,0,0,0,.46,1.09,1.82,1.82,0,0,0,1.23.4,1.91,1.91,0,0,0,1.25-.4,1.55,1.55,0,0,0,0-2.2,1.86,1.86,0,0,0-1.25-.4A1.79,1.79,0,0,0,529,245.06Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "496.52 256.94 496.98 254.08 509.82 255.54 509.49 258.5 496.52 256.94",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "551.48 258.21 551.8 255.88 565.17 254.56 565.89 257.26 551.48 258.21",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 542.6,
    y: 238.54,
    width: 4.69,
    height: 3.11,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.46,242.63a11.34,11.34,0,0,1-4.92,0,11.77,11.77,0,0,1,4.92,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.15,240.57a2,2,0,1,1-2-2A2,2,0,0,1,519.15,240.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.45,290.73c0,.15-18.48.26-41.26.26s-41.26-.11-41.26-.26,18.47-.26,41.26-.26S572.45,290.59,572.45,290.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 531.21,
    cy: 299.43,
    rx: 33.68,
    ry: 3.38
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-8--inject-29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M451.53,267.24l-1.15-.36a2.25,2.25,0,0,0-1.67-.07c-.49.25-.76.82-1.28,1s-1.23-.28-1.85-.13-.95.77-1.54.88-1-.14-1.29.15a1.7,1.7,0,0,0-.19.19,1.57,1.57,0,0,1-1.47.2,2,2,0,0,0-1.5,0,2.32,2.32,0,0,0-.64.75,1.07,1.07,0,0,1-.81.53c-.19,0-.36-.09-.54-.1-.6,0-1,.66-1.49.92s-1.17.1-1.62.44a.83.83,0,0,0-.2,1.1,1.29,1.29,0,0,0,1.08.54,2.72,2.72,0,0,0,1.27-.35,3.11,3.11,0,0,1,1-.43c.82-.13,1.62.59,2.38.26.38-.16.59-.52.86-.81a2.82,2.82,0,0,1,1.49-.82,2.93,2.93,0,0,0,1.11-.28c.4-.25.56-.75,1-1s1,0,1.48-.15c.32-.1.59-.33.91-.41s.94.1,1.4,0,.79-.6,1.27-.65a3.52,3.52,0,0,1,.56,0,.59.59,0,0,0,.51-.18c.08-.12.08-.28.2-.38a.54.54,0,0,1,.31-.09l1.57-.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.18,266.87c-.59-.29-1.36-.55-1.89-.12a6.14,6.14,0,0,1-.5.52c-.45.33-1.1.14-1.59.38s-.64.68-1,1c-.6.46-1.59.45-1.9,1.11-.17.36-.11.88-.48,1a1,1,0,0,1-.43,0,3.41,3.41,0,0,0-1.44.23,1.56,1.56,0,0,0-.69.46c-.33.43-.22,1-.53,1.48-.45.67-1.51.59-2.16,1.09a4.17,4.17,0,0,0-.74.89,10.13,10.13,0,0,1-1.64,1.49,4.14,4.14,0,0,0-1.37,1.7,1.5,1.5,0,0,0,.57,1.83.75.75,0,0,0,.93-.13c.07-.1.1-.21.17-.31a1.59,1.59,0,0,1,.57-.45c.21-.13.41-.35.37-.57s-.15-.3-.05-.42a.32.32,0,0,1,.16-.09c.57-.17,1.28-.28,1.5-.81a3.57,3.57,0,0,0,.11-.74,1.35,1.35,0,0,1,.76-.95c.34-.15.75-.17,1-.44s.2-.78.43-1.11c.4-.55,1.43-.4,1.77-1,.08-.14.11-.32.23-.43.34-.34.92.1,1.37-.07s.44-.64.67-1,.82-.58,1.23-.88.83-1,1.4-1.31,1.16-.27,1.48-.72c.12-.17.19-.39.37-.49a.9.9,0,0,1,.37-.07,2.79,2.79,0,0,0,1.66-.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.57,268.42a4.5,4.5,0,0,0-3.5,1.83,3.1,3.1,0,0,1-.59.71,3.75,3.75,0,0,1-1.33.41,2.75,2.75,0,0,0-1.91,2.26c-.09.67,0,1.51-.57,1.85a1.39,1.39,0,0,0-.31.18c-.36.33.05.92.14,1.42.15.82-.65,1.55-.53,2.38a2.23,2.23,0,0,0,.38.83c.47.72,1,1.42,1.48,2.09.24.31.53.63.9.61.54,0,.74-.71.79-1.26a1.57,1.57,0,0,0-.19-1.15c-.2-.26-.55-.37-.74-.64-.31-.44-.06-1,.1-1.53a4.56,4.56,0,0,0-.16-3.09c.55-.22.66-1,1.21-1.26a2.27,2.27,0,0,0,.46-.16c.36-.22.29-.8.58-1.1s1.09-.27,1.18-.77c0-.15,0-.32,0-.46a.49.49,0,0,1,.27-.22l1.31-.6a1.6,1.6,0,0,0,.67-.47c.29-.4.22-1.06.63-1.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.5,265.41c-.21-.8-.55-1.74-1.33-1.94-.46-.11-.95.09-1.41,0-.87-.25-1.19-1.53-2.06-1.78s-1.77.57-2.51.09c-.38-.25-.52-.76-.86-1.07a1.85,1.85,0,0,0-1.52-.34,4.44,4.44,0,0,1-1.58.09c-.88-.2-1.61-1.12-2.5-1s-1.22.86-1.57,1.55a1.08,1.08,0,0,0-.17.55.88.88,0,0,0,.64.73c.66.24,1.42,0,2.05.34a6.56,6.56,0,0,0,.69.37c.35.11.74,0,1.08.12.67.25.85,1.25,1.51,1.52s1.28-.32,2-.29c.92,0,1.63,1.16,2.54,1,.4-.06.72-.37,1.11-.48a1.31,1.31,0,0,1,1.38.49c.2.28.29.64.51.9a1.46,1.46,0,0,0,1.16.46,4.36,4.36,0,0,0,1.23-.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.3,268.06a5.4,5.4,0,0,0-2.84-2.17,14.23,14.23,0,0,1-1.85-.28,15.39,15.39,0,0,1-1.38-.75,4.88,4.88,0,0,0-3.61.22A9.35,9.35,0,0,1,440,266c-1.11-.05-2.17-.59-3.27-.45a5.27,5.27,0,0,0-1.69.64l-1.86.95a1,1,0,0,0-.5.43c-.14.4.35.73.78.82a3.7,3.7,0,0,0,2.08-.17,4.85,4.85,0,0,1,1.57-.56,11.27,11.27,0,0,1,1.15.14,4.26,4.26,0,0,0,1.41-.24l2.15-.65a3.13,3.13,0,0,1,1.7-.18c.43.11.81.42,1.26.38s.89-.49,1.39-.51,1,.57,1.58.72,1.44-.33,2.1-.11c.45.14.72.57,1.05.89a2.76,2.76,0,0,0,1,.62,5.41,5.41,0,0,0,1.5.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.58,263.24c-.33-.3-.8-.6-.78-1.05a5.65,5.65,0,0,0,.15-.66c0-.41-.46-.64-.68-1s-.19-1-.52-1.34-.92-.33-1.43-.36a1.63,1.63,0,0,1-1.4-.72,5.53,5.53,0,0,1-.28-1.08,2.1,2.1,0,0,0-2.31-1.36,2.19,2.19,0,0,1-.84.06c-.51-.12-.73-.7-1.07-1.09a1.78,1.78,0,0,0-1.95-.44c-.31.12-.6.53-.36.77s.25.11.37.18c.43.25.28.94.59,1.33s1,.36,1.32.79.13.8.35,1.13.87.39,1.35.33,1.09-.07,1.35.34a2.51,2.51,0,0,1,.21.6,1.24,1.24,0,0,0,.8.75c.51.14,1.15,0,1.51.36s.1,1.23.47,1.7.79.34,1.2.5a.4.4,0,0,1,.22.18.47.47,0,0,1,0,.31c-.18.64-.41,1.39,0,1.93a2.81,2.81,0,0,0,.62.51,5.36,5.36,0,0,1,1.69,1.94l.08-2.32A2.34,2.34,0,0,0,453.58,263.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455,255.17a1.51,1.51,0,0,0-1-1.59,1.19,1.19,0,0,0-1.51.92c-.08.77.7,1.51.44,2.24a2.63,2.63,0,0,0-.24.58c0,.51.64.8.74,1.3s-.52,1-.57,1.55.7,1.18.59,1.82a2.18,2.18,0,0,1-.2.5c-.46,1.06.11,2.26.66,3.28l1.41-.49c-.46-1,.76-2.23.11-3.06-.32-.4-1-.59-1-1.09a1,1,0,0,1,.16-.37c.36-.58.71-1.16,1.06-1.74a1.36,1.36,0,0,0,.3-.83c-.07-.65-1-.91-1.17-1.53S454.9,255.68,455,255.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457,263.28c-.23-.45-.88-.47-1.35-.3-1.3.46-2.07,1.77-2.73,3a30.44,30.44,0,0,0-2,4.12,2.61,2.61,0,0,0-.2,1,1,1,0,0,0,.51.82.6.6,0,0,0,.82-.36l.37-.17a19.89,19.89,0,0,1,4-6.68C456.86,264.3,457.27,263.76,457,263.28Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.59,285.27a47.12,47.12,0,0,1-2-7.91,16.47,16.47,0,0,1,.67-8.07c.15-.39,1.38-3,1.79-3s-.47,2.46-.32,2.71a14.12,14.12,0,0,1,1.56,8.19,37.34,37.34,0,0,1-1.66,8",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.84,300.44c0-1.93.05-3.45.07-3.45s6.61-.65,7.06-7.2c.22-3.16.14-9.71,0-15.64a12.23,12.23,0,0,0-11.54-11.92l-.63,0c-6.84,0-10.65,5.82-10.45,12.66l.49,28.94,11.83,3.81Z",
    style: {
      fill: "#aa645b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.91,297a15.81,15.81,0,0,1-8.39-3s1.81,4.89,8.38,4.67Z",
    style: {
      fill: "#814742"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.19,279.72a.92.92,0,0,1-.95.89.89.89,0,0,1-.92-.89.94.94,0,0,1,1-.9A.9.9,0,0,1,473.19,279.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.41,276.79c-.12.11-.8-.45-1.8-.5s-1.78.4-1.88.27.08-.27.41-.48a2.54,2.54,0,0,1,1.51-.38,2.46,2.46,0,0,1,1.44.56C474.38,276.51,474.48,276.74,474.41,276.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.91,279.72a.93.93,0,0,1-1,.89.89.89,0,0,1-.91-.89.94.94,0,0,1,.95-.9A.9.9,0,0,1,463.91,279.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.53,276.64c-.13.11-.81-.45-1.81-.51s-1.78.41-1.88.28.08-.27.42-.49a2.59,2.59,0,0,1,1.51-.37,2.52,2.52,0,0,1,1.43.55C464.49,276.36,464.59,276.59,464.53,276.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.7,284.58a6.49,6.49,0,0,1,1.65-.2c.26,0,.51-.05.56-.22a1.33,1.33,0,0,0-.13-.78c-.2-.63-.42-1.3-.65-2a33.12,33.12,0,0,1-1.41-5.22,35.52,35.52,0,0,1,1.83,5.1c.22.7.42,1.37.62,2a1.47,1.47,0,0,1,.07,1,.67.67,0,0,1-.44.35,1.74,1.74,0,0,1-.44,0A6.36,6.36,0,0,1,467.7,284.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.7,285.11c.16,0,.1,1.09,1,1.92s2.07.78,2.07.93-.28.2-.77.18a2.69,2.69,0,0,1-1.72-.71,2.36,2.36,0,0,1-.77-1.61C464.49,285.36,464.62,285.1,464.7,285.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.7,272.55c-.11.27-1.11.08-2.3.15s-2.16.35-2.31.09.12-.37.52-.61a3.9,3.9,0,0,1,1.73-.5,3.79,3.79,0,0,1,1.78.31C464.55,272.19,464.75,272.42,464.7,272.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.19,273.42c-.19.22-.87-.06-1.71-.12s-1.55.07-1.69-.18.06-.34.38-.54a2.32,2.32,0,0,1,1.4-.3,2.37,2.37,0,0,1,1.34.54C474.19,273.07,474.27,273.31,474.19,273.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.61,279.75c-.11-.06-4.43-1.59-4.54,2.9s4.42,3.67,4.43,3.54S453.61,279.75,453.61,279.75Z",
    style: {
      fill: "#aa645b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.17,284.46s-.08.05-.21.11a.79.79,0,0,1-.59,0,1.94,1.94,0,0,1-.85-1.76,2.45,2.45,0,0,1,.25-1.11.89.89,0,0,1,.6-.59.41.41,0,0,1,.46.23c.05.12,0,.21.05.22s.09-.07.06-.26a.45.45,0,0,0-.17-.29.6.6,0,0,0-.43-.12,1.12,1.12,0,0,0-.83.68,2.61,2.61,0,0,0-.3,1.24,2,2,0,0,0,1.09,2,.86.86,0,0,0,.72-.1C452.16,284.57,452.19,284.47,452.17,284.46Z",
    style: {
      fill: "#814742"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.18,266.66c.74-.39-1.41-2.77-3.18-3.61-2.68-1.27-6.79-2.09-9.29-1.42a10.8,10.8,0,0,0-7.07,5,17.59,17.59,0,0,0-2.12,9,5.28,5.28,0,0,0,.59,2.75c.61,1,1.8,1.65,1.73,3a1.86,1.86,0,0,0,.44,1.38c.81.88,1.83.08,2.3-.74a12.93,12.93,0,0,0,1.28-5.85,13.35,13.35,0,0,0-.22-4.28c-.21-.75-.55-1.46-.71-2.22a2.69,2.69,0,0,1,.35-2.24,3.23,3.23,0,0,1,.37-.36,4.67,4.67,0,0,1,4.66-.81c2.51.93,6.81,2.34,7.95,1.5a6.91,6.91,0,0,0,2-2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436.93 307.29 441.85 319.39 437.2 351.99 434.99 367.88 426.26 367.88 427.44 349.96 430.25 325.62 436.93 307.29",
    style: {
      fill: "#aa645b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "488.3 311.63 482.72 319.39 486.06 351.19 489.14 367.88 497.95 367.88 495.81 349.16 494.32 325.62 488.3 311.63",
    style: {
      fill: "#aa645b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.44,334.13s1.59-10.33,2.63-14,3.37-11.59,6.15-14.14,4.61-2.3,9.6-3.91c3.73-1.21,6.76-2.3,6.76-2.3l1.15-1.55c3.13,8.39,13.72,6.4,15.74,0l.93,1.48s15.65,5.17,18.16,9,8.26,25.73,8.26,25.73l-14.41,1,.28-7.45s-2,9.06-1.3,16.19c.6,6.27,2,23.73,2,23.73l-42.63-.13s1.21-21.46,1.37-25.54c.11-3-.79-14.88-.79-14.88l-.93,8.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.28,304.49a6,6,0,0,1-1.14.55L452,306.45c-1.31.62-2.91,1.31-4.59,2.2a12.36,12.36,0,0,0-4.5,4.06,13.73,13.73,0,0,0-1.92,5.78,25.73,25.73,0,0,0,.12,5.05c.13,1.37.24,2.52.33,3.43a4.93,4.93,0,0,1,0,1.27,7.64,7.64,0,0,1-.24-1.24c-.13-.81-.31-2-.49-3.42a23.52,23.52,0,0,1-.24-5.14,13.77,13.77,0,0,1,2-6,12.47,12.47,0,0,1,4.71-4.2c1.74-.89,3.34-1.54,4.68-2.11s2.44-1,3.21-1.27A5.77,5.77,0,0,1,456.28,304.49Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.69,327.92a5.79,5.79,0,0,1,0-1.31c0-.84.13-2.06.28-3.55a29.32,29.32,0,0,0,.13-5.24,11.65,11.65,0,0,0-1.94-5.93,12.77,12.77,0,0,0-5-3.85c-1.79-.83-3.45-1.51-4.84-2.08l-3.3-1.33a6.82,6.82,0,0,1-1.2-.5,5.32,5.32,0,0,1,1.27.31c.81.25,2,.64,3.37,1.17s3.08,1.18,4.91,2a12.9,12.9,0,0,1,5.17,4,11.89,11.89,0,0,1,2,6.21,26.53,26.53,0,0,1-.25,5.31c-.19,1.49-.35,2.69-.44,3.53A7,7,0,0,1,482.69,327.92Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.4,299.66a9.59,9.59,0,0,1-12.64,5.63,8.4,8.4,0,0,1-5.12-5.32l1.09-1.77a8,8,0,0,0,8.1,5.56c6.06-.25,7.44-5.68,7.64-5.56l.93,1.48",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.38,301.16a12.77,12.77,0,0,1-1.64.59l-4.51,1.43-3.12,1c-1.12.34-2.32.7-3.53,1.2a9.9,9.9,0,0,0-5.85,5.69c-.61,1.37-1.06,2.79-1.51,4.15s-.85,2.69-1.22,4c-.74,2.53-1.36,4.82-1.87,6.75L429,330.47a11,11,0,0,1-.48,1.67,1.53,1.53,0,0,1,0-.45c.05-.29.13-.72.24-1.27.22-1.09.56-2.67,1-4.62s1.05-4.25,1.77-6.8c.36-1.27.75-2.6,1.19-4a38.39,38.39,0,0,1,1.53-4.21,11.37,11.37,0,0,1,2.54-3.74,11.69,11.69,0,0,1,3.6-2.18c1.24-.5,2.46-.85,3.58-1.18l3.14-.9,4.56-1.26A10.05,10.05,0,0,1,453.38,301.16Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.45,331.61a9.34,9.34,0,0,1-.66-1.56c-.42-1.1-1-2.55-1.63-4.31C491.8,322.1,490,317,488,311.47a8.08,8.08,0,0,0-1.05-1.84,8.78,8.78,0,0,0-1.53-1.39,30.13,30.13,0,0,0-3.44-2c-2.26-1.21-4.37-2.16-6.15-2.93l-4.25-1.78a10.79,10.79,0,0,1-1.54-.71,10.74,10.74,0,0,1,1.62.52c1,.36,2.5.91,4.31,1.63s3.94,1.65,6.24,2.84a29.35,29.35,0,0,1,3.51,2.06,8.68,8.68,0,0,1,1.63,1.47,8.33,8.33,0,0,1,1.13,2c2.1,5.59,3.8,10.67,5.08,14.35.6,1.79,1.09,3.26,1.47,4.37A12.19,12.19,0,0,1,495.45,331.61Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.2,328.54a3.92,3.92,0,0,1,.95,2.65,4.26,4.26,0,0,1-.69,2.34,4.79,4.79,0,0,1-2.08,1.75,8.06,8.06,0,0,1-3.46.66,12.18,12.18,0,0,1-3-.37,8.74,8.74,0,0,1-2.56-1l1.47-3a6.56,6.56,0,0,0,1.89.88,7.53,7.53,0,0,0,2.07.31,3.05,3.05,0,0,0,1.65-.39,1.24,1.24,0,0,0,.62-1.1c0-.93-.73-1.39-2.19-1.39h-1.69v-2.55l2.55-2.76h-5.63v-3.12h10.32v2.53l-3,3.19A4.78,4.78,0,0,1,468.2,328.54Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "427.44 334.09 427.9 331.24 440.74 332.69 440.41 335.65 427.44 334.09",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "482.41 335.37 482.72 333.04 496.09 331.71 496.81 334.41 482.41 335.37",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 473.52,
    y: 315.69,
    width: 4.69,
    height: 3.11,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.38,319.79a11.77,11.77,0,0,1-4.92,0,11.77,11.77,0,0,1,4.92,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.07,317.72a2,2,0,1,1-2-2A2,2,0,0,1,450.07,317.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.37,367.88c0,.15-18.48.26-41.26.26s-41.26-.11-41.26-.26,18.47-.26,41.26-.26S503.37,367.74,503.37,367.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 465.47,
    cy: 374.21,
    rx: 33.68,
    ry: 3.38
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-7--inject-29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.78,335.2c-.92-2.35-4.4-3.89-3.93-6.35.31-1.65,2.36-2.68,2.69-4.33.23-1.14-.43-2.33-.09-3.45.47-1.53,2.53-2.18,3.4-3.55.61-.95.57-2.12,1.06-3.12s2-1.78,2.87-1L366.93,332c0,4.47.47,8.86.43,13.33-1.3.91-3.35,0-4-1.37s-.25-2.92.14-4.36A6.89,6.89,0,0,0,363.78,335.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.12,334.68l3.66-19.35,2.53-4.47c.32-2.08,3.7-1.57,5.67-.31s2.64,5.66,2.68,7.76a11.66,11.66,0,0,0,1.07,4.59c.93,2.72,3.7,5.05,3.44,7.87-.18,2-1.84,3.65-2.46,5.57-.77,2.41.16,4.94.19,7.43s-1.48,5.46-4.39,5.65l-.26-2.08a9.34,9.34,0,0,1-10.4-1.27C375.81,343.07,376.38,338.59,377.12,334.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.26,320.72a11.83,11.83,0,0,0-11.78-10.9h-.61c-6.61.38-10,6.2-9.43,12.8l1.14,26.45h0L382.69,355l-.05-11.81s6.36-1,6.45-7.33C389.13,332.77,388.71,326.44,388.26,320.72Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.69,343.16a15.42,15.42,0,0,1-8.31-2.46s1.94,4.58,8.28,4Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386,326.08a.89.89,0,0,1-.87.91.87.87,0,0,1-.94-.82.91.91,0,0,1,.88-.91A.86.86,0,0,1,386,326.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.52,323.17c-.11.12-.8-.39-1.78-.39s-1.69.49-1.79.37.06-.27.37-.49a2.42,2.42,0,0,1,1.44-.44,2.34,2.34,0,0,1,1.41.46C387.47,322.91,387.57,323.12,387.52,323.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.83,326.19a.92.92,0,0,1-.88.92.88.88,0,0,1-.93-.82.92.92,0,0,1,.88-.92A.86.86,0,0,1,376.83,326.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.71,323c-.11.11-.8-.4-1.77-.4s-1.7.49-1.8.37.06-.26.37-.49A2.44,2.44,0,0,1,376,322a2.39,2.39,0,0,1,1.42.46C377.67,322.73,377.77,322.94,377.71,323Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.82,331.24a6.13,6.13,0,0,1,1.59-.28c.25,0,.48-.08.52-.25a1.26,1.26,0,0,0-.16-.74c-.23-.6-.48-1.23-.73-1.9a32,32,0,0,1-1.65-5,32.87,32.87,0,0,1,2,4.83c.25.67.48,1.3.7,1.91a1.4,1.4,0,0,1,.13,1,.61.61,0,0,1-.41.36,1.76,1.76,0,0,1-.42.06A6.22,6.22,0,0,1,380.82,331.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378,331.91c.15,0,.15,1,1.06,1.8s2,.64,2,.79-.25.21-.73.22a2.67,2.67,0,0,1-1.7-.6,2.34,2.34,0,0,1-.83-1.51C377.75,332.17,377.87,331.9,378,331.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.8,319.4c-.09.26-1.07.13-2.21.27s-2.08.45-2.23.21.1-.37.47-.62a3.93,3.93,0,0,1,3.38-.37C377.63,319.06,377.85,319.27,377.8,319.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.63,319.87c-.17.22-.84,0-1.65,0s-1.49.15-1.65-.08,0-.34.34-.55a2.4,2.4,0,0,1,1.34-.36,2.27,2.27,0,0,1,1.32.45C386.62,319.53,386.71,319.76,386.63,319.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.68,317.39a4.64,4.64,0,0,1,1.7-3l3.86,0c-1.2.66-.65,2.27-.39,2.62a5.84,5.84,0,0,1-1.79,6.83l.19,3.87c.15,1-.22,1.78-1.22,1.78h0s-1.12-2.9-1.39-4.09C365.12,323.1,364.41,319.74,364.68,317.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.39,327.31c-.11-.05-4.36-1.3-4.23,3s4.46,3.32,4.46,3.2S367.39,327.31,367.39,327.31Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.63,331.94s-.07.06-.2.12a.76.76,0,0,1-.57,0,1.88,1.88,0,0,1-.91-1.66,2.58,2.58,0,0,1,.18-1.09.84.84,0,0,1,.55-.59.38.38,0,0,1,.45.19c.06.12,0,.21.06.21s.09-.07.05-.25a.45.45,0,0,0-.18-.27.53.53,0,0,0-.42-.09,1.08,1.08,0,0,0-.77.69,2.56,2.56,0,0,0-.22,1.22,1.94,1.94,0,0,0,1.16,1.84.82.82,0,0,0,.68-.13C366.63,332.05,366.65,332,366.63,331.94Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.46,314.2h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.85,319.72c.12-1.1-.29-2.2,0-3.25a5.52,5.52,0,0,1,2.09-3,7.37,7.37,0,0,1,2.08-.85s0,.05,0,0c0-1.82,3.17-4.56,4.21-5.06,3.32-1.59,5.06-.16,8.71.34s7.51,2.27,8.73,5.74a2.62,2.62,0,0,1-1.6.67,13.15,13.15,0,0,1,2.2,6.84,26.28,26.28,0,0,1-1,7.87,5.37,5.37,0,0,0-.91-4.06,21.14,21.14,0,0,1-2.14-3.7c-.69-2-.66-3.65-1.73-5.47s-3.71-2-3.71-2c-1.5.34-3-.55-4.4-1.22a5.26,5.26,0,0,0-3.94,0c-1.26.44-1.37.87-2.48,1.62a4,4,0,0,0-.84,1.89,5.52,5.52,0,0,0,.36,1.57c1.09,2.14.21,4.86-1.46,6.59a17.4,17.4,0,0,1-6.17,3.62A32.42,32.42,0,0,0,364.85,319.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.39,344.18l.57-9.66a11.55,11.55,0,0,1,.38-2.68c.19-.65.5-1.27.63-1.93a6.58,6.58,0,0,0-.25-2.71,10.44,10.44,0,0,1-.49-2.69,3,3,0,0,1,1.09-2.45l2.87-.74c-.94,1.5-.62,3.4-.07,5.06s1.29,3.33,1.13,5.05c-.21,2.22-1.9,4.2-1.8,6.43a11.46,11.46,0,0,0,1,3.37,4.71,4.71,0,0,1,.26,3.43,1.65,1.65,0,0,1-.89.94,2.51,2.51,0,0,1-1.19,0l-2.22-.29a1.34,1.34,0,0,1-.84-.3A1.18,1.18,0,0,1,365.39,344.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.77,349.83s.2,0,.53-.19a1.71,1.71,0,0,0,.9-1.23,2.68,2.68,0,0,0-1-2.19,10.28,10.28,0,0,1-2.34-2.61,4.82,4.82,0,0,1,.36-4.22,19.86,19.86,0,0,1,3-3.82,9,9,0,0,0,2.58-4.41c.27-1.77-.69-3.52-1.69-5.17s-2.12-3.35-2.29-5.31.28-3.68.19-5.34a5.89,5.89,0,0,0-.54-2.31,6.36,6.36,0,0,0-1.37-1.78,9.77,9.77,0,0,0-3.52-2.08,5.93,5.93,0,0,0-3.33-.18,3.33,3.33,0,0,0-2,1.47A2,2,0,0,0,379,312c.09.36.22.52.19.53a1.23,1.23,0,0,1-.3-.5,2.15,2.15,0,0,1,.2-1.66,3.52,3.52,0,0,1,2.07-1.65,6.08,6.08,0,0,1,3.52.11,10.17,10.17,0,0,1,3.7,2.11,6.9,6.9,0,0,1,1.49,1.9,6.3,6.3,0,0,1,.61,2.49c.1,1.74-.34,3.52-.16,5.31s1.22,3.42,2.22,5.1a16.18,16.18,0,0,1,1.36,2.61,5.67,5.67,0,0,1,.39,2.9,9.38,9.38,0,0,1-2.73,4.66,19.84,19.84,0,0,0-3,3.69,4.46,4.46,0,0,0-.4,3.87,10.29,10.29,0,0,0,2.21,2.56,2.9,2.9,0,0,1,1,2.43,1.75,1.75,0,0,1-1,1.28A1,1,0,0,1,389.77,349.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.24,307.42c0,.08-.31.2-.72.57a2.51,2.51,0,0,0-.23,3.66c.36.41.68.58.64.65s-.41,0-.9-.38a2.72,2.72,0,0,1-.94-2.18,2.68,2.68,0,0,1,1.21-2.05C376.83,307.36,377.23,307.36,377.24,307.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.05,309.18c.14,0,0,.83.35,1.69s1,1.3,1,1.43-.25,0-.56-.15a2.43,2.43,0,0,1-1-2.46C371.84,309.34,372,309.15,372.05,309.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.41,345.27a.86.86,0,0,1-.42,0,2.15,2.15,0,0,1-1.07-.53,2.84,2.84,0,0,1-.91-1.67,5,5,0,0,1,.41-2.48,25.45,25.45,0,0,0,1.08-2.73,3.73,3.73,0,0,0-.53-3.09,29.16,29.16,0,0,0-2.38-2.88,8.94,8.94,0,0,1-1.1-1.73,3.74,3.74,0,0,1-.34-2.15,3.54,3.54,0,0,1,1.05-1.91,12.29,12.29,0,0,1,1.59-1.27,6.67,6.67,0,0,0,2.56-2.52,7.14,7.14,0,0,0,.38-3.25,12,12,0,0,1,.08-3,3.71,3.71,0,0,1,1.23-2.2,3.45,3.45,0,0,1,1.73-.77,2.33,2.33,0,0,1,1.19.11,1,1,0,0,1,.36.21,3,3,0,0,0-1.52-.12,3.36,3.36,0,0,0-1.57.8,3.41,3.41,0,0,0-1.06,2,11.74,11.74,0,0,0,0,2.91,7.56,7.56,0,0,1-.37,3.47,7.13,7.13,0,0,1-2.7,2.75c-1,.74-2.21,1.57-2.43,2.84a4.77,4.77,0,0,0,1.33,3.48,28.56,28.56,0,0,1,2.39,2.95,4.9,4.9,0,0,1,.66,1.71,4.2,4.2,0,0,1-.12,1.74,23,23,0,0,1-1.16,2.76,4.68,4.68,0,0,0-.46,2.3,2.62,2.62,0,0,0,.76,1.56A2.73,2.73,0,0,0,366.41,345.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.66,344a1.7,1.7,0,0,0,.84-.91,2.12,2.12,0,0,0-.08-1.43c-.2-.55-.54-1.17-.76-1.92a8.08,8.08,0,0,1,.36-5.38c.39-1,1.12-1.8,1.51-2.75a2.08,2.08,0,0,0,.09-1.45,6.17,6.17,0,0,0-.84-1.41,3.53,3.53,0,0,1-.7-1.69,5,5,0,0,1,.2-1.74,9.83,9.83,0,0,0,.61-3c-.08-1.94-.84-3.7-.69-5.3a3.93,3.93,0,0,1,.64-2,3.45,3.45,0,0,1,1.18-1.08,2.45,2.45,0,0,1,1-.31.79.79,0,0,1,.35,0,4.76,4.76,0,0,0-1.2.49,3.46,3.46,0,0,0-1.56,2.93,9.3,9.3,0,0,0,.32,2.41,15.79,15.79,0,0,1,.49,2.85,10.16,10.16,0,0,1-.6,3.16,4.57,4.57,0,0,0-.18,1.55,3,3,0,0,0,.62,1.45,7,7,0,0,1,.9,1.54,2.55,2.55,0,0,1-.11,1.81c-.46,1.07-1.17,1.86-1.54,2.76a7.75,7.75,0,0,0-.44,5.08c.18.72.49,1.33.67,1.93a2.25,2.25,0,0,1,0,1.6,1.47,1.47,0,0,1-.69.74A.61.61,0,0,1,367.66,344Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350.05 354.74 354.97 366.85 350.32 399.44 348.11 415.34 339.38 415.34 340.56 397.42 343.37 373.07 350.05 354.74",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "401.42 359.08 395.84 366.85 399.18 398.64 402.26 415.34 411.07 415.34 408.93 396.61 407.44 373.07 401.42 359.08",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.66,381.28s1.58-9.79,2.62-13.46,3.36-11.58,6.14-14.14,4.62-2.3,9.6-3.91c3.73-1.2,6.76-2.29,6.76-2.29l1.16-1.55c3.13,8.38,13.71,6.4,15.73,0l.93,1.47s15.66,5.17,18.17,9S410,381.78,410,381.78l-13.78,1-.34-7.15s-2,9.06-1.3,16.19c.6,6.27,2,23.56,2,23.56l-42.61,0s1.21-21.47,1.37-25.55c.11-3-.79-14.88-.79-14.88l-1,8Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.52,347.11a9.59,9.59,0,0,1-12.64,5.63,8.37,8.37,0,0,1-5.12-5.32l1.09-1.76a8,8,0,0,0,8.1,5.55c6.06-.24,7.44-5.67,7.64-5.55l.93,1.47",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.5,348.61a10.28,10.28,0,0,1-1.64.6l-4.51,1.42-3.12,1c-1.12.35-2.32.71-3.53,1.21a11.21,11.21,0,0,0-3.43,2.11,11.09,11.09,0,0,0-2.42,3.58c-.61,1.37-1.06,2.79-1.51,4.15s-.85,2.69-1.22,3.95c-.74,2.53-1.36,4.83-1.87,6.76s-.88,3.41-1.18,4.57a10.54,10.54,0,0,1-.48,1.67,1.47,1.47,0,0,1,0-.44c.05-.3.13-.72.24-1.27.22-1.1.56-2.68,1-4.62s1.05-4.25,1.77-6.8c.36-1.27.75-2.61,1.19-4a39.15,39.15,0,0,1,1.53-4.21,11.43,11.43,0,0,1,2.54-3.73,11.73,11.73,0,0,1,3.6-2.19c1.24-.5,2.46-.84,3.58-1.17l3.14-.9L364.8,349A11.48,11.48,0,0,1,366.5,348.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.57,379.07a9.87,9.87,0,0,1-.66-1.56c-.42-1.1-1-2.56-1.63-4.32-1.36-3.63-3.13-8.73-5.21-14.26a7.87,7.87,0,0,0-1.05-1.84,8.05,8.05,0,0,0-1.53-1.39,30.24,30.24,0,0,0-3.44-2.05c-2.26-1.2-4.37-2.15-6.15-2.92l-4.25-1.79a11.7,11.7,0,0,1-1.54-.7,9.82,9.82,0,0,1,1.62.51c1,.37,2.5.91,4.31,1.64s3.94,1.65,6.24,2.84a30.63,30.63,0,0,1,3.51,2,7.21,7.21,0,0,1,2.76,3.44c2.1,5.59,3.8,10.67,5.08,14.35l1.47,4.37A12.19,12.19,0,0,1,408.57,379.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.92,383.5a5.84,5.84,0,0,1-2.23-2.56,10.23,10.23,0,0,1,0-8,5.9,5.9,0,0,1,2.23-2.56,6.52,6.52,0,0,1,6.51,0,5.9,5.9,0,0,1,2.23,2.56,10.23,10.23,0,0,1,0,8,5.84,5.84,0,0,1-2.23,2.56,6.46,6.46,0,0,1-6.51,0Zm4.89-3.42a8.46,8.46,0,0,0,0-6.26,1.85,1.85,0,0,0-3.27,0,8.46,8.46,0,0,0,0,6.26,1.85,1.85,0,0,0,3.27,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.81,369.81v14.28h-4V372.93h-2.66v-3.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.53 381.55 340.99 378.69 353.82 380.14 353.49 383.11 340.53 381.55",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "396.24 382.85 396.11 380.03 409.21 379.17 409.94 381.87 396.24 382.85",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.56,381.55l.87.08,2.51.28,9.6,1.09-.12.1c.26-2.44.57-5.26.9-8.37h.27c.2,2.55.4,5.33.58,8.33.09,1.49.18,3,.23,4.65a49.05,49.05,0,0,1-.14,5c-.35,6.78-.74,14.34-1.16,22.5l-.22-.22,42.63.14-.25.27c-.5-5.94-1-12.1-1.55-18.42-.14-1.58-.27-3.18-.41-4.78a41.49,41.49,0,0,1-.17-4.87,68.14,68.14,0,0,1,1-9.82c.13-.72.26-1.44.41-2.15l.4-1.91.11,1.95q.23,3.78.43,7.47l-.27-.24,13.69-1-.23.32c-1.1-4.13-2.23-8.19-3.4-12.15s-2.36-7.86-3.84-11.52c-.2-.44-.37-.91-.61-1.33l-.34-.63c-.14-.19-.3-.36-.45-.54a10.7,10.7,0,0,0-1.05-.95c-.4-.27-.79-.55-1.19-.81a43.64,43.64,0,0,0-5.07-2.64c-3.45-1.55-6.91-2.86-10.29-4l-.08,0,0-.07c-.32-.51-.63-1-.93-1.48l.4,0a8,8,0,0,1-3.41,4.27,9.31,9.31,0,0,1-5.09,1.43,7.93,7.93,0,0,1-4.79-1.69,9.54,9.54,0,0,1-2.84-4l.34,0c-.41.56-.79,1.06-1.16,1.55l0,.05-.06,0-5.07,1.71c-1.64.57-3.27,1.08-4.87,1.49a18,18,0,0,0-4.49,1.54,8.83,8.83,0,0,0-3.19,3,35.56,35.56,0,0,0-3.26,7.36c-.79,2.36-1.47,4.54-1.95,6.52-.89,4-1.4,7.15-1.79,9.27-.18,1.05-.32,1.86-.42,2.42s-.16.83-.16.83,0-.29.11-.84.2-1.37.36-2.43c.35-2.13.83-5.28,1.69-9.3.47-2,1.14-4.18,1.91-6.55a35,35,0,0,1,3.26-7.45,9.17,9.17,0,0,1,3.28-3.14,18.24,18.24,0,0,1,4.56-1.59c1.59-.41,3.2-.92,4.84-1.5l5.06-1.72-.09.06c.37-.5.74-1,1.16-1.55l.2-.28.14.33a9,9,0,0,0,2.72,3.81,7.42,7.42,0,0,0,4.55,1.59,8.81,8.81,0,0,0,4.85-1.37,7.57,7.57,0,0,0,3.21-4l.15-.46.26.41.93,1.47-.12-.09c3.41,1.15,6.87,2.45,10.34,4a43.84,43.84,0,0,1,5.13,2.66c.42.27.82.56,1.23.84a9.64,9.64,0,0,1,1.12,1c.17.2.34.39.5.6l.36.66c.25.45.42.91.64,1.37,1.5,3.71,2.67,7.6,3.86,11.56s2.31,8,3.41,12.17l.08.3-.31,0-13.69,1H396l0-.26q-.21-3.71-.43-7.47l.52,0c-.15.7-.28,1.42-.41,2.13a68.76,68.76,0,0,0-1,9.74,40.48,40.48,0,0,0,.17,4.81c.13,1.61.27,3.2.4,4.78.53,6.33,1,12.49,1.54,18.43l0,.27h-.28l-42.62-.21h-.23l0-.23c.45-8.17.86-15.71,1.23-22.5.08-1.7.24-3.34.16-4.93s-.12-3.15-.2-4.64c-.17-3-.36-5.78-.54-8.33h.27c-.35,3.11-.67,5.92-.95,8.36l0,.11h-.1L343.87,382l-2.48-.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.64,
    y: 363.15,
    width: 4.69,
    height: 3.11,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.5,367.24a11.77,11.77,0,0,1-4.92,0,11.77,11.77,0,0,1,4.92,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.19,365.17a2,2,0,1,1-2-2A2,2,0,0,1,363.19,365.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.49,415.34c0,.14-18.48.26-41.26.26s-41.26-.12-41.26-.26,18.47-.26,41.26-.26S416.49,415.2,416.49,415.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 376.55,
    cy: 422.37,
    rx: 33.68,
    ry: 3.38
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-6--inject-29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M367.15,109.05a2.15,2.15,0,0,1,.44-1,4.87,4.87,0,0,1,3-1.94,9,9,0,0,1-2.77-1.93,3.31,3.31,0,0,1-.78-3.14,3.9,3.9,0,0,1,2.43-2.14,7,7,0,0,1,4.55-.31,4.8,4.8,0,0,1,3.24,3.06l-1.45,3.72a8.38,8.38,0,0,1-1.69,4,1.87,1.87,0,0,1-1.69.91,1.38,1.38,0,0,1-1-1.27,4,4,0,0,1,.32-1.69,7.91,7.91,0,0,1-2.9,2.52,1.44,1.44,0,0,1-1.28.16A1,1,0,0,1,367.15,109.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.44,105.21a2.28,2.28,0,0,1,.05-.9,6.09,6.09,0,0,1,1.3-3.3.73.73,0,0,1,.55-.27c.34,0,.48.46.42.8a4.24,4.24,0,0,0-.19,1l-.57,2.4a1.26,1.26,0,0,1-.3.72.76.76,0,0,1-.72.23A.84.84,0,0,1,375.44,105.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.63,121.77a49.08,49.08,0,0,1-2.35-8,17,17,0,0,1,.42-8.27c.13-.4,1.31-3.09,1.73-3.06s-.4,2.52-.24,2.77a14.35,14.35,0,0,1,1.87,8.31,38.1,38.1,0,0,1-1.43,8.27",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.08,136.34l-1-25.2c-.44-7,3.26-13,10.25-13.29l.76,0a12.38,12.38,0,0,1,12.07,11.67c.34,6.08.65,12.83.53,16.09-.24,6.71-7,7.59-7,7.59s0,1.56,0,3.53a7,7,0,0,1-7,5.75C380.45,142.68,378.08,136.34,378.08,136.34Z",
    style: {
      fill: "#aa645b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.68,133.22a16.2,16.2,0,0,1-8.68-2.79s2,4.93,8.73,4.49Z",
    style: {
      fill: "#814742"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.42,115.37a1,1,0,0,1-.95.95.92.92,0,0,1-1-.89,1,1,0,0,1,.94-1A.92.92,0,0,1,397.42,115.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.62,112.5c-.12.13-.83-.43-1.86-.45s-1.8.48-1.91.35.07-.28.41-.51a2.62,2.62,0,0,1,1.53-.44,2.52,2.52,0,0,1,1.48.52C398.58,112.22,398.68,112.45,398.62,112.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388,115.37a1,1,0,0,1-.94.94.91.91,0,0,1-1-.88,1,1,0,0,1,.94-1A.92.92,0,0,1,388,115.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.82,112.61c-.12.12-.83-.43-1.86-.46s-1.8.48-1.91.35.07-.28.41-.51a2.63,2.63,0,0,1,1.53-.43,2.59,2.59,0,0,1,1.48.51C388.78,112.33,388.88,112.55,388.82,112.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392,120.59a6.31,6.31,0,0,1,1.68-.26c.26,0,.51-.07.56-.25a1.31,1.31,0,0,0-.16-.78c-.23-.65-.47-1.32-.73-2a34.15,34.15,0,0,1-1.62-5.28,33.91,33.91,0,0,1,2,5.14c.25.71.48,1.39.7,2a1.52,1.52,0,0,1,.11,1,.62.62,0,0,1-.44.37,2,2,0,0,1-.45.06A6.58,6.58,0,0,1,392,120.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389,109.05c-.14.27-1.14,0-2.36,0s-2.23.16-2.36-.11.16-.37.58-.58a4.07,4.07,0,0,1,3.6.12C388.86,108.68,389.05,108.93,389,109.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.76,109.86c-.22.23-1,0-2-.08s-1.84.11-2-.14.06-.36.43-.57a3.14,3.14,0,0,1,1.66-.33,3,3,0,0,1,1.6.51C398.75,109.5,398.86,109.75,398.76,109.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.47,116.12c-.12-.05-4.58-1.47-4.54,3.12s4.64,3.6,4.64,3.47S377.47,116.12,377.47,116.12Z",
    style: {
      fill: "#aa645b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.16,121s-.08.05-.22.11a.75.75,0,0,1-.6,0,2,2,0,0,1-.93-1.77,2.64,2.64,0,0,1,.22-1.14c.14-.34.35-.58.6-.62a.41.41,0,0,1,.47.21c.06.13,0,.22.06.23s.1-.08.06-.26a.51.51,0,0,0-.19-.29.59.59,0,0,0-.44-.11,1.11,1.11,0,0,0-.83.71,2.84,2.84,0,0,0-.27,1.29,2.08,2.08,0,0,0,1.19,2,.86.86,0,0,0,.73-.13C376.15,121.1,376.17,121,376.16,121Z",
    style: {
      fill: "#814742"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397,102.1c.73-.42-1.54-2.79-3.38-3.59-2.78-1.2-7-1.9-9.53-1.14-3.05.92-5.57,2.49-7.06,5.3a18.12,18.12,0,0,0-1.87,9.26,5.36,5.36,0,0,0,.7,2.79c.65,1,1.89,1.62,1.86,3a1.94,1.94,0,0,0,.5,1.39c.86.88,1.87,0,2.33-.82a13.39,13.39,0,0,0,1.11-6,13.29,13.29,0,0,0-.37-4.36c-.23-.76-.61-1.48-.8-2.25a2.73,2.73,0,0,1,.28-2.29,3.12,3.12,0,0,1,.37-.39,4.78,4.78,0,0,1,4.73-1c2.6.87,7,2.16,8.18,1.26a7.21,7.21,0,0,0,2-2.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.9,130.85c.1,0,.16-.44,0-1s-.35-.9-.44-.86,0,.45.08.94S394.79,130.86,394.9,130.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.65,131c.1,0,.12-.35.1-.75s-.08-.73-.18-.74-.21.33-.19.76S393.55,131,393.65,131Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.51,131.1c.1,0,.16-.36.14-.79s-.12-.79-.22-.78-.17.36-.15.79S392.4,131.11,392.51,131.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391,130.78c.1,0,.24-.28.31-.67s.05-.72-.05-.74-.24.28-.31.67S390.92,130.76,391,130.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.38,122.1c.15-.06.48.93,1.56,1.35s2.1,0,2.15.09-.17.27-.61.43a2.64,2.64,0,0,1-1.78,0,2.28,2.28,0,0,1-1.24-1.15C389.28,122.4,389.31,122.12,389.38,122.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "361.23 143.71 366.15 155.81 361.5 188.41 359.29 204.31 350.57 204.31 351.74 186.38 354.55 162.04 361.23 143.71",
    style: {
      fill: "#aa645b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "412.6 148.05 407.02 155.81 410.36 187.61 413.44 204.31 422.25 204.31 420.11 185.58 418.62 162.04 412.6 148.05",
    style: {
      fill: "#aa645b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.74,170.55s1.59-10.33,2.64-14,3.36-11.58,6.14-14.14,4.61-2.3,9.6-3.91c3.73-1.21,6.76-2.29,6.76-2.29l1.15-1.56c3.14,8.39,13.72,6.41,15.74,0l.93,1.48s15.65,5.17,18.16,9,8.26,25.74,8.26,25.74l-14.41,1,.28-7.44s-2,9.06-1.29,16.18c.6,6.28,2,23.74,2,23.74l-42.63-.14s1.21-21.46,1.37-25.54c.11-3-.79-14.88-.79-14.88l-.93,8.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.59,140.92a8,8,0,0,1-1.15.54l-3.14,1.42c-1.31.61-2.91,1.3-4.58,2.2a12.31,12.31,0,0,0-4.51,4.06,13.64,13.64,0,0,0-1.92,5.78,25.73,25.73,0,0,0,.12,5.05c.13,1.36.25,2.51.33,3.43a4.84,4.84,0,0,1,0,1.26,7.33,7.33,0,0,1-.24-1.24c-.12-.8-.31-2-.49-3.41a23.64,23.64,0,0,1-.24-5.15,13.77,13.77,0,0,1,2-6,12.47,12.47,0,0,1,4.71-4.2c1.74-.9,3.34-1.54,4.68-2.12s2.44-1,3.21-1.26A4.93,4.93,0,0,1,380.59,140.92Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407,164.35a5.85,5.85,0,0,1,0-1.31c0-.85.13-2.07.28-3.56a29.21,29.21,0,0,0,.13-5.23,11.62,11.62,0,0,0-1.94-5.94,12.87,12.87,0,0,0-5-3.85c-1.79-.83-3.45-1.51-4.83-2.08l-3.31-1.32a7.23,7.23,0,0,1-1.2-.51,5.21,5.21,0,0,1,1.27.31c.81.25,2,.65,3.37,1.18s3.08,1.17,4.91,2a12.84,12.84,0,0,1,5.17,4,11.83,11.83,0,0,1,2,6.2,26.53,26.53,0,0,1-.25,5.31c-.19,1.49-.35,2.69-.44,3.53A7.2,7.2,0,0,1,407,164.35Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.7,136.08a9.59,9.59,0,0,1-12.64,5.63,8.4,8.4,0,0,1-5.12-5.32l1.09-1.77a8,8,0,0,0,8.1,5.56c6.06-.25,7.44-5.67,7.64-5.56l.93,1.48",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.68,137.58a9.81,9.81,0,0,1-1.64.59l-4.51,1.43-3.12,1c-1.12.35-2.32.71-3.53,1.21a11,11,0,0,0-3.43,2.11,10.91,10.91,0,0,0-2.41,3.58,40.81,40.81,0,0,0-1.52,4.15c-.44,1.36-.84,2.68-1.22,3.95-.74,2.53-1.36,4.83-1.87,6.75l-1.18,4.58a11,11,0,0,1-.48,1.67,1.53,1.53,0,0,1,0-.45c.05-.29.13-.72.24-1.26.22-1.1.56-2.68,1-4.63s1.05-4.25,1.77-6.79c.36-1.28.76-2.61,1.19-4a43,43,0,0,1,1.53-4.21,10.24,10.24,0,0,1,6.14-5.92,34.67,34.67,0,0,1,3.59-1.17l3.14-.9L376,138A11.82,11.82,0,0,1,377.68,137.58Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.75,168a8.93,8.93,0,0,1-.66-1.55c-.42-1.1-1-2.56-1.63-4.32-1.36-3.63-3.13-8.74-5.2-14.27a8.74,8.74,0,0,0-1.06-1.84,8,8,0,0,0-1.53-1.38,29.39,29.39,0,0,0-3.44-2c-2.26-1.2-4.37-2.15-6.15-2.92l-4.25-1.79a9.55,9.55,0,0,1-1.54-.71,11.92,11.92,0,0,1,1.62.52c1,.37,2.5.91,4.31,1.64s3.94,1.65,6.24,2.84a29.23,29.23,0,0,1,3.51,2.05,8.4,8.4,0,0,1,1.63,1.48,8.13,8.13,0,0,1,1.13,2c2.1,5.58,3.8,10.66,5.08,14.35l1.47,4.37A11.88,11.88,0,0,1,419.75,168Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383,158.78v14.28h-4V161.9h-2.65v-3.12Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.15,172.47a6,6,0,0,1-2.23-2.56,10.23,10.23,0,0,1,0-8,6,6,0,0,1,2.23-2.56,6.18,6.18,0,0,1,3.27-.88,6.1,6.1,0,0,1,3.24.88,6,6,0,0,1,2.24,2.56,10.35,10.35,0,0,1,0,8,6,6,0,0,1-2.24,2.56,6.1,6.1,0,0,1-3.24.88A6.18,6.18,0,0,1,388.15,172.47Zm4.89-3.42a8.46,8.46,0,0,0,0-6.26,1.82,1.82,0,0,0-1.62-1,1.84,1.84,0,0,0-1.64,1,8.34,8.34,0,0,0,0,6.26,1.84,1.84,0,0,0,1.64,1A1.82,1.82,0,0,0,393,169.05Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.74 170.51 352.2 167.66 365.04 169.11 364.71 172.08 351.74 170.51",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "406.71 171.79 407.02 169.46 420.39 168.14 421.12 170.84 406.71 171.79",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.82,
    y: 152.12,
    width: 4.69,
    height: 3.11,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.68,156.21a11.77,11.77,0,0,1-4.92,0,11.77,11.77,0,0,1,4.92,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 372.34,
    cy: 154.14,
    r: 2.02,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.67,204.31c0,.14-18.48.26-41.26.26s-41.26-.12-41.26-.26,18.47-.26,41.26-.26S427.67,204.16,427.67,204.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M421.61,212.09c0,1.86-15.08,3.38-33.68,3.38s-33.68-1.52-33.68-3.38,15.08-3.38,33.68-3.38S421.61,210.22,421.61,212.09Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-5--inject-29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M393.63,196.9c-1.09-1.12-2.4-2.18-2.79-3.69s.09-3-.67-4.21c-.93-1.5-3.2-1.59-4.32-3-.54-.66-.74-1.55-1.27-2.22a4.23,4.23,0,0,0-4-1.14c-1.44.22-2.81.81-4.26,1-2,.24-4.08-.31-6,.36-2.08.74-3.28,2.67-4.56,4.55l-1.69,2.18a7.92,7.92,0,0,1-1.14,1,15,15,0,0,0-2.2,1.56,3.54,3.54,0,0,0,.49,5.07,3.79,3.79,0,0,0-2.36,3.83,11.16,11.16,0,0,0,.82,2.53,3.81,3.81,0,0,1,.2,2.59,1.68,1.68,0,0,1-2.12,1,4,4,0,0,0,2.3,2.53,2.39,2.39,0,0,1-1.56.79c1.8,3.72,6.3,5.49,10.43,5.3s8-2,11.75-3.69l11-3.46c1-.27,1.31-1.48,1.24-2.48a8.09,8.09,0,0,1-.06-3c.43-1.31,1.88-2.06,2.33-3.36C395.69,199.59,394.72,198,393.63,196.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.86,208.38a46.48,46.48,0,0,1-2.35-7.55,16.08,16.08,0,0,1,.26-7.83c.12-.38,1.19-2.95,1.59-2.93s-.34,2.39-.18,2.63a13.62,13.62,0,0,1,1.9,7.84,35.27,35.27,0,0,1-1.22,7.84",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.13,198.34c-.53-6.6,2.87-12.41,9.48-12.76h.62A11.83,11.83,0,0,1,389,196.54c.42,5.73.82,12.06.76,15.12-.12,6.36-6.48,7.3-6.48,7.3s.73,10.41.73,10.41l-15.77-2.06Z",
    style: {
      fill: "#e6866e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.24,219a15.36,15.36,0,0,1-8.25-2.49,8,8,0,0,0,8.34,4.63Z",
    style: {
      fill: "#a3594e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.46,201.72a.91.91,0,0,1-.88.91.86.86,0,0,1-.93-.82.9.9,0,0,1,.88-.91A.87.87,0,0,1,386.46,201.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.58,199.17c-.11.12-.79-.39-1.77-.4s-1.69.48-1.8.36.06-.26.38-.49a2.49,2.49,0,0,1,1.44-.43,2.4,2.4,0,0,1,1.41.46C387.54,198.91,387.64,199.12,387.58,199.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.46,202a.91.91,0,0,1-.88.91.86.86,0,0,1-.93-.82.9.9,0,0,1,.88-.91A.86.86,0,0,1,377.46,202Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378,199.51c-.11.11-.8-.4-1.78-.4s-1.69.48-1.8.36.07-.27.38-.49a2.51,2.51,0,0,1,1.44-.44,2.46,2.46,0,0,1,1.42.47C378,199.24,378.07,199.45,378,199.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.47,207a6.86,6.86,0,0,1,1.59-.28c.25,0,.49-.07.53-.24a1.26,1.26,0,0,0-.16-.74c-.23-.6-.47-1.24-.73-1.9a33.09,33.09,0,0,1-1.62-5,33.34,33.34,0,0,1,2,4.84l.69,1.91a1.41,1.41,0,0,1,.13,1,.62.62,0,0,1-.42.36,1.76,1.76,0,0,1-.42.06A5.93,5.93,0,0,1,381.47,207Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.6,207.69c.15,0,.15,1.05,1,1.81s2,.65,2,.79-.25.21-.73.22a2.62,2.62,0,0,1-1.7-.61,2.28,2.28,0,0,1-.82-1.51C378.4,207.94,378.52,207.68,378.6,207.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378,195.55c-.1.26-1.07.13-2.22.26s-2.07.44-2.22.2.09-.37.47-.62a3.84,3.84,0,0,1,1.65-.57,3.72,3.72,0,0,1,1.73.22C377.82,195.21,378,195.42,378,195.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.2,195.93c-.17.22-.84,0-1.65,0s-1.5.14-1.65-.1,0-.33.34-.54a2.25,2.25,0,0,1,1.34-.36,2.35,2.35,0,0,1,1.32.46C387.18,195.59,387.28,195.82,387.2,195.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.62,203c-.11,0-4.36-1.32-4.25,3s4.45,3.33,4.46,3.21S367.62,203,367.62,203Z",
    style: {
      fill: "#e6866e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.46,207.67s-.08.05-.2.11a.77.77,0,0,1-.57,0,1.88,1.88,0,0,1-.91-1.66,2.44,2.44,0,0,1,.19-1.09.86.86,0,0,1,.55-.59.38.38,0,0,1,.45.19c.06.12,0,.21.06.22s.09-.08.05-.25a.48.48,0,0,0-.17-.27.62.62,0,0,0-.43-.1,1.08,1.08,0,0,0-.77.69,2.69,2.69,0,0,0-.23,1.22,2,2,0,0,0,1.15,1.85.8.8,0,0,0,.69-.14C366.45,207.77,366.47,207.68,366.46,207.67Z",
    style: {
      fill: "#a3594e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.9,189.45c.69-.41-1.5-2.62-3.25-3.34-2.65-1.1-6.66-1.69-9-.92a10.46,10.46,0,0,0-6.59,5.13,17.23,17.23,0,0,0-1.62,8.79,5.18,5.18,0,0,0,.71,2.63c.64.94,1.82,1.5,1.82,2.83a1.8,1.8,0,0,0,.49,1.31c.83.82,1.77,0,2.19-.82a18.73,18.73,0,0,0,.53-9.84c-.23-.72-.6-1.39-.8-2.12a2.21,2.21,0,0,1,.58-2.55,4.53,4.53,0,0,1,4.46-1c2.48.78,6.7,1.93,7.76,1.07a6.74,6.74,0,0,0,1.88-2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.81,184.59a9.55,9.55,0,0,1,7.35.15,5,5,0,0,1,2.72,2.79,2.85,2.85,0,0,1-1.31,3.42l-.08.06a6.65,6.65,0,0,1-4.92-.09c-1.57-.49-3-1.4-4.56-1.88a8.84,8.84,0,0,0-5.17,0A14.34,14.34,0,0,1,373.81,184.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350.98 229.8 355.89 241.9 351.25 274.5 349.04 290.39 340.31 290.39 341.49 272.47 344.3 248.13 350.98 229.8",
    style: {
      fill: "#e6866e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "402.35 234.14 396.77 241.9 400.1 273.69 403.19 290.39 412 290.39 409.86 271.67 408.37 248.13 402.35 234.14",
    style: {
      fill: "#e6866e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.49,256.64s1.59-10.33,2.63-14,3.37-11.59,6.15-14.14,4.61-2.31,9.59-3.91c3.74-1.21,6.77-2.3,6.77-2.3l1.15-1.55c3.13,8.39,13.72,6.4,15.74,0l.93,1.48s15.65,5.17,18.16,9S410.86,257,410.86,257l-14.4,1,.28-7.45s-2,9.06-1.3,16.19c.6,6.27,2,23.73,2,23.73l-42.62-.13s1.21-21.46,1.37-25.54c.11-3-.79-14.89-.79-14.89l-.93,8.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.33,227a6,6,0,0,1-1.14.55L366.05,229c-1.31.62-2.92,1.31-4.59,2.2a12.36,12.36,0,0,0-4.5,4.06A13.73,13.73,0,0,0,355,241a25.73,25.73,0,0,0,.12,5.05c.13,1.37.24,2.52.33,3.43a4.93,4.93,0,0,1,0,1.27,7.64,7.64,0,0,1-.24-1.24c-.13-.81-.31-2-.5-3.42a24.22,24.22,0,0,1-.23-5.14,13.77,13.77,0,0,1,2-6,12.47,12.47,0,0,1,4.71-4.2c1.74-.89,3.33-1.54,4.68-2.11s2.44-1,3.21-1.27A5.59,5.59,0,0,1,370.33,227Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.74,250.43a5.12,5.12,0,0,1,0-1.31c0-.84.13-2.06.28-3.55a29.32,29.32,0,0,0,.13-5.24,11.65,11.65,0,0,0-1.94-5.93,12.77,12.77,0,0,0-5-3.85c-1.79-.83-3.45-1.51-4.84-2.08l-3.3-1.33a6.82,6.82,0,0,1-1.2-.5,5.44,5.44,0,0,1,1.27.31c.81.25,2,.64,3.37,1.17s3.08,1.18,4.9,2a12.86,12.86,0,0,1,5.18,4,11.89,11.89,0,0,1,2,6.21,26.53,26.53,0,0,1-.25,5.31c-.19,1.49-.35,2.69-.44,3.53A7,7,0,0,1,396.74,250.43Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.45,222.17a9.59,9.59,0,0,1-12.65,5.63,8.41,8.41,0,0,1-5.11-5.32l1.09-1.77a8,8,0,0,0,8.1,5.56c6.06-.25,7.44-5.68,7.64-5.56l.93,1.48",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.42,223.67a12.16,12.16,0,0,1-1.63.59l-4.51,1.43-3.12,1a36.85,36.85,0,0,0-3.53,1.2,9.9,9.9,0,0,0-5.85,5.69,41.61,41.61,0,0,0-1.51,4.15c-.45,1.37-.85,2.69-1.22,4-.74,2.53-1.36,4.82-1.87,6.75s-.88,3.41-1.19,4.58a12,12,0,0,1-.47,1.67,1.53,1.53,0,0,1,0-.45c.05-.29.13-.72.24-1.27.21-1.09.56-2.67,1-4.62s1.05-4.25,1.77-6.8c.36-1.27.75-2.6,1.19-4a38.39,38.39,0,0,1,1.53-4.21,11.37,11.37,0,0,1,2.54-3.74,11.58,11.58,0,0,1,3.6-2.18c1.24-.5,2.46-.85,3.58-1.18l3.14-.9,4.56-1.26A10.35,10.35,0,0,1,367.42,223.67Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.5,254.12a9.34,9.34,0,0,1-.66-1.56c-.42-1.1-1-2.55-1.63-4.31-1.36-3.64-3.13-8.74-5.21-14.27a7.75,7.75,0,0,0-1.06-1.84,8.37,8.37,0,0,0-1.52-1.39,30.13,30.13,0,0,0-3.44-2c-2.26-1.21-4.37-2.16-6.15-2.93L385.58,224a10.79,10.79,0,0,1-1.54-.71,10.47,10.47,0,0,1,1.61.52c1,.36,2.51.91,4.32,1.63s3.94,1.65,6.24,2.84a30.16,30.16,0,0,1,3.51,2.06,9,9,0,0,1,1.63,1.47,8.33,8.33,0,0,1,1.13,2c2.1,5.59,3.79,10.67,5.08,14.35.6,1.79,1.09,3.26,1.47,4.37A12.19,12.19,0,0,1,409.5,254.12Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.64,244.87v2.52l-5,11.76h-4.41L378,248.07h-3.76v2.2H370.8v-5.4Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "341.49 256.6 341.95 253.75 354.79 255.2 354.46 258.16 341.49 256.6",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "396.45 257.88 396.77 255.55 410.14 254.22 410.86 256.92 396.45 257.88",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.57,
    y: 238.2,
    width: 4.69,
    height: 3.11,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.43,242.3a11.77,11.77,0,0,1-4.92,0,11.77,11.77,0,0,1,4.92,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.12,240.23a2,2,0,1,1-2-2A2,2,0,0,1,364.12,240.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.42,290.39c0,.15-18.48.26-41.26.26s-41.26-.11-41.26-.26,18.47-.26,41.26-.26S417.42,290.25,417.42,290.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 375.65,
    cy: 299.87,
    rx: 33.68,
    ry: 3.38
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-4--inject-29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.49,283.94a49.6,49.6,0,0,1-2.13-8,17.27,17.27,0,0,1,.54-8.24c.14-.4,1.32-3.06,1.73-3s-.43,2.51-.28,2.77a14.63,14.63,0,0,1,1.67,8.32,38.32,38.32,0,0,1-1.53,8.22",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.07,307.12a7.82,7.82,0,0,1-7.64-7.83l-.33-26c-.3-7,3.39-13,10.17-13.08l.63,0a12.29,12.29,0,0,1,11.62,12c.23,6,.41,12.72.24,15.95-.35,6.69-6.89,7.45-6.89,7.45s0,1.55,0,3.52a7.83,7.83,0,0,1-7.78,7.95Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.87,295.65a15.38,15.38,0,0,1-8.37-2.93s1.84,5.11,8.35,4.79Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.48,278.19a1,1,0,0,1-.94.93.9.9,0,0,1-.92-.9.94.94,0,0,1,.93-.93A.92.92,0,0,1,298.48,278.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,275.14c-.12.12-.8-.44-1.8-.48s-1.76.44-1.86.31.08-.28.41-.5a2.46,2.46,0,0,1,2.92.14C300,274.86,300.08,275.09,300,275.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.31,278.19a.94.94,0,0,1-.93.93.89.89,0,0,1-.92-.9.94.94,0,0,1,.93-.93A.9.9,0,0,1,289.31,278.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.21,275c-.12.12-.8-.45-1.8-.49s-1.75.44-1.86.31.08-.27.41-.5a2.52,2.52,0,0,1,1.49-.4,2.38,2.38,0,0,1,1.43.54C290.17,274.68,290.27,274.91,290.21,275Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.48,283a6,6,0,0,1,1.64-.23c.25,0,.5-.06.55-.24a1.48,1.48,0,0,0-.14-.79c-.22-.64-.44-1.32-.68-2a34.28,34.28,0,0,1-1.48-5.3,36.14,36.14,0,0,1,1.89,5.17c.23.71.44,1.39.65,2a1.64,1.64,0,0,1,.09,1,.65.65,0,0,1-.44.36,1.78,1.78,0,0,1-.43,0A6.36,6.36,0,0,1,293.48,283Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.66,271.76c-.14.26-1.1-.06-2.28-.13s-2.17.07-2.28-.21.16-.36.58-.55a3.91,3.91,0,0,1,3.48.26C290.56,271.38,290.73,271.64,290.66,271.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.19,272.12c-.22.23-1,0-2-.07s-1.82.11-2-.14.05-.35.42-.57a3.09,3.09,0,0,1,1.64-.33,3,3,0,0,1,1.58.51C300.17,271.77,300.28,272,300.19,272.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.43,278.31c-.11-.06-4.41-1.55-4.45,3s4.43,3.67,4.44,3.54S279.43,278.31,279.43,278.31Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.08,283.14s-.08.05-.21.11a.76.76,0,0,1-.58,0,2,2,0,0,1-.87-1.78,2.76,2.76,0,0,1,.22-1.14.92.92,0,0,1,.59-.61.41.41,0,0,1,.46.22c.06.13,0,.22.05.23s.1-.07.06-.26a.45.45,0,0,0-.17-.29.55.55,0,0,0-.43-.12,1.09,1.09,0,0,0-.81.7,2.76,2.76,0,0,0-.28,1.27,2.08,2.08,0,0,0,1.11,2,.82.82,0,0,0,.71-.11C278.07,283.25,278.09,283.14,278.08,283.14Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.64,264.66c.72-.41-1.44-2.81-3.21-3.64-2.67-1.25-6.76-2-9.23-1.3a10.72,10.72,0,0,0-6.93,5.16,18.32,18.32,0,0,0-2,9.2,5.56,5.56,0,0,0,.62,2.8c.62,1,1.82,1.65,1.76,3.05a1.93,1.93,0,0,0,.47,1.39c.81.9,1.81.06,2.27-.78a20.43,20.43,0,0,0,.89-10.35c-.21-.76-.56-1.48-.74-2.25a2.81,2.81,0,0,1,.32-2.29,2.9,2.9,0,0,1,.36-.38,4.58,4.58,0,0,1,4.61-.9c2.5.92,6.79,2.28,7.9,1.41a7.08,7.08,0,0,0,2-2.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.65,286c0,.07-.18.24-.59.33a2.39,2.39,0,0,1-1.61-.25,2.46,2.46,0,0,1-1.09-1.21c-.15-.39-.13-.66-.06-.68s.49.87,1.43,1.38S293.61,285.86,293.65,286Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "262.51 306.65 267.43 318.75 262.78 351.35 260.57 367.25 251.84 367.25 253.02 349.32 255.83 324.98 262.51 306.65",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.88 310.99 308.3 318.75 311.63 350.55 314.72 367.25 323.53 367.25 321.39 348.52 319.9 324.98 313.88 310.99",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253,333.49s1.59-10.33,2.63-14,3.37-11.59,6.15-14.14,4.61-2.3,9.59-3.91c3.74-1.21,6.77-2.3,6.77-2.3l1.15-1.55c3.13,8.39,13.72,6.41,15.74,0l.93,1.48s15.65,5.17,18.16,9,8.25,25.73,8.25,25.73l-14.4,1,.28-7.44s-2,9.06-1.3,16.18c.6,6.28,2,23.74,2,23.74l-42.62-.14s1.21-21.46,1.37-25.54c.11-3-.79-14.88-.79-14.88l-.93,8.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.86,303.86a7.5,7.5,0,0,1-1.14.54l-3.14,1.42c-1.31.61-2.92,1.3-4.59,2.19a12.55,12.55,0,0,0-4.5,4.06,13.72,13.72,0,0,0-1.92,5.79,25.73,25.73,0,0,0,.12,5.05c.13,1.36.24,2.51.33,3.42a4.91,4.91,0,0,1,0,1.27,7.33,7.33,0,0,1-.24-1.24c-.13-.8-.31-2-.5-3.41a24.35,24.35,0,0,1-.23-5.15,13.81,13.81,0,0,1,2-6,12.64,12.64,0,0,1,4.71-4.2c1.74-.89,3.33-1.53,4.68-2.11s2.44-1,3.21-1.27A4.58,4.58,0,0,1,281.86,303.86Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.27,327.29a5.24,5.24,0,0,1,0-1.32c0-.84.13-2.06.28-3.55a29.24,29.24,0,0,0,.13-5.23,11.64,11.64,0,0,0-1.95-5.94,12.77,12.77,0,0,0-4.95-3.85c-1.79-.83-3.45-1.51-4.84-2.08L293.6,304a6.82,6.82,0,0,1-1.2-.5,5.44,5.44,0,0,1,1.27.31c.81.25,2,.65,3.37,1.17s3.08,1.18,4.9,2a12.8,12.8,0,0,1,5.18,4,11.83,11.83,0,0,1,2,6.2,26.53,26.53,0,0,1-.25,5.31c-.19,1.49-.35,2.69-.44,3.53A7.2,7.2,0,0,1,308.27,327.29Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296,299a9.59,9.59,0,0,1-12.65,5.63,8.41,8.41,0,0,1-5.11-5.32l1.09-1.77a8,8,0,0,0,8.1,5.56c6.06-.25,7.44-5.67,7.64-5.56L296,299",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279,300.52a12.16,12.16,0,0,1-1.63.59l-4.51,1.43-3.12,1c-1.13.35-2.32.7-3.53,1.2a11.24,11.24,0,0,0-3.43,2.12,11.09,11.09,0,0,0-2.42,3.58,41.44,41.44,0,0,0-1.51,4.14c-.45,1.37-.85,2.69-1.22,4-.74,2.53-1.36,4.82-1.87,6.75s-.88,3.42-1.19,4.58a12,12,0,0,1-.47,1.67,1.53,1.53,0,0,1,0-.45c0-.29.13-.72.24-1.26.21-1.1.56-2.68,1-4.63s1-4.25,1.77-6.79c.36-1.28.75-2.61,1.19-4a38.39,38.39,0,0,1,1.53-4.21,10.24,10.24,0,0,1,6.14-5.92,35.32,35.32,0,0,1,3.58-1.17l3.14-.9,4.56-1.27A11.91,11.91,0,0,1,279,300.52Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321,331a8.93,8.93,0,0,1-.66-1.55c-.42-1.11-1-2.56-1.63-4.32-1.36-3.63-3.13-8.74-5.21-14.27a8,8,0,0,0-1.06-1.84A8.37,8.37,0,0,0,311,307.6a31.66,31.66,0,0,0-3.44-2c-2.26-1.2-4.37-2.15-6.15-2.93l-4.25-1.78a9.55,9.55,0,0,1-1.54-.71,10.47,10.47,0,0,1,1.61.52c1,.36,2.51.91,4.32,1.64s3.94,1.65,6.24,2.83a30.16,30.16,0,0,1,3.51,2.06,8.7,8.7,0,0,1,1.63,1.48,8.26,8.26,0,0,1,1.13,1.95c2.1,5.59,3.79,10.67,5.08,14.36l1.47,4.37A11.88,11.88,0,0,1,321,331Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.05,331.52v3.21H281.93V332.2l5.34-5a5.14,5.14,0,0,0,1.05-1.26,2.33,2.33,0,0,0,.26-1.05,1.34,1.34,0,0,0-.47-1.08,2.09,2.09,0,0,0-1.37-.38,3,3,0,0,0-1.45.35,2.93,2.93,0,0,0-1.1,1l-3-1.67a5.83,5.83,0,0,1,2.35-2.18,7.58,7.58,0,0,1,3.57-.8,7.45,7.45,0,0,1,2.89.53,4.56,4.56,0,0,1,2,1.52,3.87,3.87,0,0,1,.7,2.3,5,5,0,0,1-.5,2.19,8.35,8.35,0,0,1-1.93,2.34l-2.69,2.48Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "253.02 333.45 253.48 330.6 266.32 332.05 265.99 335.02 253.02 333.45",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "307.99 334.73 308.3 332.4 321.67 331.08 322.39 333.77 307.99 334.73",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.1,
    y: 315.05,
    width: 4.69,
    height: 3.11,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304,319.15a11.77,11.77,0,0,1-4.92,0,11.77,11.77,0,0,1,4.92,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.65,317.08a2,2,0,1,1-2-2A2,2,0,0,1,275.65,317.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329,367.25c0,.14-18.48.26-41.26.26s-41.26-.12-41.26-.26,18.47-.26,41.26-.26S329,367.1,329,367.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M321,373c0,1.87-15.08,3.38-33.68,3.38s-33.68-1.51-33.68-3.38,15.08-3.38,33.68-3.38S321,371.11,321,373Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-29"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "222.69 139.62 227.61 151.73 222.97 184.32 220.75 200.22 212.03 200.22 213.21 182.3 216.01 157.96 222.69 139.62",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "274.07 143.96 268.49 151.73 271.82 183.52 274.91 200.22 283.72 200.22 281.58 181.49 280.08 157.96 274.07 143.96",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.74,107.22l2.51,25.64c.34,4.39.86,10.89,7.78,10h0c5.94-1.19,7-7,6.7-11.11-.15-1.94-.28-3.56-.28-3.76,0,0,6.52-1.13,6.49-7.67,0-3.16-.57-9.66-1.15-15.54a12.17,12.17,0,0,0-12.33-11h-.63C240,94.34,237,100.44,237.74,107.22Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.47,128a15.8,15.8,0,0,1-8.56-2.38s2.16,4.74,8.67,4Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.11,109.09c-.14,0-.83-.39-1.91-.56s-1.93,0-2-.11.11-.15.48-.23a4.49,4.49,0,0,1,1.65,0,4.05,4.05,0,0,1,1.49.53C249.09,108.92,249.18,109.07,249.11,109.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,111.08a.88.88,0,0,1-.84.9.83.83,0,0,1-.92-.78.87.87,0,0,1,.83-.9A.84.84,0,0,1,248,111.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.52,115.77a6.25,6.25,0,0,1,1.62-.33c.26,0,.5-.08.54-.26a1.25,1.25,0,0,0-.18-.75c-.26-.62-.52-1.27-.8-1.94a31.75,31.75,0,0,1-1.78-5.09,34.79,34.79,0,0,1,2.19,4.93c.26.68.52,1.33.76,2a1.54,1.54,0,0,1,.15,1,.66.66,0,0,1-.42.38,1.82,1.82,0,0,1-.43.07A7,7,0,0,1,252.52,115.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.28,104.4c-.08.25-1,.15-2,.3s-1.87.45-2,.23.08-.34.41-.59a3.42,3.42,0,0,1,1.49-.56,3.21,3.21,0,0,1,1.58.16C248.12,104.09,248.32,104.29,248.28,104.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.79,105.49c-.1.21-1,.06-2,.13s-1.87.26-2,.07.1-.29.44-.47a3.6,3.6,0,0,1,1.5-.39,3.81,3.81,0,0,1,1.55.23C258.65,105.22,258.83,105.39,258.79,105.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.36,112.14c-.11,0-4.77-1.19-4.42,3.49s5,3.36,5,3.23S238.36,112.14,238.36,112.14Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.36,117.19s-.08.07-.21.14a.84.84,0,0,1-.61.06,2,2,0,0,1-1.07-1.74,2.72,2.72,0,0,1,.14-1.19.94.94,0,0,1,.57-.67.41.41,0,0,1,.49.19c.08.13.05.22.08.23s.09-.09,0-.28a.51.51,0,0,0-.2-.28.6.6,0,0,0-.46-.08,1.13,1.13,0,0,0-.8.79,2.71,2.71,0,0,0-.19,1.32,2.12,2.12,0,0,0,1.35,1.93.87.87,0,0,0,.73-.18C237.36,117.31,237.38,117.2,237.36,117.19Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253,118.85c0-.13-.9-.06-1.77-.6a5,5,0,0,1-1-.87c-.24-.26-.4-.41-.44-.38s.05.23.24.53a3.45,3.45,0,0,0,1,1,2.63,2.63,0,0,0,1.38.4C252.75,119,253,118.89,253,118.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.84,107.72c-.09.12-.9.12-1.91.52s-1.67,1-1.8,1,0-.18.3-.43a4.72,4.72,0,0,1,1.41-.85,4.21,4.21,0,0,1,1.55-.33C258.75,107.59,258.89,107.67,258.84,107.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.67,110.85a.88.88,0,0,1-.84.9.84.84,0,0,1-.92-.78.88.88,0,0,1,.83-.91A.86.86,0,0,1,257.67,110.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.06,98.19a1.09,1.09,0,0,0-.55-.57,3.31,3.31,0,0,0-1.68-.12,9.34,9.34,0,0,1-4.15-.65,4.83,4.83,0,0,0,1.12-.95,2.81,2.81,0,0,0,.55-2.84.63.63,0,0,0-.39-.39c-.3-.06-.52.24-.7.49a2.44,2.44,0,0,1-2.17,1.16,4.05,4.05,0,0,1-1.73-.35l-.06-.06-.74-.62h0a14.56,14.56,0,0,0-4.88-3,15.25,15.25,0,0,0-8.1.09,6.12,6.12,0,0,0-4.18,5.15,4.7,4.7,0,0,0-4.74,0l0,0c-1.67.77-2.48,2.67-2.83,4.47,0,.1,0,.2-.05.3a6.86,6.86,0,0,1-2.11,2.46c-.15.11-.33.25-.34.44s.17.33.34.43a3.33,3.33,0,0,0,1.44.45,8.27,8.27,0,0,1-.46,1.26c-.17.35-.36.76-.16,1.09a.73.73,0,0,0,.79.26,2.05,2.05,0,0,0,.76-.43l-.45,1.42a3.94,3.94,0,0,0,1.86-.29A42.46,42.46,0,0,0,236,112.1c.71-.07,1.38-.3,1.86.06.65.49,1,1.48,2,1,.49-.25.86-1.36,1-1.89a25.47,25.47,0,0,0,.14-10.82,8.07,8.07,0,0,1,2.35-2l-.07.08c1.75-.79,3.75-1.6,5.55-.9,1.39.54,2.3,1.85,3.4,2.87a9.67,9.67,0,0,0,7.3,2.71c.43,1.93.45,4.44.71,6.26l1.42-3.1h0a6.35,6.35,0,0,0,.28-.67l0-.07h0c.13-.36.25-.73.42-1.09l0,0a1.15,1.15,0,0,0,1.53-1.68,2.46,2.46,0,0,0-.6-.51,1.82,1.82,0,0,0,1.76.3,1.43,1.43,0,0,0,.88-1.5,1.23,1.23,0,0,0-.81-.9,4.07,4.07,0,0,0,2.27-.72C267.86,99.22,268.27,98.75,268.06,98.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.5,96.11a5.44,5.44,0,0,0-.59.65A4.68,4.68,0,0,0,241.1,99a8.42,8.42,0,0,0,0,1.67c0,.6.15,1.23.26,1.9a17.32,17.32,0,0,1,.24,2.13,8.6,8.6,0,0,1,0,1.13,2.35,2.35,0,0,1-.36,1.13,1,1,0,0,1-.89.39,1.4,1.4,0,0,1-.87-.39,3.37,3.37,0,0,1-.77-1.59h.13a5.2,5.2,0,0,1-.66,1.43,2,2,0,0,1-1.2.81,1.29,1.29,0,0,1-.68-.06,1.07,1.07,0,0,1-.5-.41,1.17,1.17,0,0,1-.19-.56.82.82,0,0,1,.17-.53l.07.06a4.24,4.24,0,0,1-1.3,1.17,4,4,0,0,1-.42.21l-.15.05.14-.08a3,3,0,0,0,.4-.22,4.26,4.26,0,0,0,1.25-1.18l.08,0a.83.83,0,0,0,0,1,1,1,0,0,0,.45.36,1.14,1.14,0,0,0,.61,0,1.81,1.81,0,0,0,1.12-.76,5.56,5.56,0,0,0,.64-1.39l.07-.22.07.22a3.22,3.22,0,0,0,.73,1.52,1.27,1.27,0,0,0,.78.35.81.81,0,0,0,.75-.33,2.1,2.1,0,0,0,.33-1.05,7.05,7.05,0,0,0,.05-1.12,17.69,17.69,0,0,0-.23-2.11c-.1-.67-.2-1.3-.25-1.91A7.8,7.8,0,0,1,241,99a4.6,4.6,0,0,1,.86-2.27A2.6,2.6,0,0,1,242.5,96.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.15,100.61s0,0,0,0l-.15.14a1.58,1.58,0,0,1-.26.2,3.43,3.43,0,0,1-.37.24,5.84,5.84,0,0,1-2.74.75,7.36,7.36,0,0,1-4-1.09,12.85,12.85,0,0,1-3.72-3.58c-.54-.74-1-1.51-1.49-2.22a8.61,8.61,0,0,0-1.63-1.85,4.42,4.42,0,0,0-2-1,3.38,3.38,0,0,0-1,0,3.59,3.59,0,0,0-.88.26,3.74,3.74,0,0,0-1.93,2,5.36,5.36,0,0,0-.25,1V95.2a3.69,3.69,0,0,1,.18-.75,3.8,3.8,0,0,1,.64-1,3.94,3.94,0,0,1,1.3-1,3.79,3.79,0,0,1,.92-.27,3.56,3.56,0,0,1,1,0,4.56,4.56,0,0,1,2,1A8.35,8.35,0,0,1,250.45,95c.5.71,1,1.47,1.5,2.21a12.68,12.68,0,0,0,3.66,3.55,7.29,7.29,0,0,0,4,1.1,5.84,5.84,0,0,0,2.71-.69A7.51,7.51,0,0,0,263.15,100.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.49,97.71a1.9,1.9,0,0,1-.22.18,4.1,4.1,0,0,1-.66.41,6.71,6.71,0,0,1-1.06.46,7.58,7.58,0,0,1-1.38.31,7.5,7.5,0,0,1-1.41,0,6.66,6.66,0,0,1-1.14-.18,5.18,5.18,0,0,1-.74-.25c-.17-.07-.26-.11-.25-.12s.38.12,1,.26a7.63,7.63,0,0,0,1.12.15,8.15,8.15,0,0,0,1.38,0,7.41,7.41,0,0,0,2.41-.71C263.14,97.92,263.47,97.69,263.49,97.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.21,166.47s1.59-10.34,2.63-14,3.37-11.58,6.14-14.14,4.62-2.3,9.6-3.91c3.74-1.21,6.76-2.29,6.76-2.29l1.16-1.55c3.13,8.38,13.71,6.4,15.73,0l.94,1.47s15.65,5.17,18.16,9,8.25,25.73,8.25,25.73l-14.41,1,.29-7.44s-2,9.06-1.3,16.18c.6,6.28,2,23.74,2,23.74l-42.62-.14s1.21-21.46,1.36-25.54c.11-3-.79-14.88-.79-14.88l-.93,8.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.05,136.83a7.42,7.42,0,0,1-1.14.55l-3.14,1.41c-1.31.62-2.92,1.3-4.59,2.2a12.31,12.31,0,0,0-4.51,4.06,13.92,13.92,0,0,0-1.92,5.78,26.46,26.46,0,0,0,.13,5c.13,1.37.24,2.51.33,3.43a5.6,5.6,0,0,1,0,1.27,6.49,6.49,0,0,1-.24-1.25c-.13-.8-.31-2-.5-3.41a24.91,24.91,0,0,1-.24-5.14,14,14,0,0,1,2-6,12.57,12.57,0,0,1,4.72-4.2c1.73-.9,3.33-1.54,4.67-2.12s2.44-1,3.21-1.26A5.06,5.06,0,0,1,242.05,136.83Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.46,160.26a5.18,5.18,0,0,1,0-1.31c0-.85.13-2.06.27-3.56a28.23,28.23,0,0,0,.14-5.23,11.64,11.64,0,0,0-1.95-5.94,12.72,12.72,0,0,0-4.95-3.84c-1.79-.84-3.45-1.51-4.84-2.09l-3.3-1.32a10.26,10.26,0,0,1-1.21-.5,4.77,4.77,0,0,1,1.28.31c.8.24,1.95.64,3.36,1.17s3.08,1.17,4.91,2a13,13,0,0,1,5.17,4,11.77,11.77,0,0,1,2,6.21,26.5,26.5,0,0,1-.24,5.3c-.19,1.5-.36,2.7-.44,3.53A8.31,8.31,0,0,1,268.46,160.26Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.16,132a9.58,9.58,0,0,1-12.64,5.63,8.42,8.42,0,0,1-5.12-5.32l1.1-1.76a8,8,0,0,0,8.1,5.55c6.05-.24,7.43-5.67,7.63-5.55l.94,1.47",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.14,133.49a9.86,9.86,0,0,1-1.63.6L233,135.51l-3.13,1c-1.12.35-2.32.71-3.52,1.21a9.9,9.9,0,0,0-5.85,5.69,41.71,41.71,0,0,0-1.52,4.15c-.44,1.36-.84,2.69-1.21,3.95-.74,2.53-1.37,4.83-1.88,6.76s-.88,3.41-1.18,4.57a11.45,11.45,0,0,1-.48,1.68,1.86,1.86,0,0,1,.05-.45c.05-.29.12-.72.23-1.27.22-1.1.56-2.68,1-4.62s1.05-4.25,1.77-6.8c.36-1.27.75-2.6,1.19-4a38.25,38.25,0,0,1,1.53-4.2,11.37,11.37,0,0,1,2.54-3.74,11.5,11.5,0,0,1,3.6-2.19,37.1,37.1,0,0,1,3.58-1.17l3.14-.9,4.56-1.27A11.91,11.91,0,0,1,239.14,133.49Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.21,164a12.11,12.11,0,0,1-.66-1.56l-1.62-4.31c-1.37-3.64-3.14-8.74-5.21-14.27a7.89,7.89,0,0,0-1.06-1.84,7.71,7.71,0,0,0-1.52-1.39,30.24,30.24,0,0,0-3.44-2.05c-2.27-1.2-4.37-2.15-6.16-2.92l-4.24-1.79a10.24,10.24,0,0,1-1.54-.7,9.94,9.94,0,0,1,1.61.51c1,.37,2.51.91,4.31,1.64s3.95,1.65,6.24,2.84a29.35,29.35,0,0,1,3.51,2.06,8,8,0,0,1,1.63,1.47,8.73,8.73,0,0,1,1.14,2c2.09,5.59,3.79,10.67,5.07,14.35.6,1.78,1.1,3.25,1.47,4.37A9.23,9.23,0,0,1,281.21,164Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.29,154.69V169h-4V157.81H239.6v-3.12Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.55,154.69V169h-4V157.81h-2.65v-3.12Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "213.21 166.43 213.67 163.57 226.5 165.03 226.18 167.99 213.21 166.43",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "268.17 167.7 268.49 165.37 281.86 164.05 282.58 166.75 268.17 167.7",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.28,
    y: 148.03,
    width: 4.69,
    height: 3.11,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.14,152.12a11.77,11.77,0,0,1-4.92,0,11.77,11.77,0,0,1,4.92,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.83,150.05a2,2,0,1,1-2-2A2,2,0,0,1,235.83,150.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.13,200.22c0,.14-18.47.26-41.25.26s-41.26-.12-41.26-.26,18.47-.26,41.26-.26S289.13,200.08,289.13,200.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 249.37,
    cy: 206.62,
    rx: 33.68,
    ry: 3.38
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-29"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "188.75 230.22 193.66 242.32 189.02 274.92 186.81 290.81 178.08 290.81 179.26 272.89 182.06 248.55 188.75 230.22",
    style: {
      fill: "#aa645b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.12 234.56 234.54 242.32 237.87 274.11 240.96 290.81 249.77 290.81 247.63 272.09 246.14 248.55 240.12 234.56",
    style: {
      fill: "#aa645b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.09,222.39l4.22,6.46,7.54,6.79,3.9-6-.28-5.82-.23-4.88s6.43-1.23,6.29-7.7c-.07-3.13-.74-9.55-1.41-15.36a12.06,12.06,0,0,0-12.4-10.67l-.62,0c-6.72.63-9.48,6.5-8.67,13.2l1.09,24",
    style: {
      fill: "#aa645b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.24,218.93a15,15,0,0,1-8.51-2.1s2.15,4.58,8.59,3.78Z",
    style: {
      fill: "#814742"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.54,201.65a.93.93,0,0,1-.86,1,.88.88,0,0,1-1-.8.91.91,0,0,1,.86-1A.89.89,0,0,1,223.54,201.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.93,198.75c-.12.12-.83-.37-1.83-.33s-1.7.55-1.81.44.05-.28.36-.52a2.54,2.54,0,0,1,1.45-.5,2.46,2.46,0,0,1,1.46.41C224.87,198.48,225,198.69,224.93,198.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.58,201.65a.93.93,0,0,1-.86,1,.89.89,0,0,1-1-.8.92.92,0,0,1,.86-1A.87.87,0,0,1,214.58,201.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,198.81c-.1.14-.86-.28-1.85-.13s-1.63.74-1.76.63,0-.28.31-.55a2.59,2.59,0,0,1,1.39-.66,2.46,2.46,0,0,1,1.49.26C214.92,198.55,215.06,198.75,215,198.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.94,206.86a7.34,7.34,0,0,1,1.6-.35c.25,0,.49-.09.53-.26a1.28,1.28,0,0,0-.2-.75l-.81-1.91a32.33,32.33,0,0,1-1.86-5,33.73,33.73,0,0,1,2.26,4.84l.78,1.92a1.49,1.49,0,0,1,.17,1,.66.66,0,0,1-.41.39,1.82,1.82,0,0,1-.43.07A6.2,6.2,0,0,1,218.94,206.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,194.52c-.09.27-1.09.18-2.25.36s-2.09.53-2.26.29.09-.37.46-.65a3.82,3.82,0,0,1,1.66-.64,3.91,3.91,0,0,1,1.77.14C214.81,194.18,215,194.39,215,194.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.63,194.91c-.17.23-.86,0-1.68,0s-1.52.2-1.69,0,0-.34.33-.57a2.47,2.47,0,0,1,2.71,0C224.6,194.57,224.7,194.8,224.63,194.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.67,203.38c-.12,0-4.49-1.16-4.2,3.25s4.67,3.22,4.67,3.09S204.67,203.38,204.67,203.38Z",
    style: {
      fill: "#aa645b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.68,208.13s-.08.06-.2.13a.78.78,0,0,1-.58.05,1.89,1.89,0,0,1-1-1.65,2.5,2.5,0,0,1,.14-1.11.86.86,0,0,1,.54-.63.39.39,0,0,1,.47.18c.07.12,0,.21.07.21s.09-.08,0-.26a.54.54,0,0,0-.19-.26.58.58,0,0,0-.44-.09,1.07,1.07,0,0,0-.75.74,2.56,2.56,0,0,0-.19,1.25,2,2,0,0,0,1.25,1.83.85.85,0,0,0,.7-.16C203.68,208.24,203.69,208.14,203.68,208.13Z",
    style: {
      fill: "#814742"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.58,188.31a2.26,2.26,0,0,0-1.76-1.75,2,2,0,0,0-3.23-2.23,2.08,2.08,0,0,0-2.88-1.76,1.74,1.74,0,0,0-3.3-.83,3,3,0,0,0-4.69-.22,3.85,3.85,0,0,0-4.6,2.22,3.63,3.63,0,0,0-3.12,2.61,2.67,2.67,0,0,0-1.83,4.25,2,2,0,0,0-.31,3.13,1.95,1.95,0,0,0,.18,3.51c-.65.1-.88,1-.67,1.59s.71,1.11,1,1.7.31,1,.51,1.54a3.5,3.5,0,0,0,2.16,2l-.11.14c-.1.57.71.93,1.23.69a2.82,2.82,0,0,0,1.1-1.3,6.53,6.53,0,0,0,.87-1.78,1.53,1.53,0,0,0-.67-1.72,2.31,2.31,0,0,0,1.34-1.87,6.66,6.66,0,0,0-.22-2.39l-.75-3.49a4.43,4.43,0,0,0,3.74-2.64,2.53,2.53,0,0,0,3.64-1,3.3,3.3,0,0,0,4.08,1.9c-.15.92,1.52,1.71,2.43,1.92a3.28,3.28,0,0,0,2-.46s1.58.86,2.41.5,1.91-1.47,1.33-2.33A4.11,4.11,0,0,0,226.58,188.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.64,193.72a1.49,1.49,0,0,0,.46.56.85.85,0,0,0,.73.11.9.9,0,0,0,.59-.68l0-.26.21.17a1.22,1.22,0,0,0,1.23.15,1.19,1.19,0,0,0,.64-1.2l0-.26.25.09a1.14,1.14,0,0,0,.89,0,1.18,1.18,0,0,0,.53-.5,2.82,2.82,0,0,0,.2-.65s.15.27,0,.73a1.36,1.36,0,0,1-.58.65,1.42,1.42,0,0,1-1.12.09l.21-.16a1.46,1.46,0,0,1-.81,1.54,1.49,1.49,0,0,1-1.57-.21l.26-.09a1.15,1.15,0,0,1-.83.87,1.06,1.06,0,0,1-.92-.2C200.57,194.08,200.61,193.71,200.64,193.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.13,182.47a1.66,1.66,0,0,0-.51-.27.89.89,0,0,0-.65.06.94.94,0,0,0-.51.65l-.05.26-.14-.22a1.61,1.61,0,0,0-1.39-.72,1.57,1.57,0,0,0-1.43,1.16l-.07.29-.19-.23a2,2,0,0,0-1.56-.69,1.91,1.91,0,0,0-1.54.94,1.88,1.88,0,0,0-.25.72l0,.18-.18,0a1.9,1.9,0,0,0-2.08,1.06,1.94,1.94,0,0,0,.39,2.06l.17.17-.24.05a2.13,2.13,0,0,0-1.3.9,2.09,2.09,0,0,0-.33,1.18,3.18,3.18,0,0,0,.27,1.07.78.78,0,0,1-.18-.24,2.11,2.11,0,0,1-.24-.82,2.17,2.17,0,0,1,.3-1.31,2.3,2.3,0,0,1,1.42-1l-.06.23a2.14,2.14,0,0,1,2-3.63l-.2.14a2.27,2.27,0,0,1,.3-.86,2.18,2.18,0,0,1,1.81-1.08,2.24,2.24,0,0,1,1.8.81l-.26.06a1.79,1.79,0,0,1,3.28-.47l-.19,0a1.11,1.11,0,0,1,.66-.76,1,1,0,0,1,.74,0,1,1,0,0,1,.39.25A.3.3,0,0,1,218.13,182.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216,207.07c.16,0,.2,1.07,1.15,1.8s2.1.58,2.11.73-.25.22-.73.25a2.7,2.7,0,0,1-1.76-.55,2.39,2.39,0,0,1-.9-1.51C215.85,207.34,216,207.07,216,207.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.26,257.06s1.59-10.33,2.63-14,3.37-11.59,6.14-14.15,4.62-2.3,9.6-3.91c3.74-1.2,6.77-2.29,6.77-2.29l1.15-1.55c3.13,8.38,13.72,6.4,15.73,0l.94,1.48s15.65,5.17,18.16,9,8.25,25.73,8.25,25.73l-14.41.95.29-7.44s-2,9.06-1.3,16.19c.6,6.27,2,23.73,2,23.73l-42.62-.13s1.21-21.47,1.36-25.55c.12-3-.78-14.88-.78-14.88l-.93,8.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.1,227.42A6.41,6.41,0,0,1,207,228l-3.14,1.41c-1.31.62-2.92,1.31-4.59,2.2a12.39,12.39,0,0,0-4.51,4.06,14,14,0,0,0-1.92,5.78,26.46,26.46,0,0,0,.13,5.05c.13,1.37.24,2.52.33,3.43a4.93,4.93,0,0,1,0,1.27,6.47,6.47,0,0,1-.24-1.24c-.13-.81-.31-2-.5-3.42a24.22,24.22,0,0,1-.23-5.14,13.88,13.88,0,0,1,1.95-6,12.57,12.57,0,0,1,4.72-4.2c1.73-.9,3.33-1.54,4.67-2.11s2.45-1,3.21-1.27A5.74,5.74,0,0,1,208.1,227.42Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.51,250.85a5.12,5.12,0,0,1,0-1.31c0-.84.13-2.06.28-3.55a29.35,29.35,0,0,0,.13-5.24,11.57,11.57,0,0,0-1.95-5.93,12.67,12.67,0,0,0-5-3.85c-1.79-.83-3.45-1.51-4.84-2.09l-3.3-1.32a10.26,10.26,0,0,1-1.21-.5,5.33,5.33,0,0,1,1.28.31c.8.25,2,.64,3.37,1.17s3.08,1.17,4.9,2a13,13,0,0,1,5.18,4,11.86,11.86,0,0,1,2,6.21,26.53,26.53,0,0,1-.25,5.31c-.19,1.49-.36,2.69-.44,3.53A8.28,8.28,0,0,1,234.51,250.85Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.21,222.59a10.1,10.1,0,0,1-4.89,5.41,10.2,10.2,0,0,1-7.75.22,8.4,8.4,0,0,1-5.11-5.33l1.09-1.76a8,8,0,0,0,8.1,5.56c6.06-.25,7.44-5.68,7.63-5.56l.94,1.48",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.19,224.09a12.16,12.16,0,0,1-1.63.59l-4.51,1.43-3.13,1a36.7,36.7,0,0,0-3.52,1.2,9.9,9.9,0,0,0-5.85,5.69,39.25,39.25,0,0,0-1.51,4.15c-.45,1.37-.85,2.69-1.22,4-.74,2.53-1.36,4.82-1.87,6.75s-.89,3.41-1.19,4.58a14.1,14.1,0,0,1-.47,1.67,1.19,1.19,0,0,1,0-.45c0-.29.13-.72.24-1.27.21-1.09.56-2.68,1-4.62s1-4.25,1.77-6.8c.36-1.27.75-2.6,1.19-4a38.39,38.39,0,0,1,1.53-4.21,11.37,11.37,0,0,1,2.54-3.74,11.58,11.58,0,0,1,3.6-2.18,37.27,37.27,0,0,1,3.58-1.18l3.14-.9,4.56-1.27A10.83,10.83,0,0,1,205.19,224.09Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.27,254.54a9.78,9.78,0,0,1-.67-1.56L245,248.67c-1.37-3.64-3.14-8.74-5.21-14.27a7.56,7.56,0,0,0-1.06-1.84,8.37,8.37,0,0,0-1.52-1.39,30.13,30.13,0,0,0-3.44-2c-2.26-1.21-4.37-2.16-6.16-2.93l-4.24-1.79a11.7,11.7,0,0,1-1.54-.7,10.47,10.47,0,0,1,1.61.52c1,.36,2.51.9,4.32,1.63s3.94,1.65,6.23,2.84a29.45,29.45,0,0,1,3.52,2.06,9,9,0,0,1,1.63,1.47,8.33,8.33,0,0,1,1.13,2c2.1,5.59,3.79,10.67,5.08,14.35.6,1.78,1.09,3.26,1.46,4.37A11.57,11.57,0,0,1,247.27,254.54Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.28,251a4.41,4.41,0,0,1,1.78,1.59,4.28,4.28,0,0,1,.66,2.36,4.47,4.47,0,0,1-.74,2.56,4.9,4.9,0,0,1-2,1.71,6.61,6.61,0,0,1-2.85.6,6.43,6.43,0,0,1-4.83-1.81,7.19,7.19,0,0,1-1.78-5.23,8.81,8.81,0,0,1,.95-4.21,6.42,6.42,0,0,1,2.66-2.68,8.35,8.35,0,0,1,4-.92,9.79,9.79,0,0,1,2.33.27,5.84,5.84,0,0,1,1.88.77l-1.47,2.9a4.46,4.46,0,0,0-2.63-.74,3.37,3.37,0,0,0-3.62,3.33,4.75,4.75,0,0,1,3.23-1.06A5.37,5.37,0,0,1,217.28,251Zm-2,5.46a1.88,1.88,0,0,0,0-2.64,2.3,2.3,0,0,0-2.85,0,1.85,1.85,0,0,0,0,2.62,2.09,2.09,0,0,0,1.46.5A2,2,0,0,0,215.27,256.49Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "179.26 257.02 179.72 254.16 192.56 255.62 192.23 258.58 179.26 257.02",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "234.22 258.29 234.54 255.97 247.91 254.64 248.63 257.34 234.22 258.29",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.26,257s1.59-10.33,2.63-14,3.37-11.59,6.14-14.15,4.62-2.3,9.6-3.91c3.74-1.2,6.77-2.29,6.77-2.29l1.15-1.55c3.13,8.38,13.72,6.4,15.73,0l.94,1.48s15.65,5.17,18.16,9,8.25,25.73,8.25,25.73l-14.41,1,.29-7.44s-2,9.06-1.3,16.19c.6,6.27,2,23.77,2,23.77l-42.62-.17s1.21-21.47,1.36-25.55c.12-3-.78-14.88-.78-14.88l-.93,8.37Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.34,
    y: 238.62,
    width: 4.69,
    height: 3.11,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.2,242.72a11.77,11.77,0,0,1-4.92,0,11.34,11.34,0,0,1,4.92,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.89,240.65a2,2,0,1,1-2-2A2,2,0,0,1,201.89,240.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.19,290.81c0,.15-18.48.26-41.26.26s-41.26-.11-41.26-.26,18.47-.26,41.26-.26S255.19,290.67,255.19,290.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M251.49,303.74c0,1.86-15.08,3.38-33.68,3.38s-33.67-1.52-33.67-3.38,15.07-3.38,33.67-3.38S251.49,301.87,251.49,303.74Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.17,271a1.74,1.74,0,0,0-.64-1,4.24,4.24,0,0,0-2.66-.66,11.3,11.3,0,0,1-1.1-3.54,2.31,2.31,0,0,0,1.26-.36,1.66,1.66,0,0,0,.21-.06,1.78,1.78,0,0,0,.42-2.56,5.22,5.22,0,0,0-2.45-1.58,8.43,8.43,0,0,1,1.89.69c.65.2,1.56,0,1.64-.69a1.43,1.43,0,0,0-.11-.61c-.12-.4-.25-.79-.37-1.19a1.36,1.36,0,0,0-.53-.83,3.17,3.17,0,0,0-.69-.17c-.75-.2-1.14-1.12-1.9-1.33a3.54,3.54,0,0,0-1.68.25c-.57.13-1.31,0-1.48-.53a5.39,5.39,0,0,0,1.92-1.62,1.85,1.85,0,0,0-.18-2.32,2.7,2.7,0,0,0-1.9-.39c-.74,0-1.66.2-1.85.91a1.92,1.92,0,0,0-2.36,1.51l-1.9-.19a19.83,19.83,0,0,0,1.74-1.55c.46-.63.37-1.77-.39-1.93-.28-.06-.58,0-.85-.08s-.35-.25-.55-.25a.64.64,0,0,0-.41.16l-4,2.62c.36-.84.72-1.69,1.09-2.53s.59-1.84-.1-2.32-1.66.2-1.8,1a1.3,1.3,0,0,0-1.59,1.2,1.32,1.32,0,0,0-1.55,2,3.71,3.71,0,0,0-1.92.57,1.15,1.15,0,0,0-1.86-.79,2.06,2.06,0,0,0-.29-1.15.69.69,0,0,0-1-.11,1.35,1.35,0,0,0-2.18-1.32l-.66-.8a1.76,1.76,0,0,0-1.71.88c-.28.62.19,1.52.87,1.46-.48,0-.37.75-.09,1.13l1.16,1.62a1.48,1.48,0,0,0-1.84-.16,1.16,1.16,0,0,0-1.67,0,.93.93,0,0,0-1.67.28c-.12-.31-.55-.33-.88-.29a2.12,2.12,0,0,0-1.33.46c-.34.33-.34,1,.11,1.19-.4-.23-.93.22-.94.69a1.71,1.71,0,0,0,.67,1.18,3.68,3.68,0,0,1,1,1,2,2,0,0,0-1.34-.29,5.12,5.12,0,0,0-2.43.49c-.15-.33-.6-.34-1-.27a5.68,5.68,0,0,0-2.89,1.57c-.37.38-.71.94-.45,1.41a1.42,1.42,0,0,0,.53.47l2.58,1.6a7,7,0,0,0-3.53,2.49c-.51.3-1.17.33-1.63.71s-.44,1.35.16,1.35a1.1,1.1,0,0,0-.32,1.27,1.09,1.09,0,0,0,.41.44,1.43,1.43,0,0,0,.28.32,1.93,1.93,0,0,0,.69.37,1.38,1.38,0,0,0,1.16.53,5.49,5.49,0,0,0-1.23,1.45,2.31,2.31,0,0,0,0,2.37l.09.1a1.11,1.11,0,0,0,.5.71,1,1,0,0,0-.1.63,2.51,2.51,0,0,0-.56,4.41c.59.42,1.69.34,1.75-.38a1.93,1.93,0,0,0,1.48,1.08,1.9,1.9,0,0,0,1,2.61,2,2,0,0,0,.63,3.31,1.55,1.55,0,1,0,2.93,1,3.27,3.27,0,0,0,1.16,1.45,1.13,1.13,0,0,0,1.6-.42,2.12,2.12,0,0,0,3.13,1,1.42,1.42,0,0,0,1.25,1.41,1.44,1.44,0,0,0,1.49-1.16l3.55,0a12.34,12.34,0,0,0,2.35-.17,6.31,6.31,0,0,0,2.7-1.25,2.27,2.27,0,0,1,.82-.5,2.16,2.16,0,0,1,1.09.17,5.74,5.74,0,0,0,5.46-1.29,3.06,3.06,0,0,1,.72-.58,2.46,2.46,0,0,1,1.05-.14,10.71,10.71,0,0,0,2.58-.37,2.75,2.75,0,0,0,1.82-1.2c.34-.67-.06-1.7-.8-1.68a1.58,1.58,0,0,1,.39-1.35,1,1,0,0,1,1.31-.06.7.7,0,0,1-.31,1.14,1.44,1.44,0,0,0,2.07-1.2,1.93,1.93,0,0,0-1.93-1.8,4.31,4.31,0,0,0,.06-2.14,1.58,1.58,0,0,0,2.15.24,2.76,2.76,0,0,0,1.76,1.27,1.64,1.64,0,0,0,1.8-1,1.17,1.17,0,0,0-1.11-1.51,1.41,1.41,0,0,0-1.25-2,2.2,2.2,0,0,0-1.33-2.32,1.14,1.14,0,0,0,1.63-.63c.45.71,1.55.54,2.28.11A1.53,1.53,0,0,0,168.17,271Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.17,271a1.36,1.36,0,0,1,0,.29,1.27,1.27,0,0,1-.28.82,2.73,2.73,0,0,1-1.18.81,2.43,2.43,0,0,1-.92.16,1.19,1.19,0,0,1-.94-.5H165a1.19,1.19,0,0,1-1.7.66l0-.09a2.25,2.25,0,0,1,1.38,2.38l-.07-.07a1.35,1.35,0,0,1,1.22.65,1.37,1.37,0,0,1,.09,1.48l-.06-.11a1.19,1.19,0,0,1,1.19.9,1.3,1.3,0,0,1-.6,1.47,1.88,1.88,0,0,1-1.71.16,3,3,0,0,1-1.39-1.18h.12a1.66,1.66,0,0,1-2.27-.25l.15-.07a4.53,4.53,0,0,1-.05,2.19l-.09-.12a2.19,2.19,0,0,1,1.32.49,1.82,1.82,0,0,1,.7,1.28,1.51,1.51,0,0,1-.7,1.32,1.36,1.36,0,0,1-1.52.08l-.23-.16.27,0c.27,0,.45-.37.4-.66a.62.62,0,0,0-.68-.49.94.94,0,0,0-.81.49,1.7,1.7,0,0,0-.18,1l-.11-.09a.92.92,0,0,1,.71.33,1.33,1.33,0,0,1,.32.7,1.37,1.37,0,0,1-.1.77,1.78,1.78,0,0,1-.48.61,3.54,3.54,0,0,1-1.36.67,10.79,10.79,0,0,1-1.5.31c-1,.21-2.16-.2-2.82.73a5.69,5.69,0,0,1-2.87,1.47,5.76,5.76,0,0,1-1.66.1,8.41,8.41,0,0,1-1.63-.35,1,1,0,0,0-.73.08,5.4,5.4,0,0,0-.67.49,6.55,6.55,0,0,1-1.51.84,9.05,9.05,0,0,1-3.47.5l-3.56,0,.13-.11a1.51,1.51,0,0,1-3-.27l.22.11a2.26,2.26,0,0,1-3.34-1.08h.26a1,1,0,0,1-.75.63,1.54,1.54,0,0,1-1-.11,3.38,3.38,0,0,1-1.26-1.54h.26a1.69,1.69,0,0,1-3.19-1.11l.09.18a2,2,0,0,1-1.29-1.54,2,2,0,0,1,.6-2l0,.25a2,2,0,0,1-1.07-2.82l.11.22a2.11,2.11,0,0,1-1.61-1.17l.28-.05a.73.73,0,0,1-.23.49,1,1,0,0,1-.46.24,1.68,1.68,0,0,1-1-.08,2.51,2.51,0,0,1-1.27-1.48,2.57,2.57,0,0,1,.1-2,2.74,2.74,0,0,1,1.47-1.37l-.09.17a1.17,1.17,0,0,1,.1-.73l.06.2a1.27,1.27,0,0,1-.56-.81l0,.07a2.24,2.24,0,0,1-.29-2.25,4.91,4.91,0,0,1,1.43-1.88l.12.26A1.52,1.52,0,0,1,122,271l.08,0a1.89,1.89,0,0,1-1.06-.74l0,0a1.14,1.14,0,0,1-.55-.93,1.23,1.23,0,0,1,.46-1l.09.27a.57.57,0,0,1-.48-.24.8.8,0,0,1-.15-.48,1.09,1.09,0,0,1,.37-.9,11,11,0,0,1,1.66-.72l0,0a7.17,7.17,0,0,1,3.6-2.55l0,.28-1.18-.74-.9-.55a8.79,8.79,0,0,1-.9-.6.84.84,0,0,1-.28-.54,1.06,1.06,0,0,1,.09-.59,2.57,2.57,0,0,1,.67-.88,5.82,5.82,0,0,1,1.8-1.13,5.22,5.22,0,0,1,1-.31,1.55,1.55,0,0,1,.57,0,.71.71,0,0,1,.52.38l-.22-.07a4.26,4.26,0,0,1,1.95-.48c.33,0,.65,0,1,0a1.66,1.66,0,0,1,1,.32l-.24.19c-.28-.57-1-.88-1.4-1.51a1.16,1.16,0,0,1-.14-1.14,1,1,0,0,1,.43-.43.69.69,0,0,1,.64,0l-.13.27a.7.7,0,0,1-.41-.43,1.07,1.07,0,0,1,0-.56,1,1,0,0,1,.29-.48,1.41,1.41,0,0,1,.45-.28,3.86,3.86,0,0,1,1-.19,1.53,1.53,0,0,1,.52,0,.64.64,0,0,1,.47.37l-.29,0a1.08,1.08,0,0,1,2-.33l-.25,0a1.3,1.3,0,0,1,1.89,0l-.2,0a1.63,1.63,0,0,1,2,.17l-.22.2-1-1.37a2,2,0,0,1-.41-.8,1,1,0,0,1,0-.48.49.49,0,0,1,.16-.25.47.47,0,0,1,.29-.09V252a1,1,0,0,1-.95-.58,1.24,1.24,0,0,1-.05-1.11,2,2,0,0,1,1.84-.94h.06l0,0c.23.28.45.54.66.81l-.2,0a1.49,1.49,0,0,1,2.41,1.46l-.25-.12a.68.68,0,0,1,.68-.23.92.92,0,0,1,.59.36,2.18,2.18,0,0,1,.32,1.21l-.25-.09a1.21,1.21,0,0,1,1.34-.19,1.2,1.2,0,0,1,.76,1.08l-.21-.12a3.84,3.84,0,0,1,2-.59l-.11.22a1.46,1.46,0,0,1,1.72-2.23l-.19.13a1.44,1.44,0,0,1,1.77-1.33l-.18.1a1.67,1.67,0,0,1,.54-.91,1.39,1.39,0,0,1,1-.36,1.08,1.08,0,0,1,.85.63,1.83,1.83,0,0,1,.08,1,8.3,8.3,0,0,1-.66,1.81c-.25.58-.49,1.15-.74,1.72l-.19-.16,2.48-1.62,1.22-.79a2.84,2.84,0,0,1,.65-.37.57.57,0,0,1,.43.06c.12.07.21.14.3.18a1.93,1.93,0,0,0,.66.05.94.94,0,0,1,.7.34,1.54,1.54,0,0,1,.14,1.45,2.61,2.61,0,0,1-.92,1.07,11.09,11.09,0,0,0-1,.85l-.07-.2,1.9.19-.13.1a2,2,0,0,1,2.51-1.6l-.14.08a1.29,1.29,0,0,1,1-.84,4.78,4.78,0,0,1,1.23-.16,3.32,3.32,0,0,1,1.21.14,1.45,1.45,0,0,1,.91.8,2.21,2.21,0,0,1-.39,2.24,6.46,6.46,0,0,1-1.75,1.36l0-.12a.8.8,0,0,0,.67.49,2,2,0,0,0,.9-.08,6.87,6.87,0,0,1,.92-.23,1.46,1.46,0,0,1,.94.18c.55.34.87.88,1.37,1.12a7.15,7.15,0,0,0,.83.21,1.11,1.11,0,0,1,.56.7c.17.53.34,1.05.5,1.56a1,1,0,0,1-.06.84,1.08,1.08,0,0,1-.69.44,1.63,1.63,0,0,1-.79,0,3.25,3.25,0,0,1-.7-.26,3.86,3.86,0,0,0-1.32-.46l0-.15a9,9,0,0,1,1.56.75,2.94,2.94,0,0,1,1.1,1.17,2.11,2.11,0,0,1,.1,1.46,1.3,1.3,0,0,1-.94.94h0a2.29,2.29,0,0,1-1.29.36l.06-.06a11.14,11.14,0,0,0,1.07,3.53l0,0a6.55,6.55,0,0,1,1.78.22,2.51,2.51,0,0,1,1.08.63,1.65,1.65,0,0,1,.38.63,1.35,1.35,0,0,1,.06.23,1.93,1.93,0,0,0-.47-.83,2.51,2.51,0,0,0-1.07-.61,7,7,0,0,0-1.77-.19h0v0a11.24,11.24,0,0,1-1.11-3.56v-.06h.06a2.15,2.15,0,0,0,1.23-.35h0a1.18,1.18,0,0,0,.85-.86,2,2,0,0,0-.11-1.38,2.73,2.73,0,0,0-1-1.1,9.52,9.52,0,0,0-1.54-.73l-.44-.17.47,0a3.72,3.72,0,0,1,1.37.47,3.48,3.48,0,0,0,.68.25,1.7,1.7,0,0,0,.71,0,.91.91,0,0,0,.59-.37.85.85,0,0,0,0-.7c-.17-.5-.33-1-.5-1.55a.94.94,0,0,0-.47-.59,7.34,7.34,0,0,1-.84-.21c-.56-.28-.89-.83-1.38-1.12a2.08,2.08,0,0,0-1.72.07,2.18,2.18,0,0,1-1,.08,1,1,0,0,1-.82-.62l0-.07.07,0a6.54,6.54,0,0,0,1.69-1.32,2,2,0,0,0,.36-2,1.29,1.29,0,0,0-.79-.69,3.25,3.25,0,0,0-1.13-.12,4.52,4.52,0,0,0-1.17.15,1.08,1.08,0,0,0-.81.69l0,.12-.12,0a1.81,1.81,0,0,0-2.2,1.42l0,.11h-.11l-1.91-.19-.24,0,.17-.17a9.6,9.6,0,0,1,1-.88,2.43,2.43,0,0,0,.84-1,1.27,1.27,0,0,0-.11-1.2.63.63,0,0,0-.52-.25,2,2,0,0,1-.74-.07c-.25-.12-.4-.29-.57-.23a3.33,3.33,0,0,0-.58.34l-1.21.8-2.48,1.62-.36.23.17-.39c.25-.57.49-1.15.74-1.73a8.19,8.19,0,0,0,.64-1.75,1.59,1.59,0,0,0-.07-.87.79.79,0,0,0-.63-.47,1.3,1.3,0,0,0-1.24,1l0,.15-.15,0a1.17,1.17,0,0,0-1.41,1.07v.2l-.19-.07a1.21,1.21,0,0,0-1.37.36,1.23,1.23,0,0,0,0,1.45l.16.21h-.27a3.59,3.59,0,0,0-1.84.55l-.23.14v-.26a1,1,0,0,0-1.62-.69l-.22.23,0-.33a1.91,1.91,0,0,0-.26-1.05c-.18-.26-.64-.36-.82-.13l-.39.54.14-.65a1.2,1.2,0,0,0-1.94-1.18l-.12.09-.09-.11-.66-.8.1,0a1.63,1.63,0,0,0-1.55.78c-.26.5.14,1.32.71,1.27V252c-.1,0-.13,0-.16.13a.78.78,0,0,0,0,.34,1.66,1.66,0,0,0,.36.68l1,1.37-.22.2a1.33,1.33,0,0,0-1.65-.15l-.11.08-.09-.1a1,1,0,0,0-1.44,0l-.16.18-.09-.21a.79.79,0,0,0-1.39.23l-.07.75-.23-.71c0-.19-.39-.24-.68-.2a3.69,3.69,0,0,0-.89.17.84.84,0,0,0-.55.55c-.07.26,0,.57.22.64l-.12.27c-.21-.12-.52.06-.65.31a.85.85,0,0,0,.12.83c.34.55,1,.84,1.42,1.54l.36.66-.59-.48c-.44-.35-1.15-.23-1.78-.22a4.14,4.14,0,0,0-1.82.44l-.15.09-.06-.16c-.09-.21-.45-.25-.76-.19a5.57,5.57,0,0,0-1,.29,5.41,5.41,0,0,0-1.7,1.08,2,2,0,0,0-.6.77.66.66,0,0,0,.12.79,8.35,8.35,0,0,0,.85.56l.9.55,1.18.74.28.17-.32.1a6.88,6.88,0,0,0-3.44,2.44l0,0,0,0a15.26,15.26,0,0,0-1.62.68.82.82,0,0,0-.26.65c0,.25.13.45.33.44l.48,0-.39.3a1,1,0,0,0-.34.78.84.84,0,0,0,.42.69h0v0a1.66,1.66,0,0,0,.9.62l0,0,0,0a1.22,1.22,0,0,0,1,.48l.46-.05-.34.31a4.56,4.56,0,0,0-1.35,1.76,2,2,0,0,0,.23,2l0,0v0a1,1,0,0,0,.42.62l.13.07-.07.13a.83.83,0,0,0-.08.53l0,.12-.12.05a2.44,2.44,0,0,0-1.31,1.22,2.29,2.29,0,0,0-.09,1.76,2.21,2.21,0,0,0,1.1,1.29,1.33,1.33,0,0,0,.81.07.53.53,0,0,0,.47-.46l0-.58.25.53a1.84,1.84,0,0,0,1.37,1l.22,0-.11.19a1.77,1.77,0,0,0,.92,2.41l.25.08-.21.17a1.76,1.76,0,0,0-.51,1.73,1.74,1.74,0,0,0,1.1,1.33l.14,0,0,.14a1.41,1.41,0,1,0,2.66.92l.1-.31.16.29a3,3,0,0,0,1.13,1.41,1,1,0,0,0,1.37-.36l.14-.4.13.41a2,2,0,0,0,2.91.94l.23-.16v.28a1.29,1.29,0,0,0,1.18,1.27,1.3,1.3,0,0,0,1.28-1.05l0-.12h.11l3.57,0a8.78,8.78,0,0,0,3.37-.48,5.94,5.94,0,0,0,1.46-.81,6.66,6.66,0,0,1,.7-.51,1.28,1.28,0,0,1,.9-.1,8.55,8.55,0,0,0,1.6.36,5.63,5.63,0,0,0,1.59-.1,5.48,5.48,0,0,0,2.75-1.4,3,3,0,0,1,.64-.52,1.76,1.76,0,0,1,.8-.18,15.13,15.13,0,0,0,1.52-.09,11.44,11.44,0,0,0,1.46-.3,3.59,3.59,0,0,0,1.29-.62,1.25,1.25,0,0,0,.5-1.18.9.9,0,0,0-.8-.85h-.1V284a1.88,1.88,0,0,1,.21-1.16,1.16,1.16,0,0,1,1-.59.81.81,0,0,1,.88.67.77.77,0,0,1-.57.9l0-.19a1.15,1.15,0,0,0,1.3-.08,1.32,1.32,0,0,0,.62-1.14,1.85,1.85,0,0,0-1.83-1.59h-.12l0-.12a4.34,4.34,0,0,0,.06-2.11l-.09-.38.25.31a1.5,1.5,0,0,0,2,.23l.07-.06.05.08a2.94,2.94,0,0,0,1.3,1.13,1.75,1.75,0,0,0,1.58-.14,1.14,1.14,0,0,0,.54-1.3,1,1,0,0,0-1-.8l-.13,0,.07-.13a1.34,1.34,0,0,0-1.19-1.93h-.07v-.08a2.14,2.14,0,0,0-1.29-2.26l0-.09a1.12,1.12,0,0,0,1.57-.6l0-.1.06.09a1.08,1.08,0,0,0,.87.46,2.34,2.34,0,0,0,.89-.14,2.72,2.72,0,0,0,1.17-.78,1.24,1.24,0,0,0,.28-.79C168.18,271.12,168.16,271,168.17,271Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.26,297c-.06-1.87-.1-3.35-.08-3.35s6.4-.92,6.55-7.31c.08-3.09-.29-9.45-.69-15.21A11.9,11.9,0,0,0,146.3,260h-.61c-6.66.31-10.11,6.14-9.62,12.78l.68,24.31,3.79,9.26c3.78,4.13,11.94-3.78,11.72-9.38Z",
    style: {
      fill: "#e6866e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.21,293.6a15.52,15.52,0,0,1-8.29-2.56s1.91,4.89,8.29,4.39Z",
    style: {
      fill: "#a3594e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.35,276.6a.91.91,0,0,1-.89.91.87.87,0,0,1-.93-.84.92.92,0,0,1,.89-.91A.88.88,0,0,1,155.35,276.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.68,273.71c-.11.12-.8-.4-1.78-.41s-1.7.47-1.81.35.07-.27.38-.49a2.46,2.46,0,0,1,1.46-.43,2.4,2.4,0,0,1,1.41.47C156.64,273.44,156.74,273.66,156.68,273.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.44,276.77a.92.92,0,0,1-.9.91.87.87,0,0,1-.93-.84.92.92,0,0,1,.89-.91A.88.88,0,0,1,146.44,276.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.06,274c-.11.12-.8-.4-1.78-.41s-1.71.48-1.81.36.06-.27.38-.5a2.52,2.52,0,0,1,1.45-.43,2.46,2.46,0,0,1,1.42.48C147,273.72,147.12,273.94,147.06,274Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.5,281.58a6.32,6.32,0,0,1,1.59-.27c.25,0,.49-.07.54-.24a1.26,1.26,0,0,0-.16-.74l-.72-1.92a32.71,32.71,0,0,1-1.61-5,33.28,33.28,0,0,1,2,4.88l.69,1.93a1.46,1.46,0,0,1,.12,1,.62.62,0,0,1-.42.36,1.77,1.77,0,0,1-.43.06A6.1,6.1,0,0,1,150.5,281.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.33,270.68c-.1.26-1.08.13-2.23.26s-2.09.43-2.24.19.1-.37.48-.62a3.83,3.83,0,0,1,3.4-.34C147.16,270.34,147.37,270.55,147.33,270.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.33,270.4c-.17.23-.85,0-1.67,0s-1.5.17-1.66-.06,0-.34.34-.56a2.29,2.29,0,0,1,1.34-.38,2.37,2.37,0,0,1,1.34.44C156.31,270.06,156.4,270.29,156.33,270.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.45,284.11a4.15,4.15,0,0,1-.49,1.07,1.36,1.36,0,0,1-1,.62,1.23,1.23,0,0,1-1.08-.52,2.08,2.08,0,0,1-.36-1.19c0-.38.15-.84.53-.9a.94.94,0,0,1,.46.08l2,.7",
    style: {
      fill: "#a3594e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.73,285.77a2.71,2.71,0,0,1-1.06-.08,1.5,1.5,0,0,1-.83-.68,1.64,1.64,0,0,1-.09-1.29,1.51,1.51,0,0,1,.16-.31c.07-.08.06-.08.15-.07l.32.11.33.11c.43.16.82.29,1.15.39a3.46,3.46,0,0,0,1.09.27,3.68,3.68,0,0,0-1-.5l-1.13-.46-.32-.13a3.85,3.85,0,0,0-.37-.13.53.53,0,0,0-.3,0,.46.46,0,0,0-.2.19,1.41,1.41,0,0,0-.21.38,1.84,1.84,0,0,0,.14,1.58,1.66,1.66,0,0,0,1,.76,1.54,1.54,0,0,0,.86,0C150.65,285.86,150.74,285.79,150.73,285.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.72,265.77a6.17,6.17,0,0,0-.14-1,3,3,0,0,0-.85-1.2,9.88,9.88,0,0,0-4-2.83c-.94-.24-1.91-.15-2.85-.38-.58-.15-1.14-.41-1.71-.62a13.92,13.92,0,0,0-7.24-.39,11.31,11.31,0,0,0-3.89,1.26,13.75,13.75,0,0,0-3.49,3.17,21.41,21.41,0,0,0-3.88,6.26,10.33,10.33,0,0,0-.56,5.9c.46,2,1.85,3.74,3.56,4l.59-.81.95-1.2c-.16.48,0,.45.4.67a.8.8,0,0,0,1.12-.41c.35.38,1-.1.87-.63.4.18.86-.37.7-.84.45.13.66-.61.85-1.1a6.94,6.94,0,0,1,.39-.77,5,5,0,0,0,.5-2.72,4.81,4.81,0,0,0,.62-2.67c0-.6,0-1.19.07-1.78l.29-.43a1,1,0,0,0,.71.86,2,2,0,0,0,1.06-.11l1-.29.66.14a2.69,2.69,0,0,0,.34,1.69,1.64,1.64,0,0,0,.68.9.49.49,0,0,0,.65-.58.56.56,0,0,0,.84-.21,1.85,1.85,0,0,0,.15-1.1,4.67,4.67,0,0,0-1.05-2.47l2,1.55a.79.79,0,0,0,.47.24.49.49,0,0,0,.56.49,1.27,1.27,0,0,0,.63-.51c.41-.5.81-1.33.37-1.83a.38.38,0,0,0,.13-.59l2.2,1.4c-.22-.1-.42.24-.35.5a1.07,1.07,0,0,0,.48.58,1.63,1.63,0,0,0-.16,1c-.4-.3-.91.36-.74.89a1.16,1.16,0,0,0,1.16.76.81.81,0,0,0,.87-.68c.46.06.85-.6.65-1.1.34.2.58-.42.57-.86a6.77,6.77,0,0,0-.52-2.28.11.11,0,0,0,.17,0,.12.12,0,0,0,0-.09l1.31,2.57a6.83,6.83,0,0,1,.84,2.31c0,.34.11.81.39.81a.44.44,0,0,0,.22-.07,4.27,4.27,0,0,0,1.69-2.33,3.14,3.14,0,0,0,.2-1A12.31,12.31,0,0,0,159.72,265.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.62,264.87a.92.92,0,0,0,.22-.53.69.69,0,0,0-.23-.57.73.73,0,0,0-.77-.13l-.16.07.06-.17a.74.74,0,0,0-1.26-.73l-.14-.11a.37.37,0,0,0,0-.11.43.43,0,0,0-.09-.36.54.54,0,0,0-.34-.18,1,1,0,0,0-.39.05.92.92,0,0,1-.44.14c-.19,0-.28-.15-.38-.2a2,2,0,0,0-.32-.17,1.7,1.7,0,0,0-.65-.09,1.76,1.76,0,0,0-.9.3c-.18.13-.27.23-.28.22a1,1,0,0,1,.24-.27,1.58,1.58,0,0,1,.93-.37,1.71,1.71,0,0,1,.7.07,2.37,2.37,0,0,1,.36.17c.12.08.22.18.31.18a1.34,1.34,0,0,0,.37-.14,1,1,0,0,1,.47-.06.65.65,0,0,1,.45.24.55.55,0,0,1,.13.51.51.51,0,0,1-.07.17l-.14-.11a.94.94,0,0,1,1.21-.14.92.92,0,0,1,.32,1l-.1-.09a.9.9,0,0,1,.92.17.81.81,0,0,1,.23.68.82.82,0,0,1-.19.42C150.67,264.85,150.62,264.88,150.62,264.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.11,265.63a1.11,1.11,0,0,0,.29-.52.9.9,0,0,0-.1-.66.88.88,0,0,0-.73-.44h-.13l.08-.1a1.12,1.12,0,0,0,.22-1,.62.62,0,0,0-.39-.37.48.48,0,0,0-.52.12l-.45.57.31-.66a.9.9,0,0,0,0-.77.81.81,0,0,0-.65-.47.84.84,0,0,0-.58.11l-.2.11.07-.22c.09-.31-.25-.63-.56-.65a1.52,1.52,0,0,0-.91.31l-.16.11,0-.19a.67.67,0,0,0-.27-.61,1.19,1.19,0,0,0-.63-.21,3,3,0,0,0-1.12.12,4.59,4.59,0,0,0-.92.42s.06-.07.21-.17a2.82,2.82,0,0,1,.68-.34,3.11,3.11,0,0,1,1.17-.17,1.38,1.38,0,0,1,.7.23.82.82,0,0,1,.34.76l-.13-.08a1.65,1.65,0,0,1,1-.35.82.82,0,0,1,.54.26.66.66,0,0,1,.17.62l-.13-.11a1,1,0,0,1,.7-.13,1,1,0,0,1,.78.57,1.06,1.06,0,0,1,0,.92l-.14-.09a.63.63,0,0,1,.7-.16.74.74,0,0,1,.49.47,1.27,1.27,0,0,1-.26,1.12l0-.11a1,1,0,0,1,.82.53.92.92,0,0,1,.07.73,1,1,0,0,1-.23.41C155.16,265.61,155.11,265.64,155.11,265.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.65,265.64a.67.67,0,0,0-.27-.46.87.87,0,0,0-.61-.17,2.57,2.57,0,0,0-.82.28l-.09,0v-.11a.76.76,0,0,0-.68-.68,2.17,2.17,0,0,0-1.24.3l-.53.26.44-.39a.64.64,0,0,0-.12-.9,1.42,1.42,0,0,0-1.12-.17h-.06l-.34.07.27-.22a.67.67,0,0,0-.16-1.06,1,1,0,0,0-1.13.21l-.33.31.2-.41a1.54,1.54,0,0,0-.13-1.55,1.43,1.43,0,0,0-1.1-.57,1.47,1.47,0,0,0-.82.18c-.18.09-.26.16-.27.15l0-.06a.84.84,0,0,1,.19-.14,1.49,1.49,0,0,1,.85-.23,1.52,1.52,0,0,1,1.21.59,1.67,1.67,0,0,1,.17,1.7l-.13-.09a1.18,1.18,0,0,1,1.32-.24.81.81,0,0,1,.43.61.75.75,0,0,1-.24.74l-.07-.16h.06a1.56,1.56,0,0,1,1.26.2.93.93,0,0,1,.31.56.67.67,0,0,1-.18.6l-.1-.14a2.36,2.36,0,0,1,1.33-.3.9.9,0,0,1,.79.84l-.09-.06a2.53,2.53,0,0,1,.87-.26.92.92,0,0,1,.65.21.64.64,0,0,1,.23.37A.29.29,0,0,1,164.65,265.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.91,257.05s-.07.06-.23.1a3.09,3.09,0,0,1-.68.1,2.06,2.06,0,0,0-1,.23.66.66,0,0,0-.31.46.48.48,0,0,0,.23.51l-.11.09c-.06-.22-.35-.34-.62-.47a2.91,2.91,0,0,0-.86-.29,1.08,1.08,0,0,0-.83.21.71.71,0,0,0-.31.68l0,.22-.18-.13a1.92,1.92,0,0,0-1.2-.38,2.18,2.18,0,0,0-1,.23,2.86,2.86,0,0,0-.72.55,1,1,0,0,1,.14-.21,1.8,1.8,0,0,1,.53-.43,2.16,2.16,0,0,1,1-.28,2.12,2.12,0,0,1,1.3.38l-.13.09a.86.86,0,0,1,.36-.86,1.26,1.26,0,0,1,1-.24,2.87,2.87,0,0,1,.91.3,3.23,3.23,0,0,1,.41.22.62.62,0,0,1,.3.37l0,.17-.16-.07a.62.62,0,0,1-.31-.68.77.77,0,0,1,.39-.56,2.16,2.16,0,0,1,1.05-.21,3.65,3.65,0,0,0,.67,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.83,254.4a2.61,2.61,0,0,0-.46.11,1.17,1.17,0,0,0-.42.32,1,1,0,0,0-.23.62v.09l-.09,0a.58.58,0,0,0-.62.42,1.84,1.84,0,0,0,.05,1l.09.34-.24-.26,0,0a.74.74,0,0,0-.63-.2.82.82,0,0,0-.56.3,1.35,1.35,0,0,0-.27,1.08,2.46,2.46,0,0,0,.27.74,1.13,1.13,0,0,1,.13.27s-.08-.07-.19-.23a2,2,0,0,1-.33-.76,1.43,1.43,0,0,1,.26-1.21,1,1,0,0,1,1.45-.12l.05.06-.16.07a1.89,1.89,0,0,1,0-1.08.75.75,0,0,1,.82-.51l-.1.08a1.1,1.1,0,0,1,.29-.7,1.12,1.12,0,0,1,.48-.32.94.94,0,0,1,.37-.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.55,260.45a.49.49,0,0,1-.24,0,1.57,1.57,0,0,1-.57-.33,1.66,1.66,0,0,1-.48-.86c0-.18,0-.37-.16-.47s-.33-.18-.48-.37a.9.9,0,0,1,.12-1.22v.13a2.72,2.72,0,0,1-.85-1,1.43,1.43,0,0,1-.17-.47,4,4,0,0,1,.26.43,3,3,0,0,0,.85.9l.09.06-.08.07a.73.73,0,0,0-.09,1c.1.14.3.19.47.35a1,1,0,0,1,.2.57,1.48,1.48,0,0,0,.4.8A2.24,2.24,0,0,0,142.55,260.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.4,262.21l-.14,0a2,2,0,0,1-.43,0,2.41,2.41,0,0,1-1.37-.63h.11a1.54,1.54,0,0,1-1,.64,1.68,1.68,0,0,1-.67,0,1,1,0,0,1-.6-.4,1.18,1.18,0,0,1-.1-.25.29.29,0,0,0-.12-.15,1.15,1.15,0,0,0-.43-.15,1.18,1.18,0,0,1-.47-.15.51.51,0,0,1-.29-.41l.12.07a1.59,1.59,0,0,1-1.08.11,1.66,1.66,0,0,1-.75-.38,1.33,1.33,0,0,1-.33-.43c-.05-.12-.07-.18-.06-.19a2,2,0,0,0,.45.55,1.71,1.71,0,0,0,.72.32,1.41,1.41,0,0,0,1-.13l.12-.06v.13a.38.38,0,0,0,.21.28,1.72,1.72,0,0,0,.42.12,1.24,1.24,0,0,1,.5.17.6.6,0,0,1,.19.23,1.67,1.67,0,0,0,.08.24.82.82,0,0,0,.49.3,1.36,1.36,0,0,0,.6,0,1.39,1.39,0,0,0,.9-.56l.05-.07.06.06a2.39,2.39,0,0,0,1.28.65C140.19,262.21,140.4,262.19,140.4,262.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.86,268.87l0-.06a1.27,1.27,0,0,1,0-.18,2,2,0,0,1,0-.72,4.32,4.32,0,0,1,.39-1,4.22,4.22,0,0,1,.35-.6,1,1,0,0,1,.29-.26.44.44,0,0,1,.43,0l-.1.08a1.18,1.18,0,0,1,1.83-1.19l-.13.08a.8.8,0,0,1,1-.85.8.8,0,0,1,.37.23l-.15.08a.5.5,0,0,1,.15-.44.78.78,0,0,1,.38-.2,1.65,1.65,0,0,1,.78.13l-.11,0a1.3,1.3,0,0,1,.73-.6,1.73,1.73,0,0,1,.87-.07,4.39,4.39,0,0,1,1.39.55l-.09.09a.34.34,0,0,1,0-.31.54.54,0,0,1,.21-.19.88.88,0,0,1,.47-.11,2.59,2.59,0,0,1,.72.15,2.82,2.82,0,0,1,.42.2l.13.1s-.19-.11-.57-.23a2.68,2.68,0,0,0-.71-.12.86.86,0,0,0-.4.11c-.13.07-.24.21-.16.34l.11.18-.2-.1a4.75,4.75,0,0,0-1.36-.51,1.55,1.55,0,0,0-.79.08,1.07,1.07,0,0,0-.62.52l0,.07-.07,0a1.4,1.4,0,0,0-.69-.12c-.21,0-.42.23-.39.43l.06.31-.21-.24a.79.79,0,0,0-.29-.18.6.6,0,0,0-.58.12.65.65,0,0,0-.22.54l0,.19-.16-.11a1,1,0,0,0-1.58,1l0,.15-.13-.06c-.2-.1-.42.08-.55.25a3.71,3.71,0,0,0-.35.56,4.31,4.31,0,0,0-.41,1A2.44,2.44,0,0,0,126.86,268.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.3,274s0,0-.1-.1a3.58,3.58,0,0,1-.24-.34,1.28,1.28,0,0,1-.2-.64,1,1,0,0,1,.1-.42.67.67,0,0,1,.37-.33l0,.1a.83.83,0,0,1,.77-1.35l-.07.13a.67.67,0,0,1,0-.79,1,1,0,0,1,.73-.42c.14,0,.28,0,.39,0a.35.35,0,0,0,.23-.24,1.86,1.86,0,0,1,.2-.4.84.84,0,0,1,.4-.27,5.28,5.28,0,0,1,.94-.1,1,1,0,0,0,.75-.29,3.82,3.82,0,0,0,.21-.36,1,1,0,0,1,.34-.31.93.93,0,0,1,.83,0l-.09.12a.72.72,0,0,1,0-.83,1,1,0,0,1,.64-.39,3.13,3.13,0,0,1,1.17.05,4,4,0,0,1,.72.22l.24.12a9,9,0,0,0-1-.25,3.26,3.26,0,0,0-1.13,0,.9.9,0,0,0-.55.34.57.57,0,0,0,0,.65l.21.26-.3-.14a.76.76,0,0,0-.69,0,.65.65,0,0,0-.27.25,2.75,2.75,0,0,1-.23.38.84.84,0,0,1-.4.27,2.49,2.49,0,0,1-.46.09,3.85,3.85,0,0,0-.91.1.51.51,0,0,0-.31.2,1.5,1.5,0,0,0-.17.36.54.54,0,0,1-.35.34,3.66,3.66,0,0,1-.42,0,.8.8,0,0,0-.61.33.52.52,0,0,0,0,.6l.16.17-.23,0a.7.7,0,0,0-.73.37.72.72,0,0,0,.08.74l0,.07-.08,0a.68.68,0,0,0-.41.63,1.25,1.25,0,0,0,.16.61C128.19,273.82,128.31,274,128.3,274Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.74,283.63a.56.56,0,0,1-.17,0,1.35,1.35,0,0,1-.44-.29,1.26,1.26,0,0,1-.36-.72,1.41,1.41,0,0,1,.28-1v.1a2.53,2.53,0,0,1-.54-.84,1.14,1.14,0,0,1,0-.58.73.73,0,0,1,.39-.47v.16a1,1,0,0,1-.52-.89,1.23,1.23,0,0,1,.13-.6.92.92,0,0,1,.43-.4c.17-.09.24-.18.23-.35a1.36,1.36,0,0,1,.07-.53,1.82,1.82,0,0,1,.6-.77l.63-.53a3,3,0,0,1,1-.61,1.19,1.19,0,0,1,.33-.05h.11a4.26,4.26,0,0,0-.42.11,3.26,3.26,0,0,0-1,.63l-.61.55a1.65,1.65,0,0,0-.54.71,1.24,1.24,0,0,0-.06.48.5.5,0,0,1-.08.3.72.72,0,0,1-.23.2.85.85,0,0,0-.47.84.87.87,0,0,0,.42.74l.16.08-.16.08a.71.71,0,0,0-.29.84,2.45,2.45,0,0,0,.49.79l0,.05,0,0a1.23,1.23,0,0,0-.28.91,1.2,1.2,0,0,0,.31.68A1.86,1.86,0,0,0,127.74,283.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.64,268a1.32,1.32,0,0,1-.54-.17,1.37,1.37,0,0,1-.51-.37,1,1,0,0,1-.24-.76.7.7,0,0,1,.06-.19l0,.12A.84.84,0,0,1,141,266a.74.74,0,0,1,.06-.58c.17-.3.4-.35.4-.33a1.29,1.29,0,0,0-.29.38.68.68,0,0,0,0,.49.73.73,0,0,0,.4.43l.08,0,0,.09a.33.33,0,0,0,0,.14.84.84,0,0,0,.19.63,1.59,1.59,0,0,0,.44.36C142.45,267.84,142.66,267.92,142.64,268Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.61,265.68a1,1,0,0,0,.07-.66.74.74,0,0,0-.46-.52.8.8,0,0,0-.84.21l-.1.11-.05-.15a1.44,1.44,0,0,0-.24-.5.65.65,0,0,0-.47-.28c-.29,0-.59.27-.49.5l-.16.05a1.36,1.36,0,0,0-.57-.84,1.29,1.29,0,0,0-.78-.23,2.2,2.2,0,0,0-.74.2.57.57,0,0,1,.17-.14,1.48,1.48,0,0,1,.56-.17,1.4,1.4,0,0,1,.87.21,1.49,1.49,0,0,1,.65.94l-.16,0a.5.5,0,0,1,.13-.53.7.7,0,0,1,.52-.21.78.78,0,0,1,.6.35,1.6,1.6,0,0,1,.28.57l-.15,0a.94.94,0,0,1,1-.22.83.83,0,0,1,.52.63.78.78,0,0,1-.06.53C146.67,265.64,146.62,265.69,146.61,265.68Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.58,277.5c-.11-.05-4.38-1.35-4.29,3s4.46,3.38,4.46,3.25S136.58,277.5,136.58,277.5Z",
    style: {
      fill: "#e6866e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.39,282.14s-.08.06-.21.12a.77.77,0,0,1-.57,0,1.89,1.89,0,0,1-.9-1.67,2.6,2.6,0,0,1,.19-1.1.87.87,0,0,1,.56-.59.38.38,0,0,1,.45.2c.07.12,0,.21.06.21s.09-.07.06-.25a.5.5,0,0,0-.18-.27.55.55,0,0,0-.42-.1,1.07,1.07,0,0,0-.79.69,2.69,2.69,0,0,0-.24,1.22,2,2,0,0,0,1.15,1.87.86.86,0,0,0,.7-.13C135.38,282.25,135.4,282.15,135.39,282.14Z",
    style: {
      fill: "#a3594e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "119.77 305.14 124.69 317.24 120.04 349.84 117.83 365.74 109.11 365.74 110.28 347.81 113.09 323.47 119.77 305.14",
    style: {
      fill: "#e6866e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.14 309.48 165.56 317.24 168.9 349.04 171.98 365.74 180.79 365.74 178.65 347.01 177.16 323.47 171.14 309.48",
    style: {
      fill: "#e6866e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.28,332s1.59-10.33,2.63-14,3.37-11.59,6.15-14.14,4.61-2.3,9.59-3.91c3.74-1.21,6.77-2.3,6.77-2.3l1.15-1.55c3.13,8.39,13.72,6.41,15.74,0l.93,1.48s15.65,5.17,18.16,9,8.25,25.73,8.25,25.73l-14.4,1,.28-7.44s-2,9.06-1.3,16.18c.6,6.28,2,23.74,2,23.74l-42.62-.14s1.21-21.46,1.37-25.54c.11-3-.79-14.88-.79-14.88l-.93,8.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.12,302.35a7.5,7.5,0,0,1-1.14.54l-3.14,1.42c-1.31.61-2.92,1.3-4.59,2.19a12.55,12.55,0,0,0-4.5,4.06,13.72,13.72,0,0,0-1.92,5.79,25.73,25.73,0,0,0,.12,5c.13,1.36.24,2.51.33,3.42a4.91,4.91,0,0,1,0,1.27,7.33,7.33,0,0,1-.24-1.24c-.13-.8-.31-2-.49-3.41a23.64,23.64,0,0,1-.24-5.15,13.81,13.81,0,0,1,2-6,12.64,12.64,0,0,1,4.71-4.2c1.74-.89,3.33-1.53,4.68-2.11s2.44-1,3.21-1.27A4.58,4.58,0,0,1,139.12,302.35Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.53,325.78a5.92,5.92,0,0,1,0-1.32c0-.84.13-2.06.28-3.55a29.24,29.24,0,0,0,.13-5.23,11.72,11.72,0,0,0-1.94-5.94,12.87,12.87,0,0,0-5-3.85c-1.79-.83-3.45-1.51-4.84-2.08l-3.3-1.33a6.82,6.82,0,0,1-1.2-.5,5.32,5.32,0,0,1,1.27.31c.81.25,2,.65,3.37,1.17s3.08,1.18,4.91,2a12.84,12.84,0,0,1,5.17,4,11.83,11.83,0,0,1,2,6.2,26.53,26.53,0,0,1-.25,5.31c-.19,1.49-.35,2.69-.44,3.53A7.2,7.2,0,0,1,165.53,325.78Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.24,297.51a9.59,9.59,0,0,1-12.64,5.63,8.4,8.4,0,0,1-5.12-5.32l1.09-1.77a8,8,0,0,0,8.1,5.56c6.06-.25,7.44-5.67,7.64-5.56l.93,1.48",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.21,299a10.61,10.61,0,0,1-1.63.59L130.07,301,127,302c-1.12.35-2.32.7-3.53,1.2a11.24,11.24,0,0,0-3.43,2.12,11.09,11.09,0,0,0-2.42,3.58c-.61,1.37-1.06,2.78-1.51,4.14s-.85,2.69-1.22,4c-.74,2.53-1.36,4.82-1.87,6.75s-.88,3.42-1.19,4.58a10.46,10.46,0,0,1-.47,1.67,1.53,1.53,0,0,1,0-.45c.05-.29.13-.72.24-1.26.22-1.1.56-2.68,1-4.63s1-4.25,1.77-6.79c.36-1.28.75-2.61,1.19-4a38.39,38.39,0,0,1,1.53-4.21,10.24,10.24,0,0,1,6.14-5.92,35.32,35.32,0,0,1,3.58-1.17l3.14-.9,4.56-1.27A11.91,11.91,0,0,1,136.21,299Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.29,329.46a8.93,8.93,0,0,1-.66-1.55c-.42-1.11-1-2.56-1.63-4.32-1.36-3.63-3.13-8.74-5.21-14.27a8,8,0,0,0-1.06-1.84,8.37,8.37,0,0,0-1.52-1.39,31.66,31.66,0,0,0-3.44-2c-2.26-1.2-4.37-2.15-6.15-2.93l-4.25-1.78a9.55,9.55,0,0,1-1.54-.71,10.47,10.47,0,0,1,1.61.52c1,.36,2.51.91,4.32,1.64s3.94,1.65,6.24,2.83a30.16,30.16,0,0,1,3.51,2.06,8.4,8.4,0,0,1,1.63,1.48,8.26,8.26,0,0,1,1.13,1.95c2.1,5.59,3.8,10.67,5.08,14.36l1.47,4.37A11.88,11.88,0,0,1,178.29,329.46Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.71,330.8h-2.12v2.74h-3.94V330.8H138.1v-2.63l6.41-8.92h4.18l-5.81,8.35h2.89v-2.43h3.82v2.43h2.12Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "110.28 331.94 110.74 329.09 123.58 330.54 123.25 333.51 110.28 331.94",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.25 333.22 165.56 330.89 178.93 329.57 179.66 332.26 165.25 333.22",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.36,
    y: 313.54,
    width: 4.69,
    height: 3.11,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.22,317.64a11.77,11.77,0,0,1-4.92,0,11.77,11.77,0,0,1,4.92,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.91,315.57a2,2,0,1,1-2-2A2,2,0,0,1,132.91,315.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.21,365.74c0,.14-18.48.26-41.26.26s-41.26-.12-41.26-.26,18.47-.26,41.26-.26S186.21,365.59,186.21,365.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M175.1,375.26c0,1.86-15.08,3.38-33.68,3.38s-33.67-1.52-33.67-3.38,15.07-3.38,33.67-3.38S175.1,373.39,175.1,375.26Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoccer);
export default __webpack_public_path__ + "static/media/Soccer.f23e2626a57304d6dbfb90f498b20c61.svg";
export { ForwardRef as ReactComponent };